function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-g3-1{fill:url(#linear-gradient);}.cls-g3-2{fill:#8d6004;opacity:0.3;}.cls-g3-3{fill:url(#linear-gradient-2);}.cls-g3-4{fill:#fff;opacity:0.23;}.cls-g3-5{fill:#ffe682;}.cls-g3-6{fill:url(#linear-gradient-3);}.cls-g3-7{fill:url(#linear-gradient-4);}.cls-g3-8{fill:url(#linear-gradient-5);}.cls-g3-9{fill:url(#linear-gradient-6);}.cls-g3-10{fill:url(#linear-gradient-7);}.cls-g3-11{fill:url(#linear-gradient-8);}.cls-g3-12{fill:url(#linear-gradient-9);}.cls-g3-13{fill:url(#linear-gradient-10);}.cls-g3-14{fill:url(#linear-gradient-11);}.cls-g3-15{fill:url(#linear-gradient-12);}.cls-g3-16{fill:url(#linear-gradient-13);}.cls-g3-17{fill:url(#linear-gradient-14);}.cls-g3-18{fill:url(#linear-gradient-15);}.cls-g3-19{fill:url(#linear-gradient-16);}.cls-g3-20{fill:url(#linear-gradient-17);}.cls-g3-21{fill:url(#linear-gradient-18);}.cls-g3-22{fill:url(#linear-gradient-19);}.cls-g3-23{fill:url(#linear-gradient-20);}.cls-g3-24{fill:url(#linear-gradient-21);}.cls-g3-25{fill:url(#linear-gradient-22);}.cls-g3-26{fill:url(#linear-gradient-23);}.cls-g3-27{fill:url(#linear-gradient-24);}.cls-g3-28{fill:url(#linear-gradient-25);}.cls-g3-29{fill:url(#linear-gradient-26);}.cls-g3-30{fill:url(#linear-gradient-27);}.cls-g3-31{fill:url(#linear-gradient-28);}.cls-g3-32{fill:url(#linear-gradient-29);}.cls-g3-33{fill:url(#linear-gradient-30);}.cls-g3-34{fill:url(#linear-gradient-31);}.cls-g3-35{fill:url(#linear-gradient-32);}.cls-g3-36{fill:url(#linear-gradient-33);}.cls-g3-37{fill:url(#linear-gradient-34);}.cls-g3-38{fill:url(#linear-gradient-35);}.cls-g3-39{fill:url(#linear-gradient-36);}.cls-g3-40{fill:url(#linear-gradient-37);}.cls-g3-41{fill:url(#linear-gradient-38);}.cls-g3-42{fill:url(#linear-gradient-39);}.cls-g3-43{fill:url(#linear-gradient-40);}.cls-g3-44{fill:url(#linear-gradient-41);}.cls-g3-45{fill:url(#linear-gradient-42);}.cls-g3-46{fill:url(#linear-gradient-43);}.cls-g3-47{fill:url(#linear-gradient-44);}.cls-g3-48{fill:url(#linear-gradient-45);}.cls-g3-49{fill:url(#linear-gradient-46);}.cls-g3-50{fill:url(#linear-gradient-47);}.cls-g3-51{fill:url(#linear-gradient-48);}.cls-g3-52{fill:url(#linear-gradient-49);}.cls-g3-53{fill:url(#linear-gradient-50);}.cls-g3-54{fill:url(#linear-gradient-51);}.cls-g3-55{fill:url(#linear-gradient-52);}.cls-g3-56{fill:url(#linear-gradient-53);}.cls-g3-57{fill:url(#linear-gradient-54);}.cls-g3-58{fill:url(#linear-gradient-55);}.cls-g3-59{fill:url(#linear-gradient-56);}.cls-g3-60{fill:url(#linear-gradient-57);}.cls-g3-61{fill:url(#linear-gradient-58);}.cls-g3-62{fill:url(#linear-gradient-59);}.cls-g3-63{fill:url(#linear-gradient-60);}.cls-g3-64{fill:url(#linear-gradient-61);}.cls-g3-65{fill:url(#linear-gradient-62);}.cls-g3-66{fill:url(#linear-gradient-63);}.cls-g3-67{fill:url(#linear-gradient-64);}.cls-g3-68{fill:url(#linear-gradient-65);}.cls-g3-69{fill:url(#linear-gradient-66);}.cls-g3-70{fill:url(#linear-gradient-67);}.cls-g3-71{fill:url(#linear-gradient-68);}.cls-g3-72{fill:url(#linear-gradient-69);}.cls-g3-73{fill:url(#linear-gradient-70);}.cls-g3-74{fill:url(#linear-gradient-71);}.cls-g3-75{fill:url(#linear-gradient-72);}.cls-g3-76{fill:url(#linear-gradient-73);}.cls-g3-77{fill:url(#linear-gradient-74);}.cls-g3-78{fill:url(#linear-gradient-75);}.cls-g3-79{fill:url(#linear-gradient-76);}.cls-g3-80{fill:url(#linear-gradient-77);}.cls-g3-81{fill:url(#linear-gradient-78);}.cls-g3-82{fill:url(#linear-gradient-79);}.cls-g3-83{fill:url(#linear-gradient-80);}.cls-g3-84{fill:url(#linear-gradient-81);}.cls-g3-85{fill:url(#linear-gradient-82);}.cls-g3-86{fill:url(#linear-gradient-83);}.cls-g3-87{fill:url(#linear-gradient-84);}.cls-g3-88{fill:url(#linear-gradient-85);}.cls-g3-89{fill:url(#linear-gradient-86);}.cls-g3-90{fill:url(#linear-gradient-87);}.cls-g3-91{fill:url(#linear-gradient-88);}.cls-g3-92{fill:url(#linear-gradient-89);}.cls-g3-93{fill:url(#linear-gradient-90);}.cls-g3-94{fill:url(#linear-gradient-91);}.cls-g3-95{fill:url(#linear-gradient-92);}.cls-g3-96{fill:url(#linear-gradient-93);}.cls-g3-97{fill:url(#linear-gradient-94);}.cls-g3-98{fill:url(#linear-gradient-95);}.cls-g3-99{fill:url(#linear-gradient-96);}.cls-g3-100{fill:url(#linear-gradient-97);}.cls-g3-101{fill:url(#linear-gradient-98);}.cls-g3-102{fill:url(#linear-gradient-99);}.cls-g3-103{fill:url(#linear-gradient-100);}.cls-g3-104{fill:url(#linear-gradient-101);}.cls-g3-105{fill:url(#linear-gradient-102);}.cls-g3-106{fill:url(#linear-gradient-103);}.cls-g3-107{fill:url(#linear-gradient-104);}.cls-g3-108{fill:url(#linear-gradient-105);}.cls-g3-109{fill:url(#linear-gradient-106);}.cls-g3-110{fill:url(#linear-gradient-107);}.cls-g3-111{fill:url(#linear-gradient-108);}.cls-g3-112{fill:url(#linear-gradient-109);}.cls-g3-113{fill:url(#linear-gradient-110);}.cls-g3-114{fill:url(#linear-gradient-111);}.cls-g3-115{fill:url(#linear-gradient-112);}.cls-g3-116{fill:url(#linear-gradient-113);}.cls-g3-117{fill:url(#linear-gradient-114);}.cls-g3-118{fill:url(#linear-gradient-115);}.cls-g3-119{fill:url(#linear-gradient-116);}.cls-g3-120{fill:url(#linear-gradient-117);}.cls-g3-121{fill:url(#linear-gradient-118);}.cls-g3-122{fill:url(#linear-gradient-119);}.cls-g3-123{fill:url(#linear-gradient-120);}.cls-g3-124{fill:url(#linear-gradient-121);}.cls-g3-125{fill:url(#linear-gradient-122);}.cls-g3-126{fill:url(#linear-gradient-123);}.cls-g3-127{fill:url(#linear-gradient-124);}.cls-g3-128{fill:url(#linear-gradient-125);}.cls-g3-129{fill:url(#linear-gradient-126);}.cls-g3-130{fill:url(#linear-gradient-127);}.cls-g3-131{fill:url(#linear-gradient-128);}.cls-g3-132{fill:url(#linear-gradient-129);}.cls-g3-133{fill:url(#linear-gradient-130);}.cls-g3-134{fill:url(#linear-gradient-131);}.cls-g3-135{fill:url(#linear-gradient-132);}.cls-g3-136{fill:url(#linear-gradient-133);}.cls-g3-137{fill:url(#linear-gradient-134);}.cls-g3-138{fill:url(#linear-gradient-135);}.cls-g3-139{fill:url(#linear-gradient-136);}.cls-g3-140{fill:url(#linear-gradient-137);}.cls-g3-141{fill:url(#linear-gradient-138);}.cls-g3-142{fill:url(#linear-gradient-139);}.cls-g3-143{fill:url(#linear-gradient-140);}.cls-g3-144{fill:url(#linear-gradient-141);}.cls-g3-145{fill:url(#linear-gradient-142);}.cls-g3-146{fill:url(#linear-gradient-143);}.cls-g3-147{fill:url(#linear-gradient-144);}.cls-g3-148{fill:url(#linear-gradient-145);}.cls-g3-149{fill:url(#linear-gradient-146);}.cls-g3-150{fill:url(#linear-gradient-147);}.cls-g3-151{fill:url(#linear-gradient-148);}.cls-g3-152{fill:url(#linear-gradient-149);}.cls-g3-153{fill:url(#linear-gradient-150);}.cls-g3-154{fill:url(#linear-gradient-151);}.cls-g3-155{fill:url(#linear-gradient-152);}.cls-g3-156{fill:url(#linear-gradient-153);}.cls-g3-157{fill:url(#linear-gradient-154);}.cls-g3-158{fill:url(#linear-gradient-155);}.cls-g3-159{fill:url(#linear-gradient-156);}.cls-g3-160{fill:url(#linear-gradient-157);}.cls-g3-161{fill:url(#linear-gradient-158);}.cls-g3-162{fill:url(#linear-gradient-159);}.cls-g3-163{fill:url(#linear-gradient-160);}.cls-g3-164{fill:url(#linear-gradient-161);}.cls-g3-165{fill:url(#linear-gradient-162);}.cls-g3-166{fill:url(#linear-gradient-163);}.cls-g3-167{fill:url(#linear-gradient-164);}.cls-g3-168{fill:url(#linear-gradient-165);}.cls-g3-169{fill:url(#linear-gradient-166);}.cls-g3-170{fill:url(#linear-gradient-167);}.cls-g3-171{fill:url(#linear-gradient-168);}.cls-g3-172{fill:url(#linear-gradient-169);}.cls-g3-173{fill:url(#linear-gradient-170);}.cls-g3-174{fill:url(#linear-gradient-171);}.cls-g3-175{fill:url(#linear-gradient-172);}.cls-g3-176{fill:url(#linear-gradient-173);}.cls-g3-177{fill:url(#linear-gradient-174);}.cls-g3-178{fill:url(#linear-gradient-175);}.cls-g3-179{fill:url(#linear-gradient-176);}.cls-g3-180{fill:url(#linear-gradient-177);}.cls-g3-181{fill:url(#linear-gradient-178);}.cls-g3-182{fill:url(#linear-gradient-179);}.cls-g3-183{fill:url(#linear-gradient-180);}.cls-g3-184{fill:url(#linear-gradient-181);}.cls-g3-185{fill:url(#linear-gradient-182);}.cls-g3-186{fill:url(#linear-gradient-183);}.cls-g3-187{fill:url(#linear-gradient-184);}.cls-g3-188{fill:url(#linear-gradient-185);}.cls-g3-189{fill:url(#linear-gradient-186);}.cls-g3-190{fill:url(#linear-gradient-187);}.cls-g3-191{fill:url(#linear-gradient-188);}.cls-g3-192{fill:url(#linear-gradient-189);}.cls-g3-193{fill:url(#linear-gradient-190);}.cls-g3-194{fill:url(#linear-gradient-191);}.cls-g3-195{fill:url(#linear-gradient-192);}.cls-g3-196{fill:url(#linear-gradient-193);}.cls-g3-197{fill:url(#linear-gradient-194);}.cls-g3-198{fill:url(#linear-gradient-195);}.cls-g3-199{fill:url(#linear-gradient-196);}.cls-g3-200{fill:url(#linear-gradient-197);}.cls-g3-201{fill:url(#linear-gradient-198);}.cls-g3-202{fill:url(#linear-gradient-199);}.cls-g3-203{fill:url(#linear-gradient-200);}.cls-g3-204{fill:url(#linear-gradient-201);}.cls-g3-205{fill:url(#linear-gradient-202);}.cls-g3-206{fill:url(#linear-gradient-203);}.cls-g3-207{fill:url(#linear-gradient-204);}.cls-g3-208{fill:url(#linear-gradient-205);}.cls-g3-209{fill:url(#linear-gradient-206);}.cls-g3-210{fill:url(#linear-gradient-207);}.cls-g3-211{fill:url(#linear-gradient-208);}.cls-g3-212{fill:url(#linear-gradient-209);}.cls-g3-213{fill:url(#linear-gradient-210);}.cls-g3-214{fill:url(#linear-gradient-211);}.cls-g3-215{fill:url(#linear-gradient-212);}.cls-g3-216{fill:url(#linear-gradient-213);}.cls-g3-217{fill:url(#linear-gradient-214);}.cls-g3-218{fill:url(#linear-gradient-215);}.cls-g3-219{fill:url(#linear-gradient-216);}.cls-g3-220{fill:url(#linear-gradient-217);}.cls-g3-221{fill:url(#linear-gradient-218);}.cls-g3-222{fill:url(#linear-gradient-219);}.cls-g3-223{fill:url(#linear-gradient-220);}.cls-g3-224{fill:url(#linear-gradient-221);}.cls-g3-225{fill:url(#linear-gradient-222);}.cls-g3-226{fill:url(#linear-gradient-223);}.cls-g3-227{fill:url(#linear-gradient-224);}.cls-g3-228{fill:url(#linear-gradient-225);}.cls-g3-229{fill:url(#linear-gradient-226);}.cls-g3-230{fill:url(#linear-gradient-227);}.cls-g3-231{fill:url(#linear-gradient-228);}.cls-g3-232{fill:url(#linear-gradient-229);}.cls-g3-233{fill:url(#linear-gradient-230);}.cls-g3-234{fill:url(#linear-gradient-231);}.cls-g3-235{fill:url(#linear-gradient-232);}.cls-g3-236{fill:url(#linear-gradient-233);}.cls-g3-237{fill:url(#linear-gradient-234);}.cls-g3-238{fill:url(#linear-gradient-235);}.cls-g3-239{fill:url(#linear-gradient-236);}.cls-g3-240{fill:url(#linear-gradient-237);}.cls-g3-241{fill:url(#linear-gradient-238);}.cls-g3-242{fill:url(#linear-gradient-239);}.cls-g3-243{fill:url(#linear-gradient-240);}.cls-g3-244{fill:url(#linear-gradient-241);}.cls-g3-245{fill:url(#linear-gradient-242);}.cls-g3-246{fill:url(#linear-gradient-243);}.cls-g3-247{fill:url(#linear-gradient-244);}.cls-g3-248{fill:url(#linear-gradient-245);}.cls-g3-249{fill:url(#linear-gradient-246);}.cls-g3-250{fill:url(#linear-gradient-247);}.cls-g3-251{fill:url(#linear-gradient-248);}.cls-g3-252{fill:url(#linear-gradient-249);}.cls-g3-253{fill:url(#linear-gradient-250);}.cls-g3-254{fill:url(#linear-gradient-251);}.cls-g3-255{fill:url(#linear-gradient-252);}.cls-g3-256{fill:url(#linear-gradient-253);}.cls-g3-257{fill:url(#linear-gradient-254);}.cls-g3-258{fill:url(#linear-gradient-255);}.cls-g3-259{fill:url(#linear-gradient-256);}.cls-g3-260{fill:url(#linear-gradient-257);}.cls-g3-261{fill:url(#linear-gradient-258);}.cls-g3-262{fill:url(#linear-gradient-259);}.cls-g3-263{fill:url(#linear-gradient-260);}.cls-g3-264{fill:url(#linear-gradient-261);}.cls-g3-265{fill:url(#linear-gradient-262);}.cls-g3-266{fill:url(#linear-gradient-263);}.cls-g3-267{fill:url(#linear-gradient-264);}.cls-g3-268{fill:url(#linear-gradient-265);}.cls-g3-269{fill:url(#linear-gradient-266);}.cls-g3-270{fill:url(#linear-gradient-267);}.cls-g3-271{fill:url(#linear-gradient-268);}.cls-g3-272{fill:url(#linear-gradient-269);}.cls-g3-273{fill:url(#linear-gradient-270);}.cls-g3-274{fill:url(#linear-gradient-271);}.cls-g3-275{fill:url(#linear-gradient-272);}.cls-g3-276{fill:url(#linear-gradient-273);}.cls-g3-277{fill:url(#linear-gradient-274);}.cls-g3-278{fill:url(#linear-gradient-275);}.cls-g3-279{fill:url(#linear-gradient-276);}.cls-g3-280{fill:url(#linear-gradient-277);}.cls-g3-281{fill:url(#linear-gradient-278);}.cls-g3-282{fill:url(#linear-gradient-279);}.cls-g3-283{fill:url(#linear-gradient-280);}.cls-g3-284{fill:url(#linear-gradient-281);}.cls-g3-285{fill:url(#linear-gradient-282);}.cls-g3-286{fill:url(#linear-gradient-283);}.cls-g3-287{fill:url(#linear-gradient-284);}.cls-g3-288{fill:url(#linear-gradient-285);}.cls-g3-289{fill:url(#linear-gradient-286);}.cls-g3-290{fill:url(#linear-gradient-287);}.cls-g3-291{fill:url(#linear-gradient-288);}.cls-g3-292{fill:url(#linear-gradient-289);}.cls-g3-293{fill:url(#linear-gradient-290);}.cls-g3-294{fill:url(#linear-gradient-291);}.cls-g3-295{fill:url(#linear-gradient-292);}.cls-g3-296{fill:url(#linear-gradient-293);}.cls-g3-297{fill:url(#linear-gradient-294);}.cls-g3-298{fill:url(#linear-gradient-295);}.cls-g3-299{fill:url(#linear-gradient-296);}.cls-g3-300{fill:url(#linear-gradient-297);}.cls-g3-301{fill:url(#linear-gradient-298);}.cls-g3-302{fill:url(#linear-gradient-299);}.cls-g3-303{fill:url(#linear-gradient-300);}.cls-g3-304{fill:url(#linear-gradient-301);}.cls-g3-305{fill:url(#linear-gradient-302);}.cls-g3-306{fill:url(#linear-gradient-303);}.cls-g3-307{fill:url(#linear-gradient-304);}.cls-g3-308{fill:url(#linear-gradient-305);}.cls-g3-309{fill:url(#linear-gradient-306);}.cls-g3-310{fill:url(#linear-gradient-307);}.cls-g3-311{fill:url(#linear-gradient-308);}.cls-g3-312{fill:url(#linear-gradient-309);}.cls-g3-313{fill:url(#linear-gradient-310);}.cls-g3-314{fill:url(#linear-gradient-311);}.cls-g3-315{fill:url(#linear-gradient-312);}.cls-g3-316{fill:url(#linear-gradient-313);}.cls-g3-317{fill:url(#linear-gradient-314);}.cls-g3-318{fill:url(#linear-gradient-315);}.cls-g3-319{fill:url(#linear-gradient-316);}.cls-g3-320{fill:url(#linear-gradient-317);}.cls-g3-321{fill:url(#linear-gradient-318);}.cls-g3-322{fill:url(#linear-gradient-319);}.cls-g3-323{fill:url(#linear-gradient-320);}.cls-g3-324{fill:url(#linear-gradient-321);}.cls-g3-325{fill:url(#linear-gradient-322);}.cls-g3-326{fill:url(#linear-gradient-323);}.cls-g3-327{fill:url(#linear-gradient-324);}.cls-g3-328{fill:url(#linear-gradient-325);}.cls-g3-329{fill:url(#linear-gradient-326);}.cls-g3-330{fill:url(#linear-gradient-327);}.cls-g3-331{fill:url(#linear-gradient-328);}.cls-g3-332{fill:url(#linear-gradient-329);}.cls-g3-333{fill:url(#linear-gradient-330);}.cls-g3-334{fill:url(#linear-gradient-331);}.cls-g3-335{fill:url(#linear-gradient-332);}.cls-g3-336{fill:url(#linear-gradient-333);}.cls-g3-337{fill:url(#linear-gradient-334);}.cls-g3-338{fill:url(#linear-gradient-335);}.cls-g3-339{fill:url(#linear-gradient-336);}.cls-g3-340{fill:url(#linear-gradient-337);}.cls-g3-341{fill:url(#linear-gradient-338);}.cls-g3-342{fill:url(#linear-gradient-339);}.cls-g3-343{fill:url(#linear-gradient-340);}.cls-g3-344{fill:url(#linear-gradient-341);}.cls-g3-345{fill:url(#linear-gradient-342);}.cls-g3-346{fill:url(#linear-gradient-343);}.cls-g3-347{fill:url(#linear-gradient-344);}.cls-g3-348{fill:url(#linear-gradient-345);}.cls-g3-349{fill:url(#linear-gradient-346);}.cls-g3-350{fill:url(#linear-gradient-347);}.cls-g3-351{fill:url(#linear-gradient-348);}.cls-g3-352{fill:url(#linear-gradient-349);}.cls-g3-353{fill:url(#linear-gradient-350);}.cls-g3-354{fill:url(#linear-gradient-351);}.cls-g3-355{fill:url(#linear-gradient-352);}.cls-g3-356{fill:url(#linear-gradient-353);}.cls-g3-357{fill:url(#linear-gradient-354);}.cls-g3-358{fill:url(#linear-gradient-355);}.cls-g3-359{fill:url(#linear-gradient-356);}.cls-g3-360{fill:url(#linear-gradient-357);}.cls-g3-361{fill:url(#linear-gradient-358);}.cls-g3-362{fill:url(#linear-gradient-359);}.cls-g3-363{fill:url(#linear-gradient-360);}.cls-g3-364{fill:url(#linear-gradient-361);}.cls-g3-365{fill:url(#linear-gradient-362);}.cls-g3-366{fill:url(#linear-gradient-363);}.cls-g3-367{fill:url(#linear-gradient-364);}.cls-g3-368{fill:url(#linear-gradient-365);}.cls-g3-369{fill:url(#linear-gradient-366);}.cls-g3-370{fill:url(#linear-gradient-367);}.cls-g3-371{fill:url(#linear-gradient-368);}.cls-g3-372{fill:url(#linear-gradient-369);}.cls-g3-373{fill:url(#linear-gradient-370);}.cls-g3-374{fill:url(#linear-gradient-371);}.cls-g3-375{fill:url(#linear-gradient-372);}.cls-g3-376{fill:url(#linear-gradient-373);}.cls-g3-377{fill:url(#linear-gradient-374);}.cls-g3-378{fill:url(#linear-gradient-375);}.cls-g3-379{fill:url(#linear-gradient-376);}.cls-g3-380{fill:url(#linear-gradient-377);}.cls-g3-381{fill:url(#linear-gradient-378);}.cls-g3-382{fill:url(#linear-gradient-379);}.cls-g3-383{fill:url(#linear-gradient-380);}.cls-g3-384{fill:url(#linear-gradient-381);}.cls-g3-385{fill:url(#linear-gradient-382);}.cls-g3-386{fill:url(#linear-gradient-383);}.cls-g3-387{fill:url(#linear-gradient-384);}.cls-g3-388{fill:url(#linear-gradient-385);}.cls-g3-389{fill:url(#linear-gradient-386);}.cls-g3-390{fill:url(#linear-gradient-387);}.cls-g3-391{fill:url(#linear-gradient-388);}.cls-g3-392{fill:url(#linear-gradient-389);}.cls-g3-393{fill:url(#linear-gradient-390);}.cls-g3-394{fill:url(#linear-gradient-391);}.cls-g3-395{fill:url(#linear-gradient-392);}.cls-g3-396{fill:url(#linear-gradient-393);}.cls-g3-397{fill:url(#linear-gradient-394);}.cls-g3-398{fill:url(#linear-gradient-395);}.cls-g3-399{fill:url(#linear-gradient-396);}.cls-g3-400{fill:url(#linear-gradient-397);}.cls-g3-401{fill:url(#linear-gradient-398);}.cls-g3-402{fill:url(#linear-gradient-399);}.cls-g3-403{fill:url(#linear-gradient-400);}.cls-g3-404{fill:url(#linear-gradient-401);}.cls-g3-405{fill:url(#linear-gradient-402);}.cls-g3-406{fill:url(#linear-gradient-403);}.cls-g3-407{fill:url(#linear-gradient-404);}.cls-g3-408{fill:url(#linear-gradient-405);}.cls-g3-409{fill:url(#linear-gradient-406);}.cls-g3-410{fill:url(#linear-gradient-407);}.cls-g3-411{fill:url(#linear-gradient-408);}.cls-g3-412{fill:url(#linear-gradient-409);}.cls-g3-413{fill:url(#linear-gradient-410);}.cls-g3-414{fill:url(#linear-gradient-411);}.cls-g3-415{fill:url(#linear-gradient-412);}.cls-g3-416{fill:url(#linear-gradient-413);}.cls-g3-417{fill:url(#linear-gradient-414);}.cls-g3-418{fill:url(#linear-gradient-415);}.cls-g3-419{fill:url(#linear-gradient-416);}.cls-g3-420{fill:url(#linear-gradient-417);}.cls-g3-421{fill:url(#linear-gradient-418);}.cls-g3-422{fill:url(#linear-gradient-419);}.cls-g3-423{fill:url(#linear-gradient-420);}.cls-g3-424{fill:url(#linear-gradient-421);}.cls-g3-425{fill:url(#linear-gradient-422);}.cls-g3-426{fill:url(#linear-gradient-423);}.cls-g3-427{fill:url(#linear-gradient-424);}.cls-g3-428{fill:url(#linear-gradient-425);}.cls-g3-429{fill:url(#linear-gradient-426);}.cls-g3-430{fill:url(#linear-gradient-427);}.cls-g3-431{fill:url(#linear-gradient-428);}.cls-g3-432{fill:url(#linear-gradient-429);}.cls-g3-433{fill:url(#linear-gradient-430);}.cls-g3-434{fill:url(#linear-gradient-431);}.cls-g3-435{fill:url(#linear-gradient-432);}.cls-g3-436{fill:url(#linear-gradient-433);}.cls-g3-437{fill:url(#linear-gradient-434);}.cls-g3-438{fill:url(#linear-gradient-435);}.cls-g3-439{fill:url(#linear-gradient-436);}.cls-g3-440{fill:url(#linear-gradient-437);}.cls-g3-441{fill:url(#linear-gradient-438);}.cls-g3-442{fill:url(#linear-gradient-439);}.cls-g3-443{fill:url(#linear-gradient-440);}.cls-g3-444{fill:url(#linear-gradient-441);}.cls-g3-445{fill:url(#linear-gradient-442);}.cls-g3-446{fill:url(#linear-gradient-443);}.cls-g3-447{fill:url(#linear-gradient-444);}.cls-g3-448{fill:url(#linear-gradient-445);}.cls-g3-449{fill:url(#linear-gradient-446);}.cls-g3-450{fill:url(#linear-gradient-447);}.cls-g3-451{fill:url(#linear-gradient-448);}.cls-g3-452{fill:url(#linear-gradient-449);}.cls-g3-453{fill:url(#linear-gradient-450);}.cls-g3-454{fill:url(#linear-gradient-451);}.cls-g3-455{fill:url(#linear-gradient-452);}.cls-g3-456{fill:url(#linear-gradient-453);}.cls-g3-457{fill:url(#linear-gradient-454);}.cls-g3-458{fill:url(#linear-gradient-455);}.cls-g3-459{fill:url(#linear-gradient-456);}.cls-g3-460{fill:url(#linear-gradient-457);}.cls-g3-461{fill:url(#linear-gradient-458);}.cls-g3-462{fill:url(#linear-gradient-459);}.cls-g3-463{fill:url(#linear-gradient-460);}.cls-g3-464{fill:url(#linear-gradient-461);}.cls-g3-465{fill:url(#linear-gradient-462);}.cls-g3-466{fill:url(#linear-gradient-463);}.cls-g3-467{fill:url(#linear-gradient-464);}.cls-g3-468{fill:url(#linear-gradient-465);}.cls-g3-469{fill:url(#linear-gradient-466);}.cls-g3-470{fill:url(#linear-gradient-467);}.cls-g3-471{fill:url(#linear-gradient-468);}.cls-g3-472{fill:url(#linear-gradient-469);}.cls-g3-473{fill:url(#linear-gradient-470);}.cls-g3-474{fill:url(#linear-gradient-471);}.cls-g3-475{fill:url(#linear-gradient-472);}.cls-g3-476{fill:url(#linear-gradient-473);}.cls-g3-477{fill:url(#linear-gradient-474);}.cls-g3-478{fill:url(#linear-gradient-475);}.cls-g3-479{fill:url(#linear-gradient-476);}.cls-g3-480{fill:url(#linear-gradient-477);}.cls-g3-481{fill:url(#linear-gradient-478);}.cls-g3-482{fill:url(#linear-gradient-479);}.cls-g3-483{fill:url(#linear-gradient-480);}.cls-g3-484{fill:url(#linear-gradient-481);}.cls-g3-485{fill:url(#linear-gradient-482);}.cls-g3-486{fill:url(#linear-gradient-483);}.cls-g3-487{fill:url(#linear-gradient-484);}.cls-g3-488{fill:url(#linear-gradient-485);}.cls-g3-489{fill:url(#linear-gradient-486);}.cls-g3-490{fill:url(#linear-gradient-487);}.cls-g3-491{fill:url(#linear-gradient-488);}.cls-g3-492{fill:url(#linear-gradient-489);}.cls-g3-493{fill:url(#linear-gradient-490);}.cls-g3-494{fill:url(#linear-gradient-491);}.cls-g3-495{fill:url(#linear-gradient-492);}.cls-g3-496{fill:url(#linear-gradient-493);}.cls-g3-497{fill:url(#linear-gradient-494);}.cls-g3-498{fill:url(#linear-gradient-495);}.cls-g3-499{fill:url(#linear-gradient-496);}.cls-g3-500{fill:url(#linear-gradient-497);}.cls-g3-501{fill:url(#linear-gradient-498);}.cls-g3-502{fill:url(#linear-gradient-499);}.cls-g3-503{fill:url(#linear-gradient-500);}.cls-g3-504{fill:url(#linear-gradient-501);}.cls-g3-505{fill:url(#linear-gradient-502);}.cls-g3-506{fill:url(#linear-gradient-503);}.cls-g3-507{fill:url(#linear-gradient-504);}.cls-g3-508{fill:url(#linear-gradient-505);}.cls-g3-509{fill:url(#linear-gradient-506);}.cls-g3-510{fill:url(#linear-gradient-507);}.cls-g3-511{fill:url(#linear-gradient-508);}.cls-g3-512{fill:url(#linear-gradient-509);}.cls-g3-513{fill:url(#linear-gradient-510);}.cls-g3-514{fill:url(#linear-gradient-511);}.cls-g3-515{fill:url(#linear-gradient-512);}.cls-g3-516{fill:url(#linear-gradient-513);}.cls-g3-517{fill:url(#linear-gradient-514);}.cls-g3-518{fill:url(#linear-gradient-515);}.cls-g3-519{fill:url(#linear-gradient-516);}.cls-g3-520{fill:url(#linear-gradient-517);}.cls-g3-521{fill:url(#linear-gradient-518);}.cls-g3-522{fill:url(#linear-gradient-519);}.cls-g3-523{fill:url(#linear-gradient-520);}.cls-g3-524{fill:url(#linear-gradient-521);}.cls-g3-525{fill:url(#linear-gradient-522);}.cls-g3-526{fill:url(#linear-gradient-523);}.cls-g3-527{fill:url(#linear-gradient-524);}.cls-g3-528{fill:url(#linear-gradient-525);}.cls-g3-529{fill:url(#linear-gradient-526);}.cls-g3-530{fill:url(#linear-gradient-527);}.cls-g3-531{fill:url(#linear-gradient-528);}.cls-g3-532{fill:url(#linear-gradient-529);}.cls-g3-533{fill:url(#linear-gradient-530);}.cls-g3-534{fill:url(#linear-gradient-531);}.cls-g3-535{fill:url(#linear-gradient-532);}.cls-g3-536{fill:url(#linear-gradient-533);}.cls-g3-537{fill:url(#linear-gradient-534);}.cls-g3-538{fill:url(#linear-gradient-535);}.cls-g3-539{fill:url(#linear-gradient-536);}.cls-g3-540{fill:url(#linear-gradient-537);}.cls-g3-541{fill:url(#linear-gradient-538);}.cls-g3-542{fill:url(#linear-gradient-539);}.cls-g3-543{fill:url(#linear-gradient-540);}.cls-g3-544{fill:url(#linear-gradient-541);}.cls-g3-545{fill:url(#linear-gradient-542);}.cls-g3-546{fill:url(#linear-gradient-543);}.cls-g3-547{fill:url(#linear-gradient-544);}.cls-g3-548{fill:url(#linear-gradient-545);}.cls-g3-549{fill:url(#linear-gradient-546);}.cls-g3-550{fill:url(#linear-gradient-547);}.cls-g3-551{fill:url(#linear-gradient-548);}.cls-g3-552{fill:url(#linear-gradient-549);}.cls-g3-553{fill:url(#linear-gradient-550);}.cls-g3-554{fill:url(#linear-gradient-551);}.cls-g3-555{fill:url(#linear-gradient-552);}.cls-g3-556{fill:url(#linear-gradient-553);}.cls-g3-557{fill:url(#linear-gradient-554);}.cls-g3-558{fill:url(#linear-gradient-555);}.cls-g3-559{fill:url(#linear-gradient-556);}.cls-g3-560{fill:url(#linear-gradient-557);}.cls-g3-561{fill:url(#linear-gradient-558);}.cls-g3-562{fill:url(#linear-gradient-559);}.cls-g3-563{fill:url(#linear-gradient-560);}.cls-g3-564{fill:url(#linear-gradient-561);}.cls-g3-565{fill:url(#linear-gradient-562);}.cls-g3-566{fill:url(#linear-gradient-563);}.cls-g3-567{fill:url(#linear-gradient-564);}.cls-g3-568{fill:url(#linear-gradient-565);}.cls-g3-569{fill:url(#linear-gradient-566);}.cls-g3-570{fill:url(#linear-gradient-567);}.cls-g3-571{fill:url(#linear-gradient-568);}.cls-g3-572{fill:url(#linear-gradient-569);}.cls-g3-573{fill:url(#linear-gradient-570);}.cls-g3-574{fill:url(#linear-gradient-571);}.cls-g3-575{fill:url(#linear-gradient-572);}.cls-g3-576{fill:url(#linear-gradient-573);}.cls-g3-577{fill:url(#linear-gradient-574);}.cls-g3-578{fill:url(#linear-gradient-575);}.cls-g3-579{fill:url(#linear-gradient-576);}.cls-g3-580{fill:url(#linear-gradient-577);}.cls-g3-581{fill:url(#linear-gradient-578);}.cls-g3-582{fill:url(#linear-gradient-579);}.cls-g3-583{fill:url(#linear-gradient-580);}.cls-g3-584{fill:url(#linear-gradient-581);}.cls-g3-585{fill:url(#linear-gradient-582);}.cls-g3-586{fill:url(#linear-gradient-583);}.cls-g3-587{fill:url(#linear-gradient-584);}.cls-g3-588{fill:url(#linear-gradient-585);}.cls-g3-589{fill:url(#linear-gradient-586);}.cls-g3-590{fill:url(#linear-gradient-587);}.cls-g3-591{fill:url(#linear-gradient-588);}.cls-g3-592{fill:url(#linear-gradient-589);}.cls-g3-593{fill:url(#linear-gradient-590);}.cls-g3-594{fill:url(#linear-gradient-591);}.cls-g3-595{fill:url(#linear-gradient-592);}.cls-g3-596{fill:url(#linear-gradient-593);}.cls-g3-597{fill:url(#linear-gradient-594);}.cls-g3-598{fill:url(#linear-gradient-595);}.cls-g3-599{fill:url(#linear-gradient-596);}.cls-g3-600{fill:url(#linear-gradient-597);}.cls-g3-601{fill:url(#linear-gradient-598);}.cls-g3-602{fill:url(#linear-gradient-599);}.cls-g3-603{fill:url(#linear-gradient-600);}.cls-g3-604{fill:url(#linear-gradient-601);}.cls-g3-605{fill:url(#linear-gradient-602);}.cls-g3-606{fill:url(#linear-gradient-603);}.cls-g3-607{fill:url(#linear-gradient-604);}.cls-g3-608{fill:url(#linear-gradient-605);}.cls-g3-609{fill:url(#linear-gradient-606);}.cls-g3-610{fill:url(#linear-gradient-607);}.cls-g3-611{fill:url(#linear-gradient-608);}.cls-g3-612{fill:url(#linear-gradient-609);}.cls-g3-613{fill:url(#linear-gradient-610);}.cls-g3-614{fill:url(#linear-gradient-611);}.cls-g3-615{fill:url(#linear-gradient-612);}.cls-g3-616{fill:url(#linear-gradient-613);}.cls-g3-617{fill:url(#linear-gradient-614);}.cls-g3-618{fill:url(#linear-gradient-615);}.cls-g3-619{fill:url(#linear-gradient-616);}.cls-g3-620{fill:url(#linear-gradient-617);}.cls-g3-621{fill:url(#linear-gradient-618);}.cls-g3-622{fill:url(#linear-gradient-619);}.cls-g3-623{fill:url(#linear-gradient-620);}.cls-g3-624{fill:url(#linear-gradient-621);}.cls-g3-625{fill:url(#linear-gradient-622);}.cls-g3-626{fill:url(#linear-gradient-623);}.cls-g3-627{fill:url(#linear-gradient-624);}.cls-g3-628{fill:url(#linear-gradient-625);}.cls-g3-629{fill:url(#linear-gradient-626);}.cls-g3-630{fill:url(#linear-gradient-627);}.cls-g3-631{fill:url(#linear-gradient-628);}.cls-g3-632{fill:url(#linear-gradient-629);}.cls-g3-633{fill:url(#linear-gradient-630);}.cls-g3-634{fill:url(#linear-gradient-631);}.cls-g3-635{fill:url(#linear-gradient-632);}.cls-g3-636{fill:url(#linear-gradient-633);}.cls-g3-637{fill:url(#linear-gradient-634);}.cls-g3-638{fill:url(#linear-gradient-635);}.cls-g3-639{fill:url(#linear-gradient-636);}.cls-g3-640{fill:url(#linear-gradient-637);}.cls-g3-641{fill:url(#linear-gradient-638);}.cls-g3-642{fill:url(#linear-gradient-639);}.cls-g3-643{fill:url(#linear-gradient-640);}.cls-g3-644{fill:url(#linear-gradient-641);}.cls-g3-645{fill:url(#linear-gradient-642);}.cls-g3-646{fill:url(#linear-gradient-643);}.cls-g3-647{fill:url(#linear-gradient-644);}.cls-g3-648{fill:url(#linear-gradient-645);}.cls-g3-649{fill:url(#linear-gradient-646);}.cls-g3-650{fill:url(#linear-gradient-647);}.cls-g3-651{fill:url(#linear-gradient-648);}.cls-g3-652{fill:url(#linear-gradient-649);}.cls-g3-653{fill:url(#linear-gradient-650);}.cls-g3-654{fill:url(#linear-gradient-651);}.cls-g3-655{fill:url(#linear-gradient-652);}.cls-g3-656{fill:url(#linear-gradient-653);}.cls-g3-657{fill:url(#linear-gradient-654);}.cls-g3-658{fill:url(#linear-gradient-655);}.cls-g3-659{fill:url(#linear-gradient-656);}.cls-g3-660{fill:url(#linear-gradient-657);}.cls-g3-661{fill:url(#linear-gradient-658);}.cls-g3-662{fill:url(#linear-gradient-659);}.cls-g3-663{fill:url(#linear-gradient-660);}.cls-g3-664{fill:url(#linear-gradient-661);}.cls-g3-665{fill:url(#linear-gradient-662);}.cls-g3-666{fill:url(#linear-gradient-663);}.cls-g3-667{fill:url(#linear-gradient-664);}.cls-g3-668{fill:url(#linear-gradient-665);}.cls-g3-669{fill:url(#linear-gradient-666);}.cls-g3-670{fill:url(#linear-gradient-667);}.cls-g3-671{fill:url(#linear-gradient-668);}.cls-g3-672{fill:url(#linear-gradient-669);}.cls-g3-673{fill:url(#linear-gradient-670);}.cls-g3-674{fill:url(#linear-gradient-671);}.cls-g3-675{fill:url(#linear-gradient-672);}.cls-g3-676{fill:url(#linear-gradient-673);}.cls-g3-677{fill:url(#linear-gradient-674);}.cls-g3-678{fill:url(#linear-gradient-675);}.cls-g3-679{fill:url(#linear-gradient-676);}.cls-g3-680{fill:url(#linear-gradient-677);}.cls-g3-681{fill:url(#linear-gradient-678);}.cls-g3-682{fill:url(#linear-gradient-679);}.cls-g3-683{fill:url(#linear-gradient-680);}.cls-g3-684{fill:url(#linear-gradient-681);}.cls-g3-685{fill:url(#linear-gradient-682);}.cls-g3-686{fill:url(#linear-gradient-683);}.cls-g3-687{fill:url(#linear-gradient-684);}.cls-g3-688{fill:url(#linear-gradient-685);}.cls-g3-689{fill:url(#linear-gradient-686);}.cls-g3-690{fill:url(#linear-gradient-687);}.cls-g3-691{fill:url(#linear-gradient-688);}.cls-g3-692{fill:url(#linear-gradient-689);}.cls-g3-693{fill:url(#linear-gradient-690);}.cls-g3-694{fill:url(#linear-gradient-691);}.cls-g3-695{fill:url(#linear-gradient-692);}.cls-g3-696{fill:url(#linear-gradient-693);}.cls-g3-697{fill:url(#linear-gradient-694);}.cls-g3-698{fill:url(#linear-gradient-695);}.cls-g3-699{fill:url(#linear-gradient-696);}.cls-g3-700{fill:url(#linear-gradient-697);}.cls-g3-701{fill:url(#linear-gradient-698);}.cls-g3-702{fill:url(#linear-gradient-699);}.cls-g3-703{fill:url(#linear-gradient-700);}.cls-g3-704{fill:url(#linear-gradient-701);}.cls-g3-705{fill:url(#linear-gradient-702);}.cls-g3-706{fill:url(#linear-gradient-703);}.cls-g3-707{fill:url(#linear-gradient-704);}.cls-g3-708{fill:url(#linear-gradient-705);}.cls-g3-709{fill:url(#linear-gradient-706);}.cls-g3-710{fill:url(#linear-gradient-707);}.cls-g3-711{fill:url(#linear-gradient-708);}.cls-g3-712{fill:url(#linear-gradient-709);}.cls-g3-713{fill:url(#linear-gradient-710);}.cls-g3-714{fill:url(#linear-gradient-711);}.cls-g3-715{fill:url(#linear-gradient-712);}.cls-g3-716{fill:url(#linear-gradient-713);}.cls-g3-717{fill:url(#linear-gradient-714);}.cls-g3-718{fill:url(#linear-gradient-715);}.cls-g3-719{fill:url(#linear-gradient-716);}.cls-g3-720{fill:url(#linear-gradient-717);}.cls-g3-721{fill:url(#linear-gradient-718);}.cls-g3-722{fill:url(#linear-gradient-719);}.cls-g3-723{fill:url(#linear-gradient-720);}.cls-g3-724{fill:url(#linear-gradient-721);}.cls-g3-725{fill:url(#linear-gradient-722);}.cls-g3-726{fill:url(#linear-gradient-723);}.cls-g3-727{fill:url(#linear-gradient-724);}.cls-g3-728{fill:url(#linear-gradient-725);}.cls-g3-729{fill:url(#linear-gradient-726);}.cls-g3-730{fill:url(#linear-gradient-727);}.cls-g3-731{fill:url(#linear-gradient-728);}.cls-g3-732{fill:url(#linear-gradient-729);}.cls-g3-733{fill:url(#linear-gradient-730);}.cls-g3-734{fill:url(#linear-gradient-731);}.cls-g3-735{fill:url(#linear-gradient-732);}.cls-g3-736{fill:url(#linear-gradient-733);}.cls-g3-737{fill:url(#linear-gradient-734);}.cls-g3-738{fill:url(#linear-gradient-735);}.cls-g3-739{fill:url(#linear-gradient-736);}.cls-g3-740{fill:url(#linear-gradient-737);}.cls-g3-741{fill:url(#linear-gradient-738);}.cls-g3-742{fill:url(#linear-gradient-739);}.cls-g3-743{fill:url(#linear-gradient-740);}.cls-g3-744{fill:url(#linear-gradient-741);}.cls-g3-745{fill:url(#linear-gradient-742);}.cls-g3-746{fill:url(#linear-gradient-743);}.cls-g3-747{fill:url(#linear-gradient-744);}.cls-g3-748{fill:url(#linear-gradient-745);}.cls-g3-749{fill:url(#linear-gradient-746);}.cls-g3-750{fill:url(#linear-gradient-747);}.cls-g3-751{fill:url(#linear-gradient-748);}.cls-g3-752{fill:url(#linear-gradient-749);}.cls-g3-753{fill:url(#linear-gradient-750);}.cls-g3-754{fill:url(#linear-gradient-751);}.cls-g3-755{fill:url(#linear-gradient-752);}.cls-g3-756{fill:url(#linear-gradient-753);}.cls-g3-757{fill:url(#linear-gradient-754);}.cls-g3-758{fill:url(#linear-gradient-755);}.cls-g3-759{fill:url(#linear-gradient-756);}.cls-g3-760{fill:url(#linear-gradient-757);}.cls-g3-761{fill:url(#linear-gradient-758);}.cls-g3-762{fill:url(#linear-gradient-759);}.cls-g3-763{fill:url(#linear-gradient-760);}.cls-g3-764{fill:url(#linear-gradient-761);}.cls-g3-765{fill:url(#linear-gradient-762);}.cls-g3-766{fill:url(#linear-gradient-763);}.cls-g3-767{fill:url(#linear-gradient-764);}.cls-g3-768{fill:url(#linear-gradient-765);}.cls-g3-769{fill:url(#linear-gradient-766);}.cls-g3-770{fill:url(#linear-gradient-767);}.cls-g3-771{fill:url(#linear-gradient-768);}.cls-g3-772{fill:url(#linear-gradient-769);}.cls-g3-773{fill:url(#linear-gradient-770);}.cls-g3-774{fill:url(#linear-gradient-771);}.cls-g3-775{fill:url(#linear-gradient-772);}.cls-g3-776{fill:url(#linear-gradient-773);}.cls-g3-777{fill:url(#linear-gradient-774);}.cls-g3-778{fill:url(#linear-gradient-775);}.cls-g3-779{fill:url(#linear-gradient-776);}.cls-g3-780{fill:url(#linear-gradient-777);}.cls-g3-781{fill:url(#linear-gradient-778);}.cls-g3-782{fill:url(#linear-gradient-779);}.cls-g3-783{fill:url(#linear-gradient-780);}.cls-g3-784{fill:url(#linear-gradient-781);}.cls-g3-785{fill:url(#linear-gradient-782);}.cls-g3-786{fill:url(#linear-gradient-783);}.cls-g3-787{fill:url(#linear-gradient-784);}.cls-g3-788{fill:url(#linear-gradient-785);}.cls-g3-789{fill:url(#linear-gradient-786);}.cls-g3-790{fill:url(#linear-gradient-787);}.cls-g3-791{fill:url(#linear-gradient-788);}.cls-g3-792{fill:url(#linear-gradient-789);}.cls-g3-793{fill:url(#linear-gradient-790);}.cls-g3-794{fill:url(#linear-gradient-791);}.cls-g3-795{fill:url(#linear-gradient-792);}.cls-g3-796{fill:url(#linear-gradient-793);}.cls-g3-797{fill:url(#linear-gradient-794);}.cls-g3-798{fill:url(#linear-gradient-795);}.cls-g3-799{fill:url(#linear-gradient-796);}.cls-g3-800{fill:url(#linear-gradient-797);}.cls-g3-801{fill:url(#linear-gradient-798);}.cls-g3-802{fill:url(#linear-gradient-799);}.cls-g3-803{fill:url(#linear-gradient-800);}.cls-g3-804{fill:url(#linear-gradient-801);}.cls-g3-805{fill:url(#linear-gradient-802);}.cls-g3-806{fill:url(#linear-gradient-803);}.cls-g3-807{fill:url(#linear-gradient-804);}.cls-g3-808{fill:url(#linear-gradient-805);}.cls-g3-809{fill:url(#linear-gradient-806);}.cls-g3-810{fill:url(#linear-gradient-807);}.cls-g3-811{fill:url(#linear-gradient-808);}.cls-g3-812{fill:url(#linear-gradient-809);}.cls-g3-813{fill:url(#linear-gradient-810);}.cls-g3-814{fill:url(#linear-gradient-811);}.cls-g3-815{fill:url(#linear-gradient-812);}.cls-g3-816{fill:url(#linear-gradient-813);}.cls-g3-817{fill:url(#linear-gradient-814);}.cls-g3-818{fill:url(#linear-gradient-815);}.cls-g3-819{fill:url(#linear-gradient-816);}.cls-g3-820{fill:url(#linear-gradient-817);}.cls-g3-821{fill:url(#linear-gradient-818);}.cls-g3-822{fill:url(#linear-gradient-819);}.cls-g3-823{fill:url(#linear-gradient-820);}.cls-g3-824{fill:url(#linear-gradient-821);}.cls-g3-825{fill:url(#linear-gradient-822);}.cls-g3-826{fill:url(#linear-gradient-823);}.cls-g3-827{fill:url(#linear-gradient-824);}.cls-g3-828{fill:url(#linear-gradient-825);}.cls-g3-829{fill:url(#linear-gradient-826);}.cls-g3-830{fill:url(#linear-gradient-827);}.cls-g3-831{fill:url(#linear-gradient-828);}.cls-g3-832{fill:url(#linear-gradient-829);}.cls-g3-833{fill:url(#linear-gradient-830);}.cls-g3-834{fill:url(#linear-gradient-831);}.cls-g3-835{fill:url(#linear-gradient-832);}.cls-g3-836{fill:url(#linear-gradient-833);}.cls-g3-837{fill:url(#linear-gradient-834);}.cls-g3-838{fill:url(#linear-gradient-835);}.cls-g3-839{fill:url(#linear-gradient-836);}.cls-g3-840{fill:url(#linear-gradient-837);}.cls-g3-841{fill:url(#linear-gradient-838);}.cls-g3-842{fill:url(#linear-gradient-839);}.cls-g3-843{fill:url(#linear-gradient-840);}.cls-g3-844{fill:url(#linear-gradient-841);}.cls-g3-845{fill:url(#linear-gradient-842);}.cls-g3-846{fill:url(#linear-gradient-843);}.cls-g3-847{fill:url(#linear-gradient-844);}.cls-g3-848{fill:url(#linear-gradient-845);}.cls-g3-849{fill:url(#linear-gradient-846);}.cls-g3-850{fill:url(#linear-gradient-847);}.cls-g3-851{fill:url(#linear-gradient-848);}.cls-g3-852{fill:url(#linear-gradient-849);}.cls-g3-853{fill:url(#linear-gradient-850);}.cls-g3-854{fill:url(#linear-gradient-851);}.cls-g3-855{fill:url(#linear-gradient-852);}.cls-g3-856{fill:url(#linear-gradient-853);}.cls-g3-857{fill:url(#linear-gradient-854);}.cls-g3-858{fill:url(#linear-gradient-855);}.cls-g3-859{fill:url(#linear-gradient-856);}.cls-g3-860{fill:url(#linear-gradient-857);}.cls-g3-861{fill:url(#linear-gradient-858);}.cls-g3-862{fill:url(#linear-gradient-859);}.cls-g3-863{fill:url(#linear-gradient-860);}.cls-g3-864{fill:url(#linear-gradient-861);}.cls-g3-865{fill:url(#linear-gradient-862);}.cls-g3-866{fill:url(#linear-gradient-863);}.cls-g3-867{fill:url(#linear-gradient-864);}.cls-g3-868{fill:url(#linear-gradient-865);}.cls-g3-869{fill:url(#linear-gradient-866);}.cls-g3-870{fill:url(#linear-gradient-867);}.cls-g3-871{fill:url(#linear-gradient-868);}.cls-g3-872{fill:url(#linear-gradient-869);}.cls-g3-873{fill:url(#linear-gradient-870);}.cls-g3-874{fill:url(#linear-gradient-871);}.cls-g3-875{fill:url(#linear-gradient-872);}.cls-g3-876{fill:url(#linear-gradient-873);}.cls-g3-877{fill:url(#linear-gradient-874);}.cls-g3-878{fill:url(#linear-gradient-875);}.cls-g3-879{fill:url(#linear-gradient-876);}.cls-g3-880{fill:url(#linear-gradient-877);}.cls-g3-881{fill:url(#linear-gradient-878);}.cls-g3-882{fill:url(#linear-gradient-879);}.cls-g3-883{fill:url(#linear-gradient-880);}.cls-g3-884{fill:url(#linear-gradient-881);}.cls-g3-885{fill:url(#linear-gradient-882);}.cls-g3-886{fill:url(#linear-gradient-883);}.cls-g3-887{fill:url(#linear-gradient-884);}.cls-g3-888{fill:url(#linear-gradient-885);}.cls-g3-889{fill:url(#linear-gradient-886);}.cls-g3-890{fill:url(#linear-gradient-887);}.cls-g3-891{fill:url(#linear-gradient-888);}.cls-g3-892{fill:url(#linear-gradient-889);}.cls-g3-893{fill:url(#linear-gradient-890);}.cls-g3-894{fill:url(#linear-gradient-891);}.cls-g3-895{fill:url(#linear-gradient-892);}.cls-g3-896{fill:url(#linear-gradient-893);}.cls-g3-897{fill:url(#linear-gradient-894);}.cls-g3-898{fill:url(#linear-gradient-895);}.cls-g3-899{fill:url(#linear-gradient-896);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -0.38,
  y1: 1592.67,
  x2: 243.31,
  y2: 1592.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ae7912"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#fbe97c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#e0a00e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#fcbc1e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#ae7912"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 53.1,
  y1: 1510.83,
  x2: 181.6,
  y2: 1635.98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fcbc1e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fbe97c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 19.09,
  y1: 1586.97,
  x2: 22.59,
  y2: 1586.97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e0a00e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fbe97c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 26.44,
  y1: 1591.35,
  x2: 29.94,
  y2: 1591.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 33.8,
  y1: 1594.17,
  x2: 37.3,
  y2: 1594.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 41.16,
  y1: 1596.31,
  x2: 44.66,
  y2: 1596.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 48.52,
  y1: 1598.02,
  x2: 52.02,
  y2: 1598.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 55.87,
  y1: 1599.41,
  x2: 59.37,
  y2: 1599.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 63.23,
  y1: 1600.55,
  x2: 66.73,
  y2: 1600.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 70.59,
  y1: 1601.47,
  x2: 74.09,
  y2: 1601.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 77.94,
  y1: 1602.21,
  x2: 81.44,
  y2: 1602.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 85.3,
  y1: 1602.79,
  x2: 88.8,
  y2: 1602.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 92.66,
  y1: 1603.21,
  x2: 96.16,
  y2: 1603.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 100.01,
  y1: 1603.48,
  x2: 103.51,
  y2: 1603.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 107.37,
  y1: 1603.62,
  x2: 110.87,
  y2: 1603.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 114.73,
  y1: 1603.62,
  x2: 118.23,
  y2: 1603.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 122.08,
  y1: 1603.48,
  x2: 125.58,
  y2: 1603.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 129.44,
  y1: 1603.21,
  x2: 132.94,
  y2: 1603.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 136.8,
  y1: 1602.79,
  x2: 140.3,
  y2: 1602.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 144.15,
  y1: 1602.21,
  x2: 147.65,
  y2: 1602.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 151.51,
  y1: 1601.47,
  x2: 155.01,
  y2: 1601.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 158.87,
  y1: 1600.55,
  x2: 162.37,
  y2: 1600.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 166.22,
  y1: 1599.41,
  x2: 169.72,
  y2: 1599.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 173.58,
  y1: 1598.02,
  x2: 177.08,
  y2: 1598.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 180.94,
  y1: 1596.31,
  x2: 184.44,
  y2: 1596.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: 188.29,
  y1: 1594.17,
  x2: 191.79,
  y2: 1594.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: 195.65,
  y1: 1591.35,
  x2: 199.15,
  y2: 1591.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: 203.01,
  y1: 1586.97,
  x2: 206.51,
  y2: 1586.97,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: -11.59,
  y1: 1567.29,
  x2: 232.09,
  y2: 1567.29,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: 41.89,
  y1: 1485.44,
  x2: 170.39,
  y2: 1610.6,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-31",
  x1: 7.87,
  y1: 1561.59,
  x2: 11.37,
  y2: 1561.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-32",
  x1: 15.23,
  y1: 1565.97,
  x2: 18.73,
  y2: 1565.97,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-33",
  x1: 22.59,
  y1: 1568.79,
  x2: 26.09,
  y2: 1568.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-34",
  x1: 29.94,
  y1: 1570.93,
  x2: 33.44,
  y2: 1570.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-35",
  x1: 37.3,
  y1: 1572.64,
  x2: 40.8,
  y2: 1572.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-36",
  x1: 44.66,
  y1: 1574.03,
  x2: 48.16,
  y2: 1574.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-37",
  x1: 52.02,
  y1: 1575.16,
  x2: 55.51,
  y2: 1575.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-38",
  x1: 59.37,
  y1: 1576.09,
  x2: 62.87,
  y2: 1576.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-39",
  x1: 66.73,
  y1: 1576.83,
  x2: 70.23,
  y2: 1576.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-40",
  x1: 74.09,
  y1: 1577.41,
  x2: 77.59,
  y2: 1577.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-41",
  x1: 81.44,
  y1: 1577.83,
  x2: 84.94,
  y2: 1577.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-42",
  x1: 88.8,
  y1: 1578.1,
  x2: 92.3,
  y2: 1578.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-43",
  x1: 96.16,
  y1: 1578.24,
  x2: 99.66,
  y2: 1578.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-44",
  x1: 103.51,
  y1: 1578.24,
  x2: 107.01,
  y2: 1578.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-45",
  x1: 110.87,
  y1: 1578.1,
  x2: 114.37,
  y2: 1578.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-46",
  x1: 118.23,
  y1: 1577.83,
  x2: 121.73,
  y2: 1577.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-47",
  x1: 125.58,
  y1: 1577.41,
  x2: 129.08,
  y2: 1577.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-48",
  x1: 132.94,
  y1: 1576.83,
  x2: 136.44,
  y2: 1576.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-49",
  x1: 140.3,
  y1: 1576.09,
  x2: 143.8,
  y2: 1576.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-50",
  x1: 147.65,
  y1: 1575.16,
  x2: 151.15,
  y2: 1575.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-51",
  x1: 155.01,
  y1: 1574.03,
  x2: 158.51,
  y2: 1574.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-52",
  x1: 162.37,
  y1: 1572.64,
  x2: 165.87,
  y2: 1572.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-53",
  x1: 169.72,
  y1: 1570.93,
  x2: 173.22,
  y2: 1570.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-54",
  x1: 177.08,
  y1: 1568.79,
  x2: 180.58,
  y2: 1568.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-55",
  x1: 184.44,
  y1: 1565.97,
  x2: 187.94,
  y2: 1565.97,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-56",
  x1: 191.79,
  y1: 1561.59,
  x2: 195.29,
  y2: 1561.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-57",
  x1: -0.38,
  y1: 1541.91,
  x2: 243.31,
  y2: 1541.91,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-58",
  x1: 53.1,
  y1: 1460.06,
  x2: 181.6,
  y2: 1585.22,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-59",
  x1: 19.09,
  y1: 1536.21,
  x2: 22.59,
  y2: 1536.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-60",
  x1: 26.44,
  y1: 1540.59,
  x2: 29.94,
  y2: 1540.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-61",
  x1: 33.8,
  y1: 1543.41,
  x2: 37.3,
  y2: 1543.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-62",
  x1: 41.16,
  y1: 1545.55,
  x2: 44.66,
  y2: 1545.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-63",
  x1: 48.52,
  y1: 1547.26,
  x2: 52.02,
  y2: 1547.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-64",
  x1: 55.87,
  y1: 1548.65,
  x2: 59.37,
  y2: 1548.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-65",
  x1: 63.23,
  y1: 1549.78,
  x2: 66.73,
  y2: 1549.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-66",
  x1: 70.59,
  y1: 1550.71,
  x2: 74.09,
  y2: 1550.71,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-67",
  x1: 77.94,
  y1: 1551.45,
  x2: 81.44,
  y2: 1551.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-68",
  x1: 85.3,
  y1: 1552.03,
  x2: 88.8,
  y2: 1552.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-69",
  x1: 92.66,
  y1: 1552.45,
  x2: 96.16,
  y2: 1552.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-70",
  x1: 100.01,
  y1: 1552.72,
  x2: 103.51,
  y2: 1552.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-71",
  x1: 107.37,
  y1: 1552.86,
  x2: 110.87,
  y2: 1552.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-72",
  x1: 114.73,
  y1: 1552.86,
  x2: 118.23,
  y2: 1552.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-73",
  x1: 122.08,
  y1: 1552.72,
  x2: 125.58,
  y2: 1552.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-74",
  x1: 129.44,
  y1: 1552.45,
  x2: 132.94,
  y2: 1552.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-75",
  x1: 136.8,
  y1: 1552.03,
  x2: 140.3,
  y2: 1552.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-76",
  x1: 144.15,
  y1: 1551.45,
  x2: 147.65,
  y2: 1551.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-77",
  x1: 151.51,
  y1: 1550.71,
  x2: 155.01,
  y2: 1550.71,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-78",
  x1: 158.87,
  y1: 1549.78,
  x2: 162.37,
  y2: 1549.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-79",
  x1: 166.22,
  y1: 1548.65,
  x2: 169.72,
  y2: 1548.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-80",
  x1: 173.58,
  y1: 1547.26,
  x2: 177.08,
  y2: 1547.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-81",
  x1: 180.94,
  y1: 1545.55,
  x2: 184.44,
  y2: 1545.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-82",
  x1: 188.29,
  y1: 1543.41,
  x2: 191.79,
  y2: 1543.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-83",
  x1: 195.65,
  y1: 1540.59,
  x2: 199.15,
  y2: 1540.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-84",
  x1: 203.01,
  y1: 1536.21,
  x2: 206.51,
  y2: 1536.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-85",
  x1: -7.91,
  y1: 1516.53,
  x2: 235.77,
  y2: 1516.53,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-86",
  x1: 45.57,
  y1: 1434.68,
  x2: 174.07,
  y2: 1559.84,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-87",
  x1: 11.55,
  y1: 1510.83,
  x2: 15.05,
  y2: 1510.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-88",
  x1: 18.91,
  y1: 1515.21,
  x2: 22.41,
  y2: 1515.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-89",
  x1: 26.27,
  y1: 1518.03,
  x2: 29.77,
  y2: 1518.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-90",
  x1: 33.62,
  y1: 1520.17,
  x2: 37.12,
  y2: 1520.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-91",
  x1: 40.98,
  y1: 1521.88,
  x2: 44.48,
  y2: 1521.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-92",
  x1: 48.34,
  y1: 1523.27,
  x2: 51.84,
  y2: 1523.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-93",
  x1: 55.69,
  y1: 1524.4,
  x2: 59.19,
  y2: 1524.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-94",
  x1: 63.05,
  y1: 1525.33,
  x2: 66.55,
  y2: 1525.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-95",
  x1: 70.41,
  y1: 1526.07,
  x2: 73.91,
  y2: 1526.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-96",
  x1: 77.76,
  y1: 1526.65,
  x2: 81.26,
  y2: 1526.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-97",
  x1: 85.12,
  y1: 1527.07,
  x2: 88.62,
  y2: 1527.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-98",
  x1: 92.48,
  y1: 1527.34,
  x2: 95.98,
  y2: 1527.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-99",
  x1: 99.83,
  y1: 1527.48,
  x2: 103.33,
  y2: 1527.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-100",
  x1: 107.19,
  y1: 1527.48,
  x2: 110.69,
  y2: 1527.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-101",
  x1: 114.55,
  y1: 1527.34,
  x2: 118.05,
  y2: 1527.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-102",
  x1: 121.9,
  y1: 1527.07,
  x2: 125.4,
  y2: 1527.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-103",
  x1: 129.26,
  y1: 1526.65,
  x2: 132.76,
  y2: 1526.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-104",
  x1: 136.62,
  y1: 1526.07,
  x2: 140.12,
  y2: 1526.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-105",
  x1: 143.97,
  y1: 1525.33,
  x2: 147.47,
  y2: 1525.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-106",
  x1: 151.33,
  y1: 1524.4,
  x2: 154.83,
  y2: 1524.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-107",
  x1: 158.69,
  y1: 1523.27,
  x2: 162.19,
  y2: 1523.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-108",
  x1: 166.04,
  y1: 1521.88,
  x2: 169.54,
  y2: 1521.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-109",
  x1: 173.4,
  y1: 1520.17,
  x2: 176.9,
  y2: 1520.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-110",
  x1: 180.76,
  y1: 1518.03,
  x2: 184.26,
  y2: 1518.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-111",
  x1: 188.11,
  y1: 1515.21,
  x2: 191.62,
  y2: 1515.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-112",
  x1: 195.47,
  y1: 1510.83,
  x2: 198.97,
  y2: 1510.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-113",
  x1: 6.98,
  y1: 1491.15,
  x2: 250.67,
  y2: 1491.15,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-114",
  x1: 60.46,
  y1: 1409.3,
  x2: 188.96,
  y2: 1534.46,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-115",
  x1: 26.44,
  y1: 1485.45,
  x2: 29.94,
  y2: 1485.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-116",
  x1: 33.8,
  y1: 1489.83,
  x2: 37.3,
  y2: 1489.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-117",
  x1: 41.16,
  y1: 1492.65,
  x2: 44.66,
  y2: 1492.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-118",
  x1: 48.52,
  y1: 1494.79,
  x2: 52.02,
  y2: 1494.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-119",
  x1: 55.87,
  y1: 1496.49,
  x2: 59.37,
  y2: 1496.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-120",
  x1: 63.23,
  y1: 1497.88,
  x2: 66.73,
  y2: 1497.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-121",
  x1: 70.59,
  y1: 1499.02,
  x2: 74.09,
  y2: 1499.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-122",
  x1: 77.94,
  y1: 1499.95,
  x2: 81.44,
  y2: 1499.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-123",
  x1: 85.3,
  y1: 1500.69,
  x2: 88.8,
  y2: 1500.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-124",
  x1: 92.66,
  y1: 1501.27,
  x2: 96.16,
  y2: 1501.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-125",
  x1: 100.01,
  y1: 1501.69,
  x2: 103.51,
  y2: 1501.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-126",
  x1: 107.37,
  y1: 1501.96,
  x2: 110.87,
  y2: 1501.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-127",
  x1: 114.73,
  y1: 1502.1,
  x2: 118.23,
  y2: 1502.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-128",
  x1: 122.08,
  y1: 1502.1,
  x2: 125.58,
  y2: 1502.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-129",
  x1: 129.44,
  y1: 1501.96,
  x2: 132.94,
  y2: 1501.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-130",
  x1: 136.8,
  y1: 1501.69,
  x2: 140.3,
  y2: 1501.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-131",
  x1: 144.15,
  y1: 1501.27,
  x2: 147.65,
  y2: 1501.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-132",
  x1: 151.51,
  y1: 1500.69,
  x2: 155.01,
  y2: 1500.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-133",
  x1: 158.87,
  y1: 1499.95,
  x2: 162.37,
  y2: 1499.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-134",
  x1: 166.22,
  y1: 1499.02,
  x2: 169.72,
  y2: 1499.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-135",
  x1: 173.58,
  y1: 1497.88,
  x2: 177.08,
  y2: 1497.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-136",
  x1: 180.94,
  y1: 1496.49,
  x2: 184.44,
  y2: 1496.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-137",
  x1: 188.29,
  y1: 1494.79,
  x2: 191.79,
  y2: 1494.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-138",
  x1: 195.65,
  y1: 1492.65,
  x2: 199.15,
  y2: 1492.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-139",
  x1: 203.01,
  y1: 1489.83,
  x2: 206.51,
  y2: 1489.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-140",
  x1: 210.36,
  y1: 1485.45,
  x2: 213.86,
  y2: 1485.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-141",
  x1: -4.05,
  y1: 1462.71,
  x2: 239.63,
  y2: 1462.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-142",
  x1: 49.42,
  y1: 1380.87,
  x2: 177.92,
  y2: 1506.02,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-143",
  x1: 15.41,
  y1: 1457.01,
  x2: 18.91,
  y2: 1457.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-144",
  x1: 22.77,
  y1: 1461.39,
  x2: 26.27,
  y2: 1461.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-145",
  x1: 30.12,
  y1: 1464.22,
  x2: 33.62,
  y2: 1464.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-146",
  x1: 37.48,
  y1: 1466.35,
  x2: 40.98,
  y2: 1466.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-147",
  x1: 44.84,
  y1: 1468.06,
  x2: 48.34,
  y2: 1468.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-148",
  x1: 52.19,
  y1: 1469.45,
  x2: 55.69,
  y2: 1469.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-149",
  x1: 59.55,
  y1: 1470.59,
  x2: 63.05,
  y2: 1470.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-150",
  x1: 66.91,
  y1: 1471.51,
  x2: 70.41,
  y2: 1471.51,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-151",
  x1: 74.26,
  y1: 1472.26,
  x2: 77.76,
  y2: 1472.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-152",
  x1: 81.62,
  y1: 1472.83,
  x2: 85.12,
  y2: 1472.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-153",
  x1: 88.98,
  y1: 1473.25,
  x2: 92.48,
  y2: 1473.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-154",
  x1: 96.33,
  y1: 1473.53,
  x2: 99.83,
  y2: 1473.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-155",
  x1: 103.69,
  y1: 1473.66,
  x2: 107.19,
  y2: 1473.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-156",
  x1: 111.05,
  y1: 1473.66,
  x2: 114.55,
  y2: 1473.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-157",
  x1: 118.4,
  y1: 1473.53,
  x2: 121.9,
  y2: 1473.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-158",
  x1: 125.76,
  y1: 1473.25,
  x2: 129.26,
  y2: 1473.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-159",
  x1: 133.12,
  y1: 1472.83,
  x2: 136.62,
  y2: 1472.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-160",
  x1: 140.47,
  y1: 1472.26,
  x2: 143.97,
  y2: 1472.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-161",
  x1: 147.83,
  y1: 1471.51,
  x2: 151.33,
  y2: 1471.51,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-162",
  x1: 155.19,
  y1: 1470.59,
  x2: 158.69,
  y2: 1470.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-163",
  x1: 162.54,
  y1: 1469.45,
  x2: 166.04,
  y2: 1469.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-164",
  x1: 169.9,
  y1: 1468.06,
  x2: 173.4,
  y2: 1468.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-165",
  x1: 177.26,
  y1: 1466.35,
  x2: 180.76,
  y2: 1466.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-166",
  x1: 184.62,
  y1: 1464.22,
  x2: 188.12,
  y2: 1464.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-167",
  x1: 191.97,
  y1: 1461.39,
  x2: 195.47,
  y2: 1461.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-168",
  x1: 199.33,
  y1: 1457.02,
  x2: 202.83,
  y2: 1457.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-169",
  x1: -4.05,
  y1: 1434.25,
  x2: 239.63,
  y2: 1434.25,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-170",
  x1: 49.42,
  y1: 1352.41,
  x2: 177.92,
  y2: 1477.57,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-171",
  x1: 15.41,
  y1: 1428.55,
  x2: 18.91,
  y2: 1428.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-172",
  x1: 22.77,
  y1: 1432.94,
  x2: 26.27,
  y2: 1432.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-173",
  x1: 30.12,
  y1: 1435.76,
  x2: 33.62,
  y2: 1435.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-174",
  x1: 37.48,
  y1: 1437.9,
  x2: 40.98,
  y2: 1437.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-175",
  x1: 44.84,
  y1: 1439.6,
  x2: 48.34,
  y2: 1439.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-176",
  x1: 52.19,
  y1: 1440.99,
  x2: 55.69,
  y2: 1440.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-177",
  x1: 59.55,
  y1: 1442.13,
  x2: 63.05,
  y2: 1442.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-178",
  x1: 66.91,
  y1: 1443.06,
  x2: 70.41,
  y2: 1443.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-179",
  x1: 74.26,
  y1: 1443.8,
  x2: 77.76,
  y2: 1443.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-180",
  x1: 81.62,
  y1: 1444.37,
  x2: 85.12,
  y2: 1444.37,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-181",
  x1: 88.98,
  y1: 1444.79,
  x2: 92.48,
  y2: 1444.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-182",
  x1: 96.33,
  y1: 1445.07,
  x2: 99.83,
  y2: 1445.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-183",
  x1: 103.69,
  y1: 1445.2,
  x2: 107.19,
  y2: 1445.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-184",
  x1: 111.05,
  y1: 1445.2,
  x2: 114.55,
  y2: 1445.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-185",
  x1: 118.4,
  y1: 1445.07,
  x2: 121.9,
  y2: 1445.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-186",
  x1: 125.76,
  y1: 1444.79,
  x2: 129.26,
  y2: 1444.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-187",
  x1: 133.12,
  y1: 1444.37,
  x2: 136.62,
  y2: 1444.37,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-188",
  x1: 140.47,
  y1: 1443.8,
  x2: 143.97,
  y2: 1443.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-189",
  x1: 147.83,
  y1: 1443.06,
  x2: 151.33,
  y2: 1443.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-190",
  x1: 155.19,
  y1: 1442.13,
  x2: 158.69,
  y2: 1442.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-191",
  x1: 162.54,
  y1: 1440.99,
  x2: 166.04,
  y2: 1440.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-192",
  x1: 169.9,
  y1: 1439.6,
  x2: 173.4,
  y2: 1439.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-193",
  x1: 177.26,
  y1: 1437.9,
  x2: 180.76,
  y2: 1437.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-194",
  x1: 184.62,
  y1: 1435.76,
  x2: 188.12,
  y2: 1435.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-195",
  x1: 191.97,
  y1: 1432.94,
  x2: 195.47,
  y2: 1432.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-196",
  x1: 199.33,
  y1: 1428.56,
  x2: 202.83,
  y2: 1428.56,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-197",
  x1: -11.61,
  y1: 1406.78,
  x2: 232.08,
  y2: 1406.78,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-198",
  x1: 41.87,
  y1: 1324.94,
  x2: 170.37,
  y2: 1450.09,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-199",
  x1: 7.86,
  y1: 1401.08,
  x2: 11.36,
  y2: 1401.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-200",
  x1: 15.21,
  y1: 1405.46,
  x2: 18.71,
  y2: 1405.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-201",
  x1: 22.57,
  y1: 1408.29,
  x2: 26.07,
  y2: 1408.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-202",
  x1: 29.93,
  y1: 1410.42,
  x2: 33.43,
  y2: 1410.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-203",
  x1: 37.28,
  y1: 1412.13,
  x2: 40.78,
  y2: 1412.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-204",
  x1: 44.64,
  y1: 1413.52,
  x2: 48.14,
  y2: 1413.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-205",
  x1: 52,
  y1: 1414.66,
  x2: 55.5,
  y2: 1414.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-206",
  x1: 59.35,
  y1: 1415.59,
  x2: 62.85,
  y2: 1415.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-207",
  x1: 66.71,
  y1: 1416.33,
  x2: 70.21,
  y2: 1416.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-208",
  x1: 74.07,
  y1: 1416.9,
  x2: 77.57,
  y2: 1416.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-209",
  x1: 81.42,
  y1: 1417.32,
  x2: 84.92,
  y2: 1417.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-210",
  x1: 88.78,
  y1: 1417.6,
  x2: 92.28,
  y2: 1417.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-211",
  x1: 96.14,
  y1: 1417.73,
  x2: 99.64,
  y2: 1417.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-212",
  x1: 103.49,
  y1: 1417.73,
  x2: 106.99,
  y2: 1417.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-213",
  x1: 110.85,
  y1: 1417.6,
  x2: 114.35,
  y2: 1417.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-214",
  x1: 118.21,
  y1: 1417.32,
  x2: 121.71,
  y2: 1417.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-215",
  x1: 125.56,
  y1: 1416.9,
  x2: 129.06,
  y2: 1416.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-216",
  x1: 132.92,
  y1: 1416.33,
  x2: 136.42,
  y2: 1416.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-217",
  x1: 140.28,
  y1: 1415.59,
  x2: 143.78,
  y2: 1415.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-218",
  x1: 147.63,
  y1: 1414.66,
  x2: 151.13,
  y2: 1414.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-219",
  x1: 154.99,
  y1: 1413.52,
  x2: 158.49,
  y2: 1413.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-220",
  x1: 162.35,
  y1: 1412.13,
  x2: 165.85,
  y2: 1412.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-221",
  x1: 169.71,
  y1: 1410.42,
  x2: 173.21,
  y2: 1410.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-222",
  x1: 177.06,
  y1: 1408.29,
  x2: 180.56,
  y2: 1408.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-223",
  x1: 184.42,
  y1: 1405.47,
  x2: 187.92,
  y2: 1405.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-224",
  x1: 191.78,
  y1: 1401.09,
  x2: 195.28,
  y2: 1401.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-225",
  x1: -7.73,
  y1: 1381.4,
  x2: 235.95,
  y2: 1381.4,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-226",
  x1: 45.74,
  y1: 1299.56,
  x2: 174.25,
  y2: 1424.71,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-227",
  x1: 11.73,
  y1: 1375.7,
  x2: 15.23,
  y2: 1375.7,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-228",
  x1: 19.09,
  y1: 1380.08,
  x2: 22.59,
  y2: 1380.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-229",
  x1: 26.44,
  y1: 1382.91,
  x2: 29.94,
  y2: 1382.91,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-230",
  x1: 33.8,
  y1: 1385.04,
  x2: 37.3,
  y2: 1385.04,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-231",
  x1: 41.16,
  y1: 1386.75,
  x2: 44.66,
  y2: 1386.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-232",
  x1: 48.52,
  y1: 1388.14,
  x2: 52.02,
  y2: 1388.14,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-233",
  x1: 55.87,
  y1: 1389.28,
  x2: 59.37,
  y2: 1389.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-234",
  x1: 63.23,
  y1: 1390.2,
  x2: 66.73,
  y2: 1390.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-235",
  x1: 70.59,
  y1: 1390.95,
  x2: 74.09,
  y2: 1390.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-236",
  x1: 77.94,
  y1: 1391.52,
  x2: 81.44,
  y2: 1391.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-237",
  x1: 85.3,
  y1: 1391.94,
  x2: 88.8,
  y2: 1391.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-238",
  x1: 92.66,
  y1: 1392.22,
  x2: 96.16,
  y2: 1392.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-239",
  x1: 100.01,
  y1: 1392.35,
  x2: 103.51,
  y2: 1392.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-240",
  x1: 107.37,
  y1: 1392.35,
  x2: 110.87,
  y2: 1392.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-241",
  x1: 114.73,
  y1: 1392.22,
  x2: 118.23,
  y2: 1392.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-242",
  x1: 122.08,
  y1: 1391.94,
  x2: 125.58,
  y2: 1391.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-243",
  x1: 129.44,
  y1: 1391.52,
  x2: 132.94,
  y2: 1391.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-244",
  x1: 136.8,
  y1: 1390.95,
  x2: 140.3,
  y2: 1390.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-245",
  x1: 144.15,
  y1: 1390.2,
  x2: 147.65,
  y2: 1390.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-246",
  x1: 151.51,
  y1: 1389.28,
  x2: 155.01,
  y2: 1389.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-247",
  x1: 158.87,
  y1: 1388.14,
  x2: 162.37,
  y2: 1388.14,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-248",
  x1: 166.22,
  y1: 1386.75,
  x2: 169.72,
  y2: 1386.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-249",
  x1: 173.58,
  y1: 1385.04,
  x2: 177.08,
  y2: 1385.04,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-250",
  x1: 180.94,
  y1: 1382.91,
  x2: 184.44,
  y2: 1382.91,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-251",
  x1: 188.29,
  y1: 1380.08,
  x2: 191.79,
  y2: 1380.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-252",
  x1: 195.65,
  y1: 1375.71,
  x2: 199.15,
  y2: 1375.71,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-253",
  x1: -2.13,
  y1: 1354.93,
  x2: 241.56,
  y2: 1354.93,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-254",
  x1: 51.35,
  y1: 1273.09,
  x2: 179.85,
  y2: 1398.25,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-255",
  x1: 17.34,
  y1: 1349.23,
  x2: 20.84,
  y2: 1349.23,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-256",
  x1: 24.69,
  y1: 1353.62,
  x2: 28.19,
  y2: 1353.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-257",
  x1: 32.05,
  y1: 1356.44,
  x2: 35.55,
  y2: 1356.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-258",
  x1: 39.41,
  y1: 1358.58,
  x2: 42.91,
  y2: 1358.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-259",
  x1: 46.77,
  y1: 1360.28,
  x2: 50.27,
  y2: 1360.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-260",
  x1: 54.12,
  y1: 1361.67,
  x2: 57.62,
  y2: 1361.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-261",
  x1: 61.48,
  y1: 1362.81,
  x2: 64.98,
  y2: 1362.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-262",
  x1: 68.84,
  y1: 1363.74,
  x2: 72.34,
  y2: 1363.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-263",
  x1: 76.19,
  y1: 1364.48,
  x2: 79.69,
  y2: 1364.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-264",
  x1: 83.55,
  y1: 1365.05,
  x2: 87.05,
  y2: 1365.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-265",
  x1: 90.91,
  y1: 1365.47,
  x2: 94.41,
  y2: 1365.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-266",
  x1: 98.26,
  y1: 1365.75,
  x2: 101.76,
  y2: 1365.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-267",
  x1: 105.62,
  y1: 1365.89,
  x2: 109.12,
  y2: 1365.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-268",
  x1: 112.98,
  y1: 1365.89,
  x2: 116.48,
  y2: 1365.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-269",
  x1: 120.33,
  y1: 1365.75,
  x2: 123.83,
  y2: 1365.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-270",
  x1: 127.69,
  y1: 1365.47,
  x2: 131.19,
  y2: 1365.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-271",
  x1: 135.05,
  y1: 1365.05,
  x2: 138.55,
  y2: 1365.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-272",
  x1: 142.4,
  y1: 1364.48,
  x2: 145.9,
  y2: 1364.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-273",
  x1: 149.76,
  y1: 1363.74,
  x2: 153.26,
  y2: 1363.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-274",
  x1: 157.12,
  y1: 1362.81,
  x2: 160.62,
  y2: 1362.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-275",
  x1: 164.47,
  y1: 1361.67,
  x2: 167.97,
  y2: 1361.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-276",
  x1: 171.83,
  y1: 1360.28,
  x2: 175.33,
  y2: 1360.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-277",
  x1: 179.19,
  y1: 1358.58,
  x2: 182.69,
  y2: 1358.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-278",
  x1: 186.54,
  y1: 1356.44,
  x2: 190.04,
  y2: 1356.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-279",
  x1: 193.9,
  y1: 1353.62,
  x2: 197.4,
  y2: 1353.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-280",
  x1: 201.26,
  y1: 1349.24,
  x2: 204.76,
  y2: 1349.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-281",
  x1: -11.41,
  y1: 1326.95,
  x2: 232.27,
  y2: 1326.95,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-282",
  x1: 42.07,
  y1: 1245.11,
  x2: 170.57,
  y2: 1370.27,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-283",
  x1: 8.05,
  y1: 1321.25,
  x2: 11.55,
  y2: 1321.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-284",
  x1: 15.41,
  y1: 1325.64,
  x2: 18.91,
  y2: 1325.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-285",
  x1: 22.77,
  y1: 1328.46,
  x2: 26.27,
  y2: 1328.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-286",
  x1: 30.12,
  y1: 1330.6,
  x2: 33.62,
  y2: 1330.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-287",
  x1: 37.48,
  y1: 1332.3,
  x2: 40.98,
  y2: 1332.3,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-288",
  x1: 44.84,
  y1: 1333.69,
  x2: 48.34,
  y2: 1333.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-289",
  x1: 52.19,
  y1: 1334.83,
  x2: 55.69,
  y2: 1334.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-290",
  x1: 59.55,
  y1: 1335.76,
  x2: 63.05,
  y2: 1335.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-291",
  x1: 66.91,
  y1: 1336.5,
  x2: 70.41,
  y2: 1336.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-292",
  x1: 74.26,
  y1: 1337.07,
  x2: 77.76,
  y2: 1337.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-293",
  x1: 81.62,
  y1: 1337.49,
  x2: 85.12,
  y2: 1337.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-294",
  x1: 88.98,
  y1: 1337.77,
  x2: 92.48,
  y2: 1337.77,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-295",
  x1: 96.33,
  y1: 1337.9,
  x2: 99.83,
  y2: 1337.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-296",
  x1: 103.69,
  y1: 1337.9,
  x2: 107.19,
  y2: 1337.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-297",
  x1: 111.05,
  y1: 1337.77,
  x2: 114.55,
  y2: 1337.77,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-298",
  x1: 118.4,
  y1: 1337.49,
  x2: 121.9,
  y2: 1337.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-299",
  x1: 125.76,
  y1: 1337.07,
  x2: 129.26,
  y2: 1337.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-300",
  x1: 133.12,
  y1: 1336.5,
  x2: 136.62,
  y2: 1336.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-301",
  x1: 140.47,
  y1: 1335.76,
  x2: 143.97,
  y2: 1335.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-302",
  x1: 147.83,
  y1: 1334.83,
  x2: 151.33,
  y2: 1334.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-303",
  x1: 155.19,
  y1: 1333.69,
  x2: 158.69,
  y2: 1333.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-304",
  x1: 162.54,
  y1: 1332.3,
  x2: 166.04,
  y2: 1332.3,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-305",
  x1: 169.9,
  y1: 1330.6,
  x2: 173.4,
  y2: 1330.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-306",
  x1: 177.26,
  y1: 1328.46,
  x2: 180.76,
  y2: 1328.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-307",
  x1: 184.62,
  y1: 1325.64,
  x2: 188.12,
  y2: 1325.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-308",
  x1: 191.97,
  y1: 1321.26,
  x2: 195.47,
  y2: 1321.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-309",
  x1: -5.8,
  y1: 1301.57,
  x2: 237.88,
  y2: 1301.57,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-310",
  x1: 47.67,
  y1: 1219.73,
  x2: 176.17,
  y2: 1344.89,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-311",
  x1: 13.66,
  y1: 1295.87,
  x2: 17.16,
  y2: 1295.87,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-312",
  x1: 21.02,
  y1: 1300.26,
  x2: 24.52,
  y2: 1300.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-313",
  x1: 28.37,
  y1: 1303.08,
  x2: 31.87,
  y2: 1303.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-314",
  x1: 35.73,
  y1: 1305.22,
  x2: 39.23,
  y2: 1305.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-315",
  x1: 43.09,
  y1: 1306.92,
  x2: 46.59,
  y2: 1306.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-316",
  x1: 50.44,
  y1: 1308.31,
  x2: 53.94,
  y2: 1308.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-317",
  x1: 57.8,
  y1: 1309.45,
  x2: 61.3,
  y2: 1309.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-318",
  x1: 65.16,
  y1: 1310.38,
  x2: 68.66,
  y2: 1310.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-319",
  x1: 72.51,
  y1: 1311.12,
  x2: 76.01,
  y2: 1311.12,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-320",
  x1: 79.87,
  y1: 1311.69,
  x2: 83.37,
  y2: 1311.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-321",
  x1: 87.23,
  y1: 1312.11,
  x2: 90.73,
  y2: 1312.11,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-322",
  x1: 94.58,
  y1: 1312.39,
  x2: 98.08,
  y2: 1312.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-323",
  x1: 101.94,
  y1: 1312.52,
  x2: 105.44,
  y2: 1312.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-324",
  x1: 109.3,
  y1: 1312.52,
  x2: 112.8,
  y2: 1312.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-325",
  x1: 116.65,
  y1: 1312.39,
  x2: 120.15,
  y2: 1312.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-326",
  x1: 124.01,
  y1: 1312.11,
  x2: 127.51,
  y2: 1312.11,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-327",
  x1: 131.37,
  y1: 1311.69,
  x2: 134.87,
  y2: 1311.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-328",
  x1: 138.72,
  y1: 1311.12,
  x2: 142.22,
  y2: 1311.12,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-329",
  x1: 146.08,
  y1: 1310.38,
  x2: 149.58,
  y2: 1310.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-330",
  x1: 153.44,
  y1: 1309.45,
  x2: 156.94,
  y2: 1309.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-331",
  x1: 160.79,
  y1: 1308.31,
  x2: 164.29,
  y2: 1308.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-332",
  x1: 168.15,
  y1: 1306.92,
  x2: 171.65,
  y2: 1306.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-333",
  x1: 175.51,
  y1: 1305.22,
  x2: 179.01,
  y2: 1305.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-334",
  x1: 182.87,
  y1: 1303.08,
  x2: 186.37,
  y2: 1303.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-335",
  x1: 190.22,
  y1: 1300.26,
  x2: 193.72,
  y2: 1300.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-336",
  x1: 197.58,
  y1: 1295.88,
  x2: 201.08,
  y2: 1295.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-337",
  x1: -17.2,
  y1: 1273.64,
  x2: 226.49,
  y2: 1273.64,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-338",
  x1: 36.28,
  y1: 1191.8,
  x2: 164.78,
  y2: 1316.95,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-339",
  x1: 2.27,
  y1: 1267.94,
  x2: 5.77,
  y2: 1267.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-340",
  x1: 9.62,
  y1: 1272.32,
  x2: 13.12,
  y2: 1272.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-341",
  x1: 16.98,
  y1: 1275.15,
  x2: 20.48,
  y2: 1275.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-342",
  x1: 24.34,
  y1: 1277.28,
  x2: 27.84,
  y2: 1277.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-343",
  x1: 31.69,
  y1: 1278.99,
  x2: 35.19,
  y2: 1278.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-344",
  x1: 39.05,
  y1: 1280.38,
  x2: 42.55,
  y2: 1280.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-345",
  x1: 46.41,
  y1: 1281.52,
  x2: 49.91,
  y2: 1281.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-346",
  x1: 53.76,
  y1: 1282.44,
  x2: 57.26,
  y2: 1282.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-347",
  x1: 61.12,
  y1: 1283.19,
  x2: 64.62,
  y2: 1283.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-348",
  x1: 68.48,
  y1: 1283.76,
  x2: 71.98,
  y2: 1283.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-349",
  x1: 75.84,
  y1: 1284.18,
  x2: 79.34,
  y2: 1284.18,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-350",
  x1: 83.19,
  y1: 1284.46,
  x2: 86.69,
  y2: 1284.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-351",
  x1: 90.55,
  y1: 1284.59,
  x2: 94.05,
  y2: 1284.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-352",
  x1: 97.91,
  y1: 1284.59,
  x2: 101.41,
  y2: 1284.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-353",
  x1: 105.26,
  y1: 1284.46,
  x2: 108.76,
  y2: 1284.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-354",
  x1: 112.62,
  y1: 1284.18,
  x2: 116.12,
  y2: 1284.18,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-355",
  x1: 119.98,
  y1: 1283.76,
  x2: 123.48,
  y2: 1283.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-356",
  x1: 127.33,
  y1: 1283.19,
  x2: 130.83,
  y2: 1283.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-357",
  x1: 134.69,
  y1: 1282.44,
  x2: 138.19,
  y2: 1282.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-358",
  x1: 142.05,
  y1: 1281.52,
  x2: 145.55,
  y2: 1281.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-359",
  x1: 149.4,
  y1: 1280.38,
  x2: 152.9,
  y2: 1280.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-360",
  x1: 156.76,
  y1: 1278.99,
  x2: 160.26,
  y2: 1278.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-361",
  x1: 164.12,
  y1: 1277.28,
  x2: 167.62,
  y2: 1277.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-362",
  x1: 171.47,
  y1: 1275.15,
  x2: 174.97,
  y2: 1275.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-363",
  x1: 178.83,
  y1: 1272.32,
  x2: 182.33,
  y2: 1272.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-364",
  x1: 186.19,
  y1: 1267.95,
  x2: 189.69,
  y2: 1267.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-365",
  x1: -2.48,
  y1: 1250.1,
  x2: 241.2,
  y2: 1250.1,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-366",
  x1: 50.99,
  y1: 1168.26,
  x2: 179.49,
  y2: 1293.41,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-367",
  x1: 16.98,
  y1: 1244.4,
  x2: 20.48,
  y2: 1244.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-368",
  x1: 24.34,
  y1: 1248.78,
  x2: 27.84,
  y2: 1248.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-369",
  x1: 31.69,
  y1: 1251.61,
  x2: 35.19,
  y2: 1251.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-370",
  x1: 39.05,
  y1: 1253.74,
  x2: 42.55,
  y2: 1253.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-371",
  x1: 46.41,
  y1: 1255.45,
  x2: 49.91,
  y2: 1255.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-372",
  x1: 53.76,
  y1: 1256.84,
  x2: 57.26,
  y2: 1256.84,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-373",
  x1: 61.12,
  y1: 1257.98,
  x2: 64.62,
  y2: 1257.98,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-374",
  x1: 68.48,
  y1: 1258.9,
  x2: 71.98,
  y2: 1258.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-375",
  x1: 75.84,
  y1: 1259.65,
  x2: 79.34,
  y2: 1259.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-376",
  x1: 83.19,
  y1: 1260.22,
  x2: 86.69,
  y2: 1260.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-377",
  x1: 90.55,
  y1: 1260.64,
  x2: 94.05,
  y2: 1260.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-378",
  x1: 97.91,
  y1: 1260.92,
  x2: 101.41,
  y2: 1260.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-379",
  x1: 105.26,
  y1: 1261.05,
  x2: 108.76,
  y2: 1261.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-380",
  x1: 112.62,
  y1: 1261.05,
  x2: 116.12,
  y2: 1261.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-381",
  x1: 119.98,
  y1: 1260.92,
  x2: 123.48,
  y2: 1260.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-382",
  x1: 127.33,
  y1: 1260.64,
  x2: 130.83,
  y2: 1260.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-383",
  x1: 134.69,
  y1: 1260.22,
  x2: 138.19,
  y2: 1260.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-384",
  x1: 142.05,
  y1: 1259.65,
  x2: 145.55,
  y2: 1259.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-385",
  x1: 149.4,
  y1: 1258.9,
  x2: 152.9,
  y2: 1258.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-386",
  x1: 156.76,
  y1: 1257.98,
  x2: 160.26,
  y2: 1257.98,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-387",
  x1: 164.12,
  y1: 1256.84,
  x2: 167.62,
  y2: 1256.84,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-388",
  x1: 171.47,
  y1: 1255.45,
  x2: 174.97,
  y2: 1255.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-389",
  x1: 178.83,
  y1: 1253.74,
  x2: 182.33,
  y2: 1253.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-390",
  x1: 186.19,
  y1: 1251.61,
  x2: 189.69,
  y2: 1251.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-391",
  x1: 193.54,
  y1: 1248.78,
  x2: 197.04,
  y2: 1248.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-392",
  x1: 200.9,
  y1: 1244.41,
  x2: 204.4,
  y2: 1244.41,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-393",
  x1: -11.23,
  y1: 1222.14,
  x2: 232.45,
  y2: 1222.14,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-394",
  x1: 42.24,
  y1: 1140.3,
  x2: 170.75,
  y2: 1265.45,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-395",
  x1: 8.23,
  y1: 1216.44,
  x2: 11.73,
  y2: 1216.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-396",
  x1: 15.59,
  y1: 1220.82,
  x2: 19.09,
  y2: 1220.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-397",
  x1: 22.94,
  y1: 1223.65,
  x2: 26.44,
  y2: 1223.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-398",
  x1: 30.3,
  y1: 1225.78,
  x2: 33.8,
  y2: 1225.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-399",
  x1: 37.66,
  y1: 1227.49,
  x2: 41.16,
  y2: 1227.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-400",
  x1: 45.02,
  y1: 1228.88,
  x2: 48.52,
  y2: 1228.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-401",
  x1: 52.37,
  y1: 1230.02,
  x2: 55.87,
  y2: 1230.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-402",
  x1: 59.73,
  y1: 1230.95,
  x2: 63.23,
  y2: 1230.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-403",
  x1: 67.09,
  y1: 1231.69,
  x2: 70.59,
  y2: 1231.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-404",
  x1: 74.44,
  y1: 1232.26,
  x2: 77.94,
  y2: 1232.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-405",
  x1: 81.8,
  y1: 1232.68,
  x2: 85.3,
  y2: 1232.68,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-406",
  x1: 89.16,
  y1: 1232.96,
  x2: 92.66,
  y2: 1232.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-407",
  x1: 96.51,
  y1: 1233.09,
  x2: 100.01,
  y2: 1233.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-408",
  x1: 103.87,
  y1: 1233.09,
  x2: 107.37,
  y2: 1233.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-409",
  x1: 111.23,
  y1: 1232.96,
  x2: 114.73,
  y2: 1232.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-410",
  x1: 118.58,
  y1: 1232.68,
  x2: 122.08,
  y2: 1232.68,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-411",
  x1: 125.94,
  y1: 1232.26,
  x2: 129.44,
  y2: 1232.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-412",
  x1: 133.3,
  y1: 1231.69,
  x2: 136.8,
  y2: 1231.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-413",
  x1: 140.65,
  y1: 1230.95,
  x2: 144.15,
  y2: 1230.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-414",
  x1: 148.01,
  y1: 1230.02,
  x2: 151.51,
  y2: 1230.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-415",
  x1: 155.37,
  y1: 1228.88,
  x2: 158.87,
  y2: 1228.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-416",
  x1: 162.72,
  y1: 1227.49,
  x2: 166.22,
  y2: 1227.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-417",
  x1: 170.08,
  y1: 1225.78,
  x2: 173.58,
  y2: 1225.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-418",
  x1: 177.44,
  y1: 1223.65,
  x2: 180.94,
  y2: 1223.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-419",
  x1: 184.79,
  y1: 1220.82,
  x2: 188.29,
  y2: 1220.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-420",
  x1: 192.15,
  y1: 1216.45,
  x2: 195.65,
  y2: 1216.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-421",
  x1: -7.91,
  y1: 1194.71,
  x2: 235.77,
  y2: 1194.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-422",
  x1: 45.57,
  y1: 1112.87,
  x2: 174.07,
  y2: 1238.03,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-423",
  x1: 11.55,
  y1: 1189.01,
  x2: 15.05,
  y2: 1189.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-424",
  x1: 18.91,
  y1: 1193.4,
  x2: 22.41,
  y2: 1193.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-425",
  x1: 26.27,
  y1: 1196.22,
  x2: 29.77,
  y2: 1196.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-426",
  x1: 33.62,
  y1: 1198.36,
  x2: 37.12,
  y2: 1198.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-427",
  x1: 40.98,
  y1: 1200.06,
  x2: 44.48,
  y2: 1200.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-428",
  x1: 48.34,
  y1: 1201.45,
  x2: 51.84,
  y2: 1201.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-429",
  x1: 55.69,
  y1: 1202.59,
  x2: 59.19,
  y2: 1202.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-430",
  x1: 63.05,
  y1: 1203.52,
  x2: 66.55,
  y2: 1203.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-431",
  x1: 70.41,
  y1: 1204.26,
  x2: 73.91,
  y2: 1204.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-432",
  x1: 77.76,
  y1: 1204.83,
  x2: 81.26,
  y2: 1204.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-433",
  x1: 85.12,
  y1: 1205.25,
  x2: 88.62,
  y2: 1205.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-434",
  x1: 92.48,
  y1: 1205.53,
  x2: 95.98,
  y2: 1205.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-435",
  x1: 99.83,
  y1: 1205.66,
  x2: 103.33,
  y2: 1205.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-436",
  x1: 107.19,
  y1: 1205.66,
  x2: 110.69,
  y2: 1205.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-437",
  x1: 114.55,
  y1: 1205.53,
  x2: 118.05,
  y2: 1205.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-438",
  x1: 121.9,
  y1: 1205.25,
  x2: 125.4,
  y2: 1205.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-439",
  x1: 129.26,
  y1: 1204.83,
  x2: 132.76,
  y2: 1204.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-440",
  x1: 136.62,
  y1: 1204.26,
  x2: 140.12,
  y2: 1204.26,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-441",
  x1: 143.97,
  y1: 1203.52,
  x2: 147.47,
  y2: 1203.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-442",
  x1: 151.33,
  y1: 1202.59,
  x2: 154.83,
  y2: 1202.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-443",
  x1: 158.69,
  y1: 1201.45,
  x2: 162.19,
  y2: 1201.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-444",
  x1: 166.04,
  y1: 1200.06,
  x2: 169.54,
  y2: 1200.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-445",
  x1: 173.4,
  y1: 1198.36,
  x2: 176.9,
  y2: 1198.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-446",
  x1: 180.76,
  y1: 1196.22,
  x2: 184.26,
  y2: 1196.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-447",
  x1: 188.11,
  y1: 1193.4,
  x2: 191.62,
  y2: 1193.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-448",
  x1: 195.47,
  y1: 1189.02,
  x2: 198.97,
  y2: 1189.02,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-449",
  x1: 994.4,
  y1: 1582.08,
  x2: 1238.09,
  y2: 1582.08,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-450",
  x1: 1047.88,
  y1: 1500.23,
  x2: 1176.38,
  y2: 1625.39,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-451",
  x1: 1013.87,
  y1: 1576.38,
  x2: 1017.37,
  y2: 1576.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-452",
  x1: 1021.22,
  y1: 1580.76,
  x2: 1024.72,
  y2: 1580.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-453",
  x1: 1028.58,
  y1: 1583.58,
  x2: 1032.08,
  y2: 1583.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-454",
  x1: 1035.94,
  y1: 1585.72,
  x2: 1039.44,
  y2: 1585.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-455",
  x1: 1043.29,
  y1: 1587.42,
  x2: 1046.79,
  y2: 1587.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-456",
  x1: 1050.65,
  y1: 1588.81,
  x2: 1054.15,
  y2: 1588.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-457",
  x1: 1058.01,
  y1: 1589.95,
  x2: 1061.51,
  y2: 1589.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-458",
  x1: 1065.36,
  y1: 1590.88,
  x2: 1068.86,
  y2: 1590.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-459",
  x1: 1072.72,
  y1: 1591.62,
  x2: 1076.22,
  y2: 1591.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-460",
  x1: 1080.08,
  y1: 1592.2,
  x2: 1083.58,
  y2: 1592.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-461",
  x1: 1087.43,
  y1: 1592.62,
  x2: 1090.93,
  y2: 1592.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-462",
  x1: 1094.79,
  y1: 1592.89,
  x2: 1098.29,
  y2: 1592.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-463",
  x1: 1102.15,
  y1: 1593.03,
  x2: 1105.65,
  y2: 1593.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-464",
  x1: 1109.5,
  y1: 1593.03,
  x2: 1113,
  y2: 1593.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-465",
  x1: 1116.86,
  y1: 1592.89,
  x2: 1120.36,
  y2: 1592.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-466",
  x1: 1124.22,
  y1: 1592.62,
  x2: 1127.72,
  y2: 1592.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-467",
  x1: 1131.57,
  y1: 1592.2,
  x2: 1135.07,
  y2: 1592.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-468",
  x1: 1138.93,
  y1: 1591.62,
  x2: 1142.43,
  y2: 1591.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-469",
  x1: 1146.29,
  y1: 1590.88,
  x2: 1149.79,
  y2: 1590.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-470",
  x1: 1153.64,
  y1: 1589.95,
  x2: 1157.14,
  y2: 1589.95,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-471",
  x1: 1161,
  y1: 1588.81,
  x2: 1164.5,
  y2: 1588.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-472",
  x1: 1168.36,
  y1: 1587.42,
  x2: 1171.86,
  y2: 1587.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-473",
  x1: 1175.71,
  y1: 1585.72,
  x2: 1179.21,
  y2: 1585.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-474",
  x1: 1183.07,
  y1: 1583.58,
  x2: 1186.57,
  y2: 1583.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-475",
  x1: 1190.43,
  y1: 1580.76,
  x2: 1193.93,
  y2: 1580.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-476",
  x1: 1197.79,
  y1: 1576.38,
  x2: 1201.29,
  y2: 1576.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-477",
  x1: 983.19,
  y1: 1556.7,
  x2: 1226.87,
  y2: 1556.7,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-478",
  x1: 1036.66,
  y1: 1474.85,
  x2: 1165.17,
  y2: 1600.01,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-479",
  x1: 1002.65,
  y1: 1551,
  x2: 1006.15,
  y2: 1551,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-480",
  x1: 1010.01,
  y1: 1555.38,
  x2: 1013.51,
  y2: 1555.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-481",
  x1: 1017.37,
  y1: 1558.2,
  x2: 1020.87,
  y2: 1558.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-482",
  x1: 1024.72,
  y1: 1560.34,
  x2: 1028.22,
  y2: 1560.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-483",
  x1: 1032.08,
  y1: 1562.04,
  x2: 1035.58,
  y2: 1562.04,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-484",
  x1: 1039.44,
  y1: 1563.43,
  x2: 1042.94,
  y2: 1563.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-485",
  x1: 1046.79,
  y1: 1564.57,
  x2: 1050.29,
  y2: 1564.57,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-486",
  x1: 1054.15,
  y1: 1565.5,
  x2: 1057.65,
  y2: 1565.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-487",
  x1: 1061.51,
  y1: 1566.24,
  x2: 1065.01,
  y2: 1566.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-488",
  x1: 1068.86,
  y1: 1566.82,
  x2: 1072.36,
  y2: 1566.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-489",
  x1: 1076.22,
  y1: 1567.24,
  x2: 1079.72,
  y2: 1567.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-490",
  x1: 1083.58,
  y1: 1567.51,
  x2: 1087.08,
  y2: 1567.51,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-491",
  x1: 1090.93,
  y1: 1567.65,
  x2: 1094.43,
  y2: 1567.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-492",
  x1: 1098.29,
  y1: 1567.65,
  x2: 1101.79,
  y2: 1567.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-493",
  x1: 1105.65,
  y1: 1567.51,
  x2: 1109.15,
  y2: 1567.51,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-494",
  x1: 1113,
  y1: 1567.24,
  x2: 1116.5,
  y2: 1567.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-495",
  x1: 1120.36,
  y1: 1566.82,
  x2: 1123.86,
  y2: 1566.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-496",
  x1: 1127.72,
  y1: 1566.24,
  x2: 1131.22,
  y2: 1566.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-497",
  x1: 1135.07,
  y1: 1565.5,
  x2: 1138.57,
  y2: 1565.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-498",
  x1: 1142.43,
  y1: 1564.57,
  x2: 1145.93,
  y2: 1564.57,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-499",
  x1: 1149.79,
  y1: 1563.43,
  x2: 1153.29,
  y2: 1563.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-500",
  x1: 1157.14,
  y1: 1562.04,
  x2: 1160.64,
  y2: 1562.04,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-501",
  x1: 1164.5,
  y1: 1560.34,
  x2: 1168,
  y2: 1560.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-502",
  x1: 1171.86,
  y1: 1558.2,
  x2: 1175.36,
  y2: 1558.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-503",
  x1: 1179.21,
  y1: 1555.38,
  x2: 1182.72,
  y2: 1555.38,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-504",
  x1: 1186.57,
  y1: 1551,
  x2: 1190.07,
  y2: 1551,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-505",
  x1: 994.4,
  y1: 1531.31,
  x2: 1238.09,
  y2: 1531.31,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-506",
  x1: 1047.88,
  y1: 1449.47,
  x2: 1176.38,
  y2: 1574.63,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-507",
  x1: 1013.87,
  y1: 1525.61,
  x2: 1017.37,
  y2: 1525.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-508",
  x1: 1021.22,
  y1: 1530,
  x2: 1024.72,
  y2: 1530,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-509",
  x1: 1028.58,
  y1: 1532.82,
  x2: 1032.08,
  y2: 1532.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-510",
  x1: 1035.94,
  y1: 1534.96,
  x2: 1039.44,
  y2: 1534.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-511",
  x1: 1043.29,
  y1: 1536.66,
  x2: 1046.79,
  y2: 1536.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-512",
  x1: 1050.65,
  y1: 1538.05,
  x2: 1054.15,
  y2: 1538.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-513",
  x1: 1058.01,
  y1: 1539.19,
  x2: 1061.51,
  y2: 1539.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-514",
  x1: 1065.36,
  y1: 1540.12,
  x2: 1068.86,
  y2: 1540.12,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-515",
  x1: 1072.72,
  y1: 1540.86,
  x2: 1076.22,
  y2: 1540.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-516",
  x1: 1080.08,
  y1: 1541.44,
  x2: 1083.58,
  y2: 1541.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-517",
  x1: 1087.43,
  y1: 1541.86,
  x2: 1090.93,
  y2: 1541.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-518",
  x1: 1094.79,
  y1: 1542.13,
  x2: 1098.29,
  y2: 1542.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-519",
  x1: 1102.15,
  y1: 1542.27,
  x2: 1105.65,
  y2: 1542.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-520",
  x1: 1109.5,
  y1: 1542.27,
  x2: 1113,
  y2: 1542.27,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-521",
  x1: 1116.86,
  y1: 1542.13,
  x2: 1120.36,
  y2: 1542.13,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-522",
  x1: 1124.22,
  y1: 1541.86,
  x2: 1127.72,
  y2: 1541.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-523",
  x1: 1131.57,
  y1: 1541.44,
  x2: 1135.07,
  y2: 1541.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-524",
  x1: 1138.93,
  y1: 1540.86,
  x2: 1142.43,
  y2: 1540.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-525",
  x1: 1146.29,
  y1: 1540.12,
  x2: 1149.79,
  y2: 1540.12,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-526",
  x1: 1153.64,
  y1: 1539.19,
  x2: 1157.14,
  y2: 1539.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-527",
  x1: 1161,
  y1: 1538.05,
  x2: 1164.5,
  y2: 1538.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-528",
  x1: 1168.36,
  y1: 1536.66,
  x2: 1171.86,
  y2: 1536.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-529",
  x1: 1175.71,
  y1: 1534.96,
  x2: 1179.21,
  y2: 1534.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-530",
  x1: 1183.07,
  y1: 1532.82,
  x2: 1186.57,
  y2: 1532.82,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-531",
  x1: 1190.43,
  y1: 1530,
  x2: 1193.93,
  y2: 1530,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-532",
  x1: 1197.79,
  y1: 1525.62,
  x2: 1201.29,
  y2: 1525.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-533",
  x1: 986.87,
  y1: 1505.93,
  x2: 1230.55,
  y2: 1505.93,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-534",
  x1: 1040.34,
  y1: 1424.09,
  x2: 1168.84,
  y2: 1549.25,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-535",
  x1: 1006.33,
  y1: 1500.23,
  x2: 1009.83,
  y2: 1500.23,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-536",
  x1: 1013.69,
  y1: 1504.62,
  x2: 1017.19,
  y2: 1504.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-537",
  x1: 1021.04,
  y1: 1507.44,
  x2: 1024.54,
  y2: 1507.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-538",
  x1: 1028.4,
  y1: 1509.58,
  x2: 1031.9,
  y2: 1509.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-539",
  x1: 1035.76,
  y1: 1511.28,
  x2: 1039.26,
  y2: 1511.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-540",
  x1: 1043.11,
  y1: 1512.67,
  x2: 1046.61,
  y2: 1512.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-541",
  x1: 1050.47,
  y1: 1513.81,
  x2: 1053.97,
  y2: 1513.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-542",
  x1: 1057.83,
  y1: 1514.74,
  x2: 1061.33,
  y2: 1514.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-543",
  x1: 1065.18,
  y1: 1515.48,
  x2: 1068.68,
  y2: 1515.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-544",
  x1: 1072.54,
  y1: 1516.05,
  x2: 1076.04,
  y2: 1516.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-545",
  x1: 1079.9,
  y1: 1516.47,
  x2: 1083.4,
  y2: 1516.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-546",
  x1: 1087.26,
  y1: 1516.75,
  x2: 1090.76,
  y2: 1516.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-547",
  x1: 1094.61,
  y1: 1516.88,
  x2: 1098.11,
  y2: 1516.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-548",
  x1: 1101.97,
  y1: 1516.88,
  x2: 1105.47,
  y2: 1516.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-549",
  x1: 1109.33,
  y1: 1516.75,
  x2: 1112.83,
  y2: 1516.75,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-550",
  x1: 1116.68,
  y1: 1516.47,
  x2: 1120.18,
  y2: 1516.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-551",
  x1: 1124.04,
  y1: 1516.05,
  x2: 1127.54,
  y2: 1516.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-552",
  x1: 1131.4,
  y1: 1515.48,
  x2: 1134.9,
  y2: 1515.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-553",
  x1: 1138.75,
  y1: 1514.74,
  x2: 1142.25,
  y2: 1514.74,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-554",
  x1: 1146.11,
  y1: 1513.81,
  x2: 1149.61,
  y2: 1513.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-555",
  x1: 1153.47,
  y1: 1512.67,
  x2: 1156.97,
  y2: 1512.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-556",
  x1: 1160.82,
  y1: 1511.28,
  x2: 1164.32,
  y2: 1511.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-557",
  x1: 1168.18,
  y1: 1509.58,
  x2: 1171.68,
  y2: 1509.58,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-558",
  x1: 1175.54,
  y1: 1507.44,
  x2: 1179.04,
  y2: 1507.44,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-559",
  x1: 1182.89,
  y1: 1504.62,
  x2: 1186.39,
  y2: 1504.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-560",
  x1: 1190.25,
  y1: 1500.24,
  x2: 1193.75,
  y2: 1500.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-561",
  x1: 1001.76,
  y1: 1480.55,
  x2: 1245.44,
  y2: 1480.55,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-562",
  x1: 1055.24,
  y1: 1398.71,
  x2: 1183.74,
  y2: 1523.87,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-563",
  x1: 1021.22,
  y1: 1474.85,
  x2: 1024.72,
  y2: 1474.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-564",
  x1: 1028.58,
  y1: 1479.24,
  x2: 1032.08,
  y2: 1479.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-565",
  x1: 1035.94,
  y1: 1482.06,
  x2: 1039.44,
  y2: 1482.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-566",
  x1: 1043.29,
  y1: 1484.2,
  x2: 1046.79,
  y2: 1484.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-567",
  x1: 1050.65,
  y1: 1485.9,
  x2: 1054.15,
  y2: 1485.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-568",
  x1: 1058.01,
  y1: 1487.29,
  x2: 1061.51,
  y2: 1487.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-569",
  x1: 1065.36,
  y1: 1488.43,
  x2: 1068.86,
  y2: 1488.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-570",
  x1: 1072.72,
  y1: 1489.36,
  x2: 1076.22,
  y2: 1489.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-571",
  x1: 1080.08,
  y1: 1490.1,
  x2: 1083.58,
  y2: 1490.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-572",
  x1: 1087.43,
  y1: 1490.67,
  x2: 1090.93,
  y2: 1490.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-573",
  x1: 1094.79,
  y1: 1491.09,
  x2: 1098.29,
  y2: 1491.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-574",
  x1: 1102.15,
  y1: 1491.37,
  x2: 1105.65,
  y2: 1491.37,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-575",
  x1: 1109.5,
  y1: 1491.5,
  x2: 1113,
  y2: 1491.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-576",
  x1: 1116.86,
  y1: 1491.5,
  x2: 1120.36,
  y2: 1491.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-577",
  x1: 1124.22,
  y1: 1491.37,
  x2: 1127.72,
  y2: 1491.37,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-578",
  x1: 1131.57,
  y1: 1491.09,
  x2: 1135.07,
  y2: 1491.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-579",
  x1: 1138.93,
  y1: 1490.67,
  x2: 1142.43,
  y2: 1490.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-580",
  x1: 1146.29,
  y1: 1490.1,
  x2: 1149.79,
  y2: 1490.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-581",
  x1: 1153.64,
  y1: 1489.36,
  x2: 1157.14,
  y2: 1489.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-582",
  x1: 1161,
  y1: 1488.43,
  x2: 1164.5,
  y2: 1488.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-583",
  x1: 1168.36,
  y1: 1487.29,
  x2: 1171.86,
  y2: 1487.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-584",
  x1: 1175.71,
  y1: 1485.9,
  x2: 1179.21,
  y2: 1485.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-585",
  x1: 1183.07,
  y1: 1484.2,
  x2: 1186.57,
  y2: 1484.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-586",
  x1: 1190.43,
  y1: 1482.06,
  x2: 1193.93,
  y2: 1482.06,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-587",
  x1: 1197.79,
  y1: 1479.24,
  x2: 1201.29,
  y2: 1479.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-588",
  x1: 1205.14,
  y1: 1474.86,
  x2: 1208.64,
  y2: 1474.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-589",
  x1: 990.72,
  y1: 1452.12,
  x2: 1234.41,
  y2: 1452.12,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-590",
  x1: 1044.2,
  y1: 1370.28,
  x2: 1172.7,
  y2: 1495.43,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-591",
  x1: 1010.19,
  y1: 1446.42,
  x2: 1013.69,
  y2: 1446.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-592",
  x1: 1017.54,
  y1: 1450.8,
  x2: 1021.04,
  y2: 1450.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-593",
  x1: 1024.9,
  y1: 1453.62,
  x2: 1028.4,
  y2: 1453.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-594",
  x1: 1032.26,
  y1: 1455.76,
  x2: 1035.76,
  y2: 1455.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-595",
  x1: 1039.61,
  y1: 1457.47,
  x2: 1043.11,
  y2: 1457.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-596",
  x1: 1046.97,
  y1: 1458.86,
  x2: 1050.47,
  y2: 1458.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-597",
  x1: 1054.33,
  y1: 1460,
  x2: 1057.83,
  y2: 1460,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-598",
  x1: 1061.69,
  y1: 1460.92,
  x2: 1065.18,
  y2: 1460.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-599",
  x1: 1069.04,
  y1: 1461.66,
  x2: 1072.54,
  y2: 1461.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-600",
  x1: 1076.4,
  y1: 1462.24,
  x2: 1079.9,
  y2: 1462.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-601",
  x1: 1083.76,
  y1: 1462.66,
  x2: 1087.26,
  y2: 1462.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-602",
  x1: 1091.11,
  y1: 1462.93,
  x2: 1094.61,
  y2: 1462.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-603",
  x1: 1098.47,
  y1: 1463.07,
  x2: 1101.97,
  y2: 1463.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-604",
  x1: 1105.83,
  y1: 1463.07,
  x2: 1109.33,
  y2: 1463.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-605",
  x1: 1113.18,
  y1: 1462.93,
  x2: 1116.68,
  y2: 1462.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-606",
  x1: 1120.54,
  y1: 1462.66,
  x2: 1124.04,
  y2: 1462.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-607",
  x1: 1127.9,
  y1: 1462.24,
  x2: 1131.4,
  y2: 1462.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-608",
  x1: 1135.25,
  y1: 1461.66,
  x2: 1138.75,
  y2: 1461.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-609",
  x1: 1142.61,
  y1: 1460.92,
  x2: 1146.11,
  y2: 1460.92,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-610",
  x1: 1149.97,
  y1: 1460,
  x2: 1153.47,
  y2: 1460,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-611",
  x1: 1157.32,
  y1: 1458.86,
  x2: 1160.82,
  y2: 1458.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-612",
  x1: 1164.68,
  y1: 1457.47,
  x2: 1168.18,
  y2: 1457.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-613",
  x1: 1172.04,
  y1: 1455.76,
  x2: 1175.54,
  y2: 1455.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-614",
  x1: 1179.39,
  y1: 1453.62,
  x2: 1182.89,
  y2: 1453.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-615",
  x1: 1186.75,
  y1: 1450.8,
  x2: 1190.25,
  y2: 1450.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-616",
  x1: 1194.11,
  y1: 1446.42,
  x2: 1197.61,
  y2: 1446.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-617",
  x1: 990.72,
  y1: 1423.66,
  x2: 1234.41,
  y2: 1423.66,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-618",
  x1: 1044.2,
  y1: 1341.82,
  x2: 1172.7,
  y2: 1466.97,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-619",
  x1: 1010.19,
  y1: 1417.96,
  x2: 1013.69,
  y2: 1417.96,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-620",
  x1: 1017.54,
  y1: 1422.34,
  x2: 1021.04,
  y2: 1422.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-621",
  x1: 1024.9,
  y1: 1425.16,
  x2: 1028.4,
  y2: 1425.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-622",
  x1: 1032.26,
  y1: 1427.3,
  x2: 1035.76,
  y2: 1427.3,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-623",
  x1: 1039.61,
  y1: 1429.01,
  x2: 1043.11,
  y2: 1429.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-624",
  x1: 1046.97,
  y1: 1430.4,
  x2: 1050.47,
  y2: 1430.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-625",
  x1: 1054.33,
  y1: 1431.54,
  x2: 1057.83,
  y2: 1431.54,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-626",
  x1: 1061.69,
  y1: 1432.46,
  x2: 1065.19,
  y2: 1432.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-627",
  x1: 1069.04,
  y1: 1433.21,
  x2: 1072.54,
  y2: 1433.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-628",
  x1: 1076.4,
  y1: 1433.78,
  x2: 1079.9,
  y2: 1433.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-629",
  x1: 1083.76,
  y1: 1434.2,
  x2: 1087.26,
  y2: 1434.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-630",
  x1: 1091.11,
  y1: 1434.48,
  x2: 1094.61,
  y2: 1434.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-631",
  x1: 1098.47,
  y1: 1434.61,
  x2: 1101.97,
  y2: 1434.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-632",
  x1: 1105.83,
  y1: 1434.61,
  x2: 1109.33,
  y2: 1434.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-633",
  x1: 1113.18,
  y1: 1434.48,
  x2: 1116.68,
  y2: 1434.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-634",
  x1: 1120.54,
  y1: 1434.2,
  x2: 1124.04,
  y2: 1434.2,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-635",
  x1: 1127.9,
  y1: 1433.78,
  x2: 1131.4,
  y2: 1433.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-636",
  x1: 1135.25,
  y1: 1433.21,
  x2: 1138.75,
  y2: 1433.21,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-637",
  x1: 1142.61,
  y1: 1432.46,
  x2: 1146.11,
  y2: 1432.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-638",
  x1: 1149.97,
  y1: 1431.54,
  x2: 1153.47,
  y2: 1431.54,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-639",
  x1: 1157.32,
  y1: 1430.4,
  x2: 1160.82,
  y2: 1430.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-640",
  x1: 1164.68,
  y1: 1429.01,
  x2: 1168.18,
  y2: 1429.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-641",
  x1: 1172.04,
  y1: 1427.3,
  x2: 1175.54,
  y2: 1427.3,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-642",
  x1: 1179.39,
  y1: 1425.17,
  x2: 1182.89,
  y2: 1425.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-643",
  x1: 1186.75,
  y1: 1422.34,
  x2: 1190.25,
  y2: 1422.34,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-644",
  x1: 1194.11,
  y1: 1417.97,
  x2: 1197.61,
  y2: 1417.97,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-645",
  x1: 983.17,
  y1: 1396.19,
  x2: 1226.86,
  y2: 1396.19,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-646",
  x1: 1036.65,
  y1: 1314.35,
  x2: 1165.15,
  y2: 1439.5,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-647",
  x1: 1002.63,
  y1: 1390.49,
  x2: 1006.13,
  y2: 1390.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-648",
  x1: 1009.99,
  y1: 1394.87,
  x2: 1013.49,
  y2: 1394.87,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-649",
  x1: 1017.35,
  y1: 1397.69,
  x2: 1020.85,
  y2: 1397.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-650",
  x1: 1024.7,
  y1: 1399.83,
  x2: 1028.2,
  y2: 1399.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-651",
  x1: 1032.06,
  y1: 1401.54,
  x2: 1035.56,
  y2: 1401.54,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-652",
  x1: 1039.42,
  y1: 1402.93,
  x2: 1042.92,
  y2: 1402.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-653",
  x1: 1046.78,
  y1: 1404.07,
  x2: 1050.28,
  y2: 1404.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-654",
  x1: 1054.13,
  y1: 1404.99,
  x2: 1057.63,
  y2: 1404.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-655",
  x1: 1061.49,
  y1: 1405.73,
  x2: 1064.99,
  y2: 1405.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-656",
  x1: 1068.85,
  y1: 1406.31,
  x2: 1072.35,
  y2: 1406.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-657",
  x1: 1076.2,
  y1: 1406.73,
  x2: 1079.7,
  y2: 1406.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-658",
  x1: 1083.56,
  y1: 1407,
  x2: 1087.06,
  y2: 1407,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-659",
  x1: 1090.92,
  y1: 1407.14,
  x2: 1094.42,
  y2: 1407.14,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-660",
  x1: 1098.27,
  y1: 1407.14,
  x2: 1101.77,
  y2: 1407.14,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-661",
  x1: 1105.63,
  y1: 1407,
  x2: 1109.13,
  y2: 1407,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-662",
  x1: 1112.99,
  y1: 1406.73,
  x2: 1116.49,
  y2: 1406.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-663",
  x1: 1120.34,
  y1: 1406.31,
  x2: 1123.84,
  y2: 1406.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-664",
  x1: 1127.7,
  y1: 1405.73,
  x2: 1131.2,
  y2: 1405.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-665",
  x1: 1135.06,
  y1: 1404.99,
  x2: 1138.56,
  y2: 1404.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-666",
  x1: 1142.41,
  y1: 1404.07,
  x2: 1145.91,
  y2: 1404.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-667",
  x1: 1149.77,
  y1: 1402.93,
  x2: 1153.27,
  y2: 1402.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-668",
  x1: 1157.13,
  y1: 1401.54,
  x2: 1160.63,
  y2: 1401.54,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-669",
  x1: 1164.48,
  y1: 1399.83,
  x2: 1167.98,
  y2: 1399.83,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-670",
  x1: 1171.84,
  y1: 1397.69,
  x2: 1175.34,
  y2: 1397.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-671",
  x1: 1179.2,
  y1: 1394.87,
  x2: 1182.7,
  y2: 1394.87,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-672",
  x1: 1186.55,
  y1: 1390.49,
  x2: 1190.05,
  y2: 1390.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-673",
  x1: 987.05,
  y1: 1370.81,
  x2: 1230.73,
  y2: 1370.81,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-674",
  x1: 1040.52,
  y1: 1288.97,
  x2: 1169.02,
  y2: 1414.12,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-675",
  x1: 1006.51,
  y1: 1365.11,
  x2: 1010.01,
  y2: 1365.11,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-676",
  x1: 1013.87,
  y1: 1369.49,
  x2: 1017.37,
  y2: 1369.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-677",
  x1: 1021.22,
  y1: 1372.31,
  x2: 1024.72,
  y2: 1372.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-678",
  x1: 1028.58,
  y1: 1374.45,
  x2: 1032.08,
  y2: 1374.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-679",
  x1: 1035.94,
  y1: 1376.16,
  x2: 1039.44,
  y2: 1376.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-680",
  x1: 1043.29,
  y1: 1377.55,
  x2: 1046.79,
  y2: 1377.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-681",
  x1: 1050.65,
  y1: 1378.69,
  x2: 1054.15,
  y2: 1378.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-682",
  x1: 1058.01,
  y1: 1379.61,
  x2: 1061.51,
  y2: 1379.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-683",
  x1: 1065.36,
  y1: 1380.35,
  x2: 1068.86,
  y2: 1380.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-684",
  x1: 1072.72,
  y1: 1380.93,
  x2: 1076.22,
  y2: 1380.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-685",
  x1: 1080.08,
  y1: 1381.35,
  x2: 1083.58,
  y2: 1381.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-686",
  x1: 1087.43,
  y1: 1381.62,
  x2: 1090.93,
  y2: 1381.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-687",
  x1: 1094.79,
  y1: 1381.76,
  x2: 1098.29,
  y2: 1381.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-688",
  x1: 1102.15,
  y1: 1381.76,
  x2: 1105.65,
  y2: 1381.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-689",
  x1: 1109.5,
  y1: 1381.62,
  x2: 1113,
  y2: 1381.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-690",
  x1: 1116.86,
  y1: 1381.35,
  x2: 1120.36,
  y2: 1381.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-691",
  x1: 1124.22,
  y1: 1380.93,
  x2: 1127.72,
  y2: 1380.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-692",
  x1: 1131.57,
  y1: 1380.35,
  x2: 1135.07,
  y2: 1380.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-693",
  x1: 1138.93,
  y1: 1379.61,
  x2: 1142.43,
  y2: 1379.61,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-694",
  x1: 1146.29,
  y1: 1378.69,
  x2: 1149.79,
  y2: 1378.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-695",
  x1: 1153.64,
  y1: 1377.55,
  x2: 1157.14,
  y2: 1377.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-696",
  x1: 1161,
  y1: 1376.16,
  x2: 1164.5,
  y2: 1376.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-697",
  x1: 1168.36,
  y1: 1374.45,
  x2: 1171.86,
  y2: 1374.45,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-698",
  x1: 1175.71,
  y1: 1372.31,
  x2: 1179.22,
  y2: 1372.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-699",
  x1: 1183.07,
  y1: 1369.49,
  x2: 1186.57,
  y2: 1369.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-700",
  x1: 1190.43,
  y1: 1365.11,
  x2: 1193.93,
  y2: 1365.11,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-701",
  x1: 992.65,
  y1: 1344.34,
  x2: 1236.34,
  y2: 1344.34,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-702",
  x1: 1046.13,
  y1: 1262.5,
  x2: 1174.63,
  y2: 1387.65,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-703",
  x1: 1012.12,
  y1: 1338.64,
  x2: 1015.62,
  y2: 1338.64,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-704",
  x1: 1019.47,
  y1: 1343.03,
  x2: 1022.97,
  y2: 1343.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-705",
  x1: 1026.83,
  y1: 1345.85,
  x2: 1030.33,
  y2: 1345.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-706",
  x1: 1034.19,
  y1: 1347.99,
  x2: 1037.69,
  y2: 1347.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-707",
  x1: 1041.54,
  y1: 1349.69,
  x2: 1045.04,
  y2: 1349.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-708",
  x1: 1048.9,
  y1: 1351.08,
  x2: 1052.4,
  y2: 1351.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-709",
  x1: 1056.26,
  y1: 1352.22,
  x2: 1059.76,
  y2: 1352.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-710",
  x1: 1063.61,
  y1: 1353.15,
  x2: 1067.11,
  y2: 1353.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-711",
  x1: 1070.97,
  y1: 1353.89,
  x2: 1074.47,
  y2: 1353.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-712",
  x1: 1078.33,
  y1: 1354.46,
  x2: 1081.83,
  y2: 1354.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-713",
  x1: 1085.68,
  y1: 1354.88,
  x2: 1089.18,
  y2: 1354.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-714",
  x1: 1093.04,
  y1: 1355.16,
  x2: 1096.54,
  y2: 1355.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-715",
  x1: 1100.4,
  y1: 1355.29,
  x2: 1103.9,
  y2: 1355.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-716",
  x1: 1107.75,
  y1: 1355.29,
  x2: 1111.25,
  y2: 1355.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-717",
  x1: 1115.11,
  y1: 1355.16,
  x2: 1118.61,
  y2: 1355.16,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-718",
  x1: 1122.47,
  y1: 1354.88,
  x2: 1125.97,
  y2: 1354.88,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-719",
  x1: 1129.82,
  y1: 1354.46,
  x2: 1133.32,
  y2: 1354.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-720",
  x1: 1137.18,
  y1: 1353.89,
  x2: 1140.68,
  y2: 1353.89,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-721",
  x1: 1144.54,
  y1: 1353.15,
  x2: 1148.04,
  y2: 1353.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-722",
  x1: 1151.89,
  y1: 1352.22,
  x2: 1155.39,
  y2: 1352.22,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-723",
  x1: 1159.25,
  y1: 1351.08,
  x2: 1162.75,
  y2: 1351.08,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-724",
  x1: 1166.61,
  y1: 1349.69,
  x2: 1170.11,
  y2: 1349.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-725",
  x1: 1173.96,
  y1: 1347.99,
  x2: 1177.46,
  y2: 1347.99,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-726",
  x1: 1181.32,
  y1: 1345.85,
  x2: 1184.82,
  y2: 1345.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-727",
  x1: 1188.68,
  y1: 1343.03,
  x2: 1192.18,
  y2: 1343.03,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-728",
  x1: 1196.04,
  y1: 1338.65,
  x2: 1199.54,
  y2: 1338.65,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-729",
  x1: 983.37,
  y1: 1316.36,
  x2: 1227.05,
  y2: 1316.36,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-730",
  x1: 1036.84,
  y1: 1234.52,
  x2: 1165.34,
  y2: 1359.67,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-731",
  x1: 1002.83,
  y1: 1310.66,
  x2: 1006.33,
  y2: 1310.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-732",
  x1: 1010.19,
  y1: 1315.04,
  x2: 1013.69,
  y2: 1315.04,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-733",
  x1: 1017.54,
  y1: 1317.87,
  x2: 1021.04,
  y2: 1317.87,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-734",
  x1: 1024.9,
  y1: 1320,
  x2: 1028.4,
  y2: 1320,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-735",
  x1: 1032.26,
  y1: 1321.71,
  x2: 1035.76,
  y2: 1321.71,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-736",
  x1: 1039.61,
  y1: 1323.1,
  x2: 1043.11,
  y2: 1323.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-737",
  x1: 1046.97,
  y1: 1324.24,
  x2: 1050.47,
  y2: 1324.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-738",
  x1: 1054.33,
  y1: 1325.17,
  x2: 1057.83,
  y2: 1325.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-739",
  x1: 1061.69,
  y1: 1325.91,
  x2: 1065.19,
  y2: 1325.91,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-740",
  x1: 1069.04,
  y1: 1326.48,
  x2: 1072.54,
  y2: 1326.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-741",
  x1: 1076.4,
  y1: 1326.9,
  x2: 1079.9,
  y2: 1326.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-742",
  x1: 1083.76,
  y1: 1327.18,
  x2: 1087.26,
  y2: 1327.18,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-743",
  x1: 1091.11,
  y1: 1327.31,
  x2: 1094.61,
  y2: 1327.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-744",
  x1: 1098.47,
  y1: 1327.31,
  x2: 1101.97,
  y2: 1327.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-745",
  x1: 1105.83,
  y1: 1327.18,
  x2: 1109.33,
  y2: 1327.18,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-746",
  x1: 1113.18,
  y1: 1326.9,
  x2: 1116.68,
  y2: 1326.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-747",
  x1: 1120.54,
  y1: 1326.48,
  x2: 1124.04,
  y2: 1326.48,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-748",
  x1: 1127.9,
  y1: 1325.91,
  x2: 1131.4,
  y2: 1325.91,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-749",
  x1: 1135.25,
  y1: 1325.17,
  x2: 1138.75,
  y2: 1325.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-750",
  x1: 1142.61,
  y1: 1324.24,
  x2: 1146.11,
  y2: 1324.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-751",
  x1: 1149.97,
  y1: 1323.1,
  x2: 1153.47,
  y2: 1323.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-752",
  x1: 1157.32,
  y1: 1321.71,
  x2: 1160.82,
  y2: 1321.71,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-753",
  x1: 1164.68,
  y1: 1320,
  x2: 1168.18,
  y2: 1320,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-754",
  x1: 1172.04,
  y1: 1317.87,
  x2: 1175.54,
  y2: 1317.87,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-755",
  x1: 1179.39,
  y1: 1315.05,
  x2: 1182.89,
  y2: 1315.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-756",
  x1: 1186.75,
  y1: 1310.67,
  x2: 1190.25,
  y2: 1310.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-757",
  x1: 988.97,
  y1: 1290.98,
  x2: 1232.66,
  y2: 1290.98,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-758",
  x1: 1042.45,
  y1: 1209.14,
  x2: 1170.95,
  y2: 1334.29,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-759",
  x1: 1008.44,
  y1: 1285.28,
  x2: 1011.94,
  y2: 1285.28,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-760",
  x1: 1015.79,
  y1: 1289.66,
  x2: 1019.29,
  y2: 1289.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-761",
  x1: 1023.15,
  y1: 1292.49,
  x2: 1026.65,
  y2: 1292.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-762",
  x1: 1030.51,
  y1: 1294.62,
  x2: 1034.01,
  y2: 1294.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-763",
  x1: 1037.86,
  y1: 1296.33,
  x2: 1041.36,
  y2: 1296.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-764",
  x1: 1045.22,
  y1: 1297.72,
  x2: 1048.72,
  y2: 1297.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-765",
  x1: 1052.58,
  y1: 1298.86,
  x2: 1056.08,
  y2: 1298.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-766",
  x1: 1059.94,
  y1: 1299.78,
  x2: 1063.44,
  y2: 1299.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-767",
  x1: 1067.29,
  y1: 1300.53,
  x2: 1070.79,
  y2: 1300.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-768",
  x1: 1074.65,
  y1: 1301.1,
  x2: 1078.15,
  y2: 1301.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-769",
  x1: 1082.01,
  y1: 1301.52,
  x2: 1085.51,
  y2: 1301.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-770",
  x1: 1089.36,
  y1: 1301.8,
  x2: 1092.86,
  y2: 1301.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-771",
  x1: 1096.72,
  y1: 1301.93,
  x2: 1100.22,
  y2: 1301.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-772",
  x1: 1104.08,
  y1: 1301.93,
  x2: 1107.58,
  y2: 1301.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-773",
  x1: 1111.43,
  y1: 1301.8,
  x2: 1114.93,
  y2: 1301.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-774",
  x1: 1118.79,
  y1: 1301.52,
  x2: 1122.29,
  y2: 1301.52,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-775",
  x1: 1126.15,
  y1: 1301.1,
  x2: 1129.65,
  y2: 1301.1,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-776",
  x1: 1133.5,
  y1: 1300.53,
  x2: 1137,
  y2: 1300.53,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-777",
  x1: 1140.86,
  y1: 1299.78,
  x2: 1144.36,
  y2: 1299.78,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-778",
  x1: 1148.22,
  y1: 1298.86,
  x2: 1151.72,
  y2: 1298.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-779",
  x1: 1155.57,
  y1: 1297.72,
  x2: 1159.07,
  y2: 1297.72,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-780",
  x1: 1162.93,
  y1: 1296.33,
  x2: 1166.43,
  y2: 1296.33,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-781",
  x1: 1170.29,
  y1: 1294.62,
  x2: 1173.79,
  y2: 1294.62,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-782",
  x1: 1177.64,
  y1: 1292.49,
  x2: 1181.14,
  y2: 1292.49,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-783",
  x1: 1185,
  y1: 1289.66,
  x2: 1188.5,
  y2: 1289.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-784",
  x1: 1192.36,
  y1: 1285.29,
  x2: 1195.86,
  y2: 1285.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-785",
  x1: 977.58,
  y1: 1263.05,
  x2: 1221.27,
  y2: 1263.05,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-786",
  x1: 1031.06,
  y1: 1181.21,
  x2: 1159.56,
  y2: 1306.36,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-787",
  x1: 997.05,
  y1: 1257.35,
  x2: 1000.55,
  y2: 1257.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-788",
  x1: 1004.4,
  y1: 1261.73,
  x2: 1007.9,
  y2: 1261.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-789",
  x1: 1011.76,
  y1: 1264.55,
  x2: 1015.26,
  y2: 1264.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-790",
  x1: 1019.12,
  y1: 1266.69,
  x2: 1022.62,
  y2: 1266.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-791",
  x1: 1026.47,
  y1: 1268.4,
  x2: 1029.97,
  y2: 1268.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-792",
  x1: 1033.83,
  y1: 1269.79,
  x2: 1037.33,
  y2: 1269.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-793",
  x1: 1041.19,
  y1: 1270.93,
  x2: 1044.69,
  y2: 1270.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-794",
  x1: 1048.54,
  y1: 1271.85,
  x2: 1052.04,
  y2: 1271.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-795",
  x1: 1055.9,
  y1: 1272.59,
  x2: 1059.4,
  y2: 1272.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-796",
  x1: 1063.26,
  y1: 1273.17,
  x2: 1066.76,
  y2: 1273.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-797",
  x1: 1070.61,
  y1: 1273.59,
  x2: 1074.11,
  y2: 1273.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-798",
  x1: 1077.97,
  y1: 1273.86,
  x2: 1081.47,
  y2: 1273.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-799",
  x1: 1085.33,
  y1: 1274,
  x2: 1088.83,
  y2: 1274,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-800",
  x1: 1092.68,
  y1: 1274,
  x2: 1096.18,
  y2: 1274,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-801",
  x1: 1100.04,
  y1: 1273.86,
  x2: 1103.54,
  y2: 1273.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-802",
  x1: 1107.4,
  y1: 1273.59,
  x2: 1110.9,
  y2: 1273.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-803",
  x1: 1114.75,
  y1: 1273.17,
  x2: 1118.25,
  y2: 1273.17,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-804",
  x1: 1122.11,
  y1: 1272.59,
  x2: 1125.61,
  y2: 1272.59,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-805",
  x1: 1129.47,
  y1: 1271.85,
  x2: 1132.97,
  y2: 1271.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-806",
  x1: 1136.82,
  y1: 1270.93,
  x2: 1140.32,
  y2: 1270.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-807",
  x1: 1144.18,
  y1: 1269.79,
  x2: 1147.68,
  y2: 1269.79,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-808",
  x1: 1151.54,
  y1: 1268.4,
  x2: 1155.04,
  y2: 1268.4,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-809",
  x1: 1158.89,
  y1: 1266.69,
  x2: 1162.39,
  y2: 1266.69,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-810",
  x1: 1166.25,
  y1: 1264.55,
  x2: 1169.75,
  y2: 1264.55,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-811",
  x1: 1173.61,
  y1: 1261.73,
  x2: 1177.11,
  y2: 1261.73,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-812",
  x1: 1180.96,
  y1: 1257.35,
  x2: 1184.47,
  y2: 1257.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-813",
  x1: 992.3,
  y1: 1239.51,
  x2: 1235.98,
  y2: 1239.51,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-814",
  x1: 1045.77,
  y1: 1157.67,
  x2: 1174.27,
  y2: 1282.82,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-815",
  x1: 1011.76,
  y1: 1233.81,
  x2: 1015.26,
  y2: 1233.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-816",
  x1: 1019.12,
  y1: 1238.19,
  x2: 1022.62,
  y2: 1238.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-817",
  x1: 1026.47,
  y1: 1241.01,
  x2: 1029.97,
  y2: 1241.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-818",
  x1: 1033.83,
  y1: 1243.15,
  x2: 1037.33,
  y2: 1243.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-819",
  x1: 1041.19,
  y1: 1244.86,
  x2: 1044.69,
  y2: 1244.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-820",
  x1: 1048.54,
  y1: 1246.25,
  x2: 1052.04,
  y2: 1246.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-821",
  x1: 1055.9,
  y1: 1247.39,
  x2: 1059.4,
  y2: 1247.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-822",
  x1: 1063.26,
  y1: 1248.31,
  x2: 1066.76,
  y2: 1248.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-823",
  x1: 1070.61,
  y1: 1249.05,
  x2: 1074.11,
  y2: 1249.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-824",
  x1: 1077.97,
  y1: 1249.63,
  x2: 1081.47,
  y2: 1249.63,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-825",
  x1: 1085.33,
  y1: 1250.05,
  x2: 1088.83,
  y2: 1250.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-826",
  x1: 1092.68,
  y1: 1250.32,
  x2: 1096.18,
  y2: 1250.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-827",
  x1: 1100.04,
  y1: 1250.46,
  x2: 1103.54,
  y2: 1250.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-828",
  x1: 1107.4,
  y1: 1250.46,
  x2: 1110.9,
  y2: 1250.46,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-829",
  x1: 1114.75,
  y1: 1250.32,
  x2: 1118.25,
  y2: 1250.32,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-830",
  x1: 1122.11,
  y1: 1250.05,
  x2: 1125.61,
  y2: 1250.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-831",
  x1: 1129.47,
  y1: 1249.63,
  x2: 1132.97,
  y2: 1249.63,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-832",
  x1: 1136.82,
  y1: 1249.05,
  x2: 1140.32,
  y2: 1249.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-833",
  x1: 1144.18,
  y1: 1248.31,
  x2: 1147.68,
  y2: 1248.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-834",
  x1: 1151.54,
  y1: 1247.39,
  x2: 1155.04,
  y2: 1247.39,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-835",
  x1: 1158.89,
  y1: 1246.25,
  x2: 1162.39,
  y2: 1246.25,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-836",
  x1: 1166.25,
  y1: 1244.86,
  x2: 1169.75,
  y2: 1244.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-837",
  x1: 1173.61,
  y1: 1243.15,
  x2: 1177.11,
  y2: 1243.15,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-838",
  x1: 1180.96,
  y1: 1241.01,
  x2: 1184.47,
  y2: 1241.01,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-839",
  x1: 1188.32,
  y1: 1238.19,
  x2: 1191.82,
  y2: 1238.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-840",
  x1: 1195.68,
  y1: 1233.81,
  x2: 1199.18,
  y2: 1233.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-841",
  x1: 983.55,
  y1: 1211.55,
  x2: 1227.23,
  y2: 1211.55,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-842",
  x1: 1037.02,
  y1: 1129.71,
  x2: 1165.52,
  y2: 1254.86,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-843",
  x1: 1003.01,
  y1: 1205.85,
  x2: 1006.51,
  y2: 1205.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-844",
  x1: 1010.37,
  y1: 1210.23,
  x2: 1013.87,
  y2: 1210.23,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-845",
  x1: 1017.72,
  y1: 1213.05,
  x2: 1021.22,
  y2: 1213.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-846",
  x1: 1025.08,
  y1: 1215.19,
  x2: 1028.58,
  y2: 1215.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-847",
  x1: 1032.44,
  y1: 1216.9,
  x2: 1035.94,
  y2: 1216.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-848",
  x1: 1039.79,
  y1: 1218.29,
  x2: 1043.29,
  y2: 1218.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-849",
  x1: 1047.15,
  y1: 1219.43,
  x2: 1050.65,
  y2: 1219.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-850",
  x1: 1054.51,
  y1: 1220.35,
  x2: 1058.01,
  y2: 1220.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-851",
  x1: 1061.86,
  y1: 1221.09,
  x2: 1065.36,
  y2: 1221.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-852",
  x1: 1069.22,
  y1: 1221.67,
  x2: 1072.72,
  y2: 1221.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-853",
  x1: 1076.58,
  y1: 1222.09,
  x2: 1080.08,
  y2: 1222.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-854",
  x1: 1083.93,
  y1: 1222.36,
  x2: 1087.43,
  y2: 1222.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-855",
  x1: 1091.29,
  y1: 1222.5,
  x2: 1094.79,
  y2: 1222.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-856",
  x1: 1098.65,
  y1: 1222.5,
  x2: 1102.15,
  y2: 1222.5,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-857",
  x1: 1106,
  y1: 1222.36,
  x2: 1109.5,
  y2: 1222.36,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-858",
  x1: 1113.36,
  y1: 1222.09,
  x2: 1116.86,
  y2: 1222.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-859",
  x1: 1120.72,
  y1: 1221.67,
  x2: 1124.22,
  y2: 1221.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-860",
  x1: 1128.07,
  y1: 1221.09,
  x2: 1131.57,
  y2: 1221.09,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-861",
  x1: 1135.43,
  y1: 1220.35,
  x2: 1138.93,
  y2: 1220.35,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-862",
  x1: 1142.79,
  y1: 1219.43,
  x2: 1146.29,
  y2: 1219.43,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-863",
  x1: 1150.14,
  y1: 1218.29,
  x2: 1153.64,
  y2: 1218.29,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-864",
  x1: 1157.5,
  y1: 1216.9,
  x2: 1161,
  y2: 1216.9,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-865",
  x1: 1164.86,
  y1: 1215.19,
  x2: 1168.36,
  y2: 1215.19,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-866",
  x1: 1172.21,
  y1: 1213.05,
  x2: 1175.72,
  y2: 1213.05,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-867",
  x1: 1179.57,
  y1: 1210.23,
  x2: 1183.07,
  y2: 1210.23,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-868",
  x1: 1186.93,
  y1: 1205.85,
  x2: 1190.43,
  y2: 1205.85,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-869",
  x1: 986.87,
  y1: 1184.12,
  x2: 1230.55,
  y2: 1184.12,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-870",
  x1: 1040.34,
  y1: 1102.28,
  x2: 1168.84,
  y2: 1227.43,
  xlinkHref: "#linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-871",
  x1: 1006.33,
  y1: 1178.42,
  x2: 1009.83,
  y2: 1178.42,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-872",
  x1: 1013.69,
  y1: 1182.8,
  x2: 1017.19,
  y2: 1182.8,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-873",
  x1: 1021.04,
  y1: 1185.63,
  x2: 1024.54,
  y2: 1185.63,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-874",
  x1: 1028.4,
  y1: 1187.76,
  x2: 1031.9,
  y2: 1187.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-875",
  x1: 1035.76,
  y1: 1189.47,
  x2: 1039.26,
  y2: 1189.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-876",
  x1: 1043.11,
  y1: 1190.86,
  x2: 1046.61,
  y2: 1190.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-877",
  x1: 1050.47,
  y1: 1192,
  x2: 1053.97,
  y2: 1192,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-878",
  x1: 1057.83,
  y1: 1192.93,
  x2: 1061.33,
  y2: 1192.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-879",
  x1: 1065.18,
  y1: 1193.67,
  x2: 1068.68,
  y2: 1193.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-880",
  x1: 1072.54,
  y1: 1194.24,
  x2: 1076.04,
  y2: 1194.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-881",
  x1: 1079.9,
  y1: 1194.66,
  x2: 1083.4,
  y2: 1194.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-882",
  x1: 1087.26,
  y1: 1194.94,
  x2: 1090.76,
  y2: 1194.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-883",
  x1: 1094.61,
  y1: 1195.07,
  x2: 1098.11,
  y2: 1195.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-884",
  x1: 1101.97,
  y1: 1195.07,
  x2: 1105.47,
  y2: 1195.07,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-885",
  x1: 1109.33,
  y1: 1194.94,
  x2: 1112.83,
  y2: 1194.94,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-886",
  x1: 1116.68,
  y1: 1194.66,
  x2: 1120.18,
  y2: 1194.66,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-887",
  x1: 1124.04,
  y1: 1194.24,
  x2: 1127.54,
  y2: 1194.24,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-888",
  x1: 1131.4,
  y1: 1193.67,
  x2: 1134.9,
  y2: 1193.67,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-889",
  x1: 1138.75,
  y1: 1192.93,
  x2: 1142.25,
  y2: 1192.93,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-890",
  x1: 1146.11,
  y1: 1192,
  x2: 1149.61,
  y2: 1192,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-891",
  x1: 1153.47,
  y1: 1190.86,
  x2: 1156.97,
  y2: 1190.86,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-892",
  x1: 1160.82,
  y1: 1189.47,
  x2: 1164.32,
  y2: 1189.47,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-893",
  x1: 1168.18,
  y1: 1187.76,
  x2: 1171.68,
  y2: 1187.76,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-894",
  x1: 1175.54,
  y1: 1185.63,
  x2: 1179.04,
  y2: 1185.63,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-895",
  x1: 1182.89,
  y1: 1182.81,
  x2: 1186.39,
  y2: 1182.81,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-896",
  x1: 1190.25,
  y1: 1178.43,
  x2: 1193.75,
  y2: 1178.43,
  xlinkHref: "#linear-gradient-3"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g3",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "g3-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("image", {
  width: 328,
  height: 757,
  transform: "translate(282.97) scale(2.09)",
  xlinkHref: "data:image/png;base64,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"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-1",
  d: "M208.77,1593.13v0a7.52,7.52,0,0,1-2.26,5,19,19,0,0,1-3.5,2.92,35.87,35.87,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.11.39-2.28.78-3.5,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.6-3.86.89c-1.14.25-2.31.5-3.5.73s-2.55.49-3.86.73l-3.5.6-3.85.59-3.5.49-3.86.49c-1.15.13-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.85.3s-2.33.17-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.11-3.86.15s-2.32.07-3.5.09-2.56.06-3.85.07l-3.5,0h-3.86l-3.5,0c-1.29,0-2.58,0-3.86-.07s-2.34-.06-3.5-.09-2.58-.09-3.85-.15l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.19-3.86-.3l-3.5-.31-3.85-.39-3.5-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.6-.47-3.85-.72s-2.36-.48-3.5-.74c-1.32-.28-2.61-.58-3.86-.89s-2.37-.59-3.5-.9c-1.33-.36-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.86-1.47s-2.41-1.05-3.5-1.59a34.07,34.07,0,0,1-3.85-2.21,18.29,18.29,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.85.37,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.86-.49c1.15-.13,2.32-.27,3.5-.39s2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07,3.5,0h3.86c1.17,0,2.33,0,3.5,0l3.85.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.86.22l3.5.23,3.85.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.86.48l3.5.49,1.39.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.86-.38,3.5-.36,3.85-.38,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M208.77,1592.2c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-3",
  cx: 112.78,
  cy: 1568.95,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M112.78,1545.68c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.77,19l84.68-41.19C133,1546.08,123.07,1545.68,112.78,1545.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M112.78,1590.8c-52,0-94.36-10-95.91-22.56a5.65,5.65,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0-.05-.71C207.14,1580.76,164.8,1590.8,112.78,1590.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-6",
  d: "M21.87,1577.4l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.74,1.74,0,0,0,.51,1.24l0,0a1.74,1.74,0,0,0,2.95-1.24V1578.8A1.73,1.73,0,0,0,21.87,1577.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-7",
  d: "M28.9,1581.24l0,0a1.74,1.74,0,0,0-2.42,1.59v17.06a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,28.9,1581.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-8",
  d: "M36.1,1583.92h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.74,1.74,0,0,0,36.1,1583.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-9",
  d: "M43.35,1586h0a1.73,1.73,0,0,0-2.16,1.68V1605a1.73,1.73,0,0,0,1.29,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,43.35,1586Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-10",
  d: "M50.63,1587.66h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.37,1.69h0a1.73,1.73,0,0,0,2.09-1.7v-17.32A1.73,1.73,0,0,0,50.63,1587.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-11",
  d: "M57.93,1589h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.72,1.72,0,0,0,2-1.7v-17.36A1.75,1.75,0,0,0,57.93,1589Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-12",
  d: "M65.24,1590.15h0a1.73,1.73,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.71h0a1.73,1.73,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,65.24,1590.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-13",
  d: "M72.54,1591.06h0a1.72,1.72,0,0,0-1.92,1.72v17.38a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,72.54,1591.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-14",
  d: "M79.86,1591.79h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.73,1.73,0,0,0,1.58,1.72h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.73,1.73,0,0,0,79.86,1591.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-15",
  d: "M87.18,1592.36h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,87.18,1592.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-16",
  d: "M94.5,1592.78h0a1.74,1.74,0,0,0-1.81,1.74v17.4a1.73,1.73,0,0,0,1.64,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.4A1.73,1.73,0,0,0,94.5,1592.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-17",
  d: "M101.83,1593.05h0a1.73,1.73,0,0,0-1.78,1.73v17.41a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,101.83,1593.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-18",
  d: "M109.15,1593.18h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.72,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,109.15,1593.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-19",
  d: "M116.48,1593.18h0a1.73,1.73,0,0,0-1.71,1.73v17.41a1.73,1.73,0,0,0,1.74,1.74h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,116.48,1593.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-20",
  d: "M123.8,1593.05h0a1.73,1.73,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.79,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,123.8,1593.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-21",
  d: "M131.13,1592.77h0a1.74,1.74,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73V1594.5A1.74,1.74,0,0,0,131.13,1592.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-22",
  d: "M138.45,1592.36h0a1.72,1.72,0,0,0-1.61,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.41A1.73,1.73,0,0,0,138.45,1592.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-23",
  d: "M145.77,1591.79h0a1.74,1.74,0,0,0-1.58,1.72v17.41a1.74,1.74,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.72,1.72,0,0,0,145.77,1591.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-24",
  d: "M153.09,1591.05h0a1.72,1.72,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.4A1.73,1.73,0,0,0,153.09,1591.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-25",
  d: "M160.39,1590.14h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.5-1.72v-17.38A1.73,1.73,0,0,0,160.39,1590.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-26",
  d: "M167.7,1589h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.7v-17.37A1.73,1.73,0,0,0,167.7,1589Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-27",
  d: "M175,1587.64h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,175,1587.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-28",
  d: "M182.28,1586h0a1.73,1.73,0,0,0-1.3,1.68V1605a1.74,1.74,0,0,0,2.17,1.68h0a1.74,1.74,0,0,0,1.3-1.68v-17.31A1.74,1.74,0,0,0,182.28,1586Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-29",
  d: "M189.53,1583.9h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.17-1.64v-17.24A1.73,1.73,0,0,0,189.53,1583.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-30",
  d: "M196.73,1581.21h0a1.74,1.74,0,0,0-1,1.59v17.09a1.74,1.74,0,0,0,2.46,1.58l0,0a1.71,1.71,0,0,0,1-1.56V1582.8A1.73,1.73,0,0,0,196.73,1581.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-31",
  d: "M203.76,1577.35l0,0a1.74,1.74,0,0,0-.71,1.41v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.77,1.77,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,203.76,1577.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-32",
  d: "M197.56,1567.75v0a7.49,7.49,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,35.68,35.68,0,0,1-3.85,2.2c-1.09.54-2.26,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.39-2.29.78-3.5,1.15s-2.52.76-3.86,1.12c-1.13.31-2.3.61-3.5.9s-2.53.6-3.85.89c-1.15.25-2.31.5-3.5.73s-2.55.49-3.86.73l-3.5.6c-1.26.2-2.55.4-3.86.59l-3.5.49-3.85.49c-1.16.13-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.86.3s-2.32.16-3.5.24l-3.85.22-3.5.16c-1.28.06-2.57.1-3.86.15s-2.33.07-3.5.09-2.57.06-3.86.07l-3.5,0H99.66l-3.5,0c-1.3,0-2.58,0-3.86-.07s-2.34-.06-3.5-.09-2.58-.09-3.86-.15l-3.5-.16-3.85-.22-3.5-.24c-1.3-.09-2.59-.19-3.86-.3l-3.5-.31-3.86-.39-3.5-.4c-1.3-.15-2.59-.32-3.86-.48L52,1587.7c-1.31-.19-2.6-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.28-2.6-.58-3.86-.89s-2.36-.59-3.5-.9c-1.33-.36-2.61-.74-3.85-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a34.25,34.25,0,0,1-3.86-2.21,18.61,18.61,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.17,2.26.22,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,2.74.27,1.12-.16,3.49-.49,3.86-.49c1.16-.13,2.32-.27,3.5-.39s2.56-.27,3.86-.39c1.15-.11,2.32-.22,3.5-.31l3.86-.31,3.5-.23,3.85-.22,3.5-.17,3.86-.14,3.5-.1,3.86-.07c1.16,0,2.32,0,3.5,0h3.85c1.17,0,2.34,0,3.5,0l3.86.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.85.22l3.5.23,3.86.3,3.5.31,3.86.39,3.5.4c1.3.15,2.58.32,3.85.48l3.5.49,1.4.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.85-.38,3.5-.36,3.86-.38,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,2.24-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M197.56,1566.82c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-33",
  cx: 101.57,
  cy: 1543.57,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M101.57,1520.3c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.76,19l84.69-41.19C121.77,1520.69,111.86,1520.3,101.57,1520.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M101.57,1565.42c-52,0-94.37-10-95.92-22.56a5.53,5.53,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.52,5.52,0,0,0-.05-.71C195.93,1555.38,153.58,1565.42,101.57,1565.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-34",
  d: "M10.66,1552l0,0a1.74,1.74,0,0,0-2.75,1.4v16.35a1.75,1.75,0,0,0,.52,1.24l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.72,1.72,0,0,0,10.66,1552Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-35",
  d: "M17.69,1555.86l0,0a1.74,1.74,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.73,1.73,0,0,0,17.69,1555.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-36",
  d: "M24.88,1558.54h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.73,1.73,0,0,0,1.18,1.65h0a1.74,1.74,0,0,0,2.29-1.64v-17.22A1.74,1.74,0,0,0,24.88,1558.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-37",
  d: "M32.14,1560.61h0a1.74,1.74,0,0,0-2.17,1.68v17.29a1.74,1.74,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.16-1.68v-17.29A1.73,1.73,0,0,0,32.14,1560.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-38",
  d: "M39.42,1562.28h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.73,1.73,0,0,0,1.38,1.69h0a1.73,1.73,0,0,0,2.09-1.7V1564A1.73,1.73,0,0,0,39.42,1562.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-39",
  d: "M46.72,1563.64h0a1.73,1.73,0,0,0-2,1.71v17.35a1.74,1.74,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.7v-17.36A1.74,1.74,0,0,0,46.72,1563.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-40",
  d: "M54,1564.76h0a1.73,1.73,0,0,0-2,1.72v17.37a1.72,1.72,0,0,0,1.49,1.71h0a1.73,1.73,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,54,1564.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-41",
  d: "M61.33,1565.68h0a1.73,1.73,0,0,0-1.93,1.72v17.38a1.73,1.73,0,0,0,1.54,1.72h0a1.74,1.74,0,0,0,1.93-1.72V1567.4A1.73,1.73,0,0,0,61.33,1565.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-42",
  d: "M68.65,1566.41h0a1.73,1.73,0,0,0-1.88,1.72v17.4a1.73,1.73,0,0,0,1.57,1.72h0a1.74,1.74,0,0,0,1.89-1.73v-17.39A1.74,1.74,0,0,0,68.65,1566.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-43",
  d: "M76,1567h0a1.72,1.72,0,0,0-1.84,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.74,1.74,0,0,0,1.86-1.73v-17.4A1.74,1.74,0,0,0,76,1567Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-44",
  d: "M83.29,1567.4h0a1.74,1.74,0,0,0-1.81,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.81-1.73v-17.4A1.73,1.73,0,0,0,83.29,1567.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-45",
  d: "M90.61,1567.67h0a1.72,1.72,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.73V1569.4A1.73,1.73,0,0,0,90.61,1567.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-46",
  d: "M97.94,1567.8h0a1.73,1.73,0,0,0-1.74,1.73v17.41a1.74,1.74,0,0,0,1.71,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,97.94,1567.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-47",
  d: "M105.26,1567.8h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.74,1.74,0,0,0,1.75,1.74h0a1.74,1.74,0,0,0,1.71-1.74v-17.41A1.73,1.73,0,0,0,105.26,1567.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-48",
  d: "M112.59,1567.67h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.68-1.73V1569.4A1.73,1.73,0,0,0,112.59,1567.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-49",
  d: "M119.91,1567.39h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.72,1.72,0,0,0,1.81,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,119.91,1567.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-50",
  d: "M127.24,1567h0a1.73,1.73,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.61-1.73V1568.7A1.72,1.72,0,0,0,127.24,1567Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-51",
  d: "M134.56,1566.41h0a1.74,1.74,0,0,0-1.58,1.72v17.41a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.58-1.73v-17.4A1.72,1.72,0,0,0,134.56,1566.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-52",
  d: "M141.87,1565.67h0a1.72,1.72,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.4A1.74,1.74,0,0,0,141.87,1565.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-53",
  d: "M149.18,1564.76h0a1.74,1.74,0,0,0-1.5,1.72v17.38a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,149.18,1564.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-54",
  d: "M156.49,1563.63h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.7v-17.37A1.74,1.74,0,0,0,156.49,1563.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-55",
  d: "M163.78,1562.26h0a1.73,1.73,0,0,0-1.38,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.74,1.74,0,0,0,1.38-1.7V1564A1.74,1.74,0,0,0,163.78,1562.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-56",
  d: "M171.06,1560.59h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.68v-17.31A1.74,1.74,0,0,0,171.06,1560.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-57",
  d: "M178.32,1558.52h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,178.32,1558.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-58",
  d: "M185.52,1555.83h0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.72,1.72,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,185.52,1555.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-59",
  d: "M192.55,1552l0,0a1.74,1.74,0,0,0-.72,1.4v16.43a1.73,1.73,0,0,0,2.94,1.23l0,0a1.72,1.72,0,0,0,.52-1.24v-16.41A1.72,1.72,0,0,0,192.55,1552Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-60",
  d: "M208.77,1542.37v0a7.52,7.52,0,0,1-2.26,5,19,19,0,0,1-3.5,2.92,35.87,35.87,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.11.39-2.28.78-3.5,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.6-3.86.89c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.73l-3.5.6-3.85.59-3.5.49-3.86.49-3.5.39c-1.27.14-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.85.3s-2.33.16-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.1-3.86.15s-2.32.07-3.5.09-2.56.06-3.85.07l-3.5,0h-3.86l-3.5,0c-1.29,0-2.58,0-3.86-.07l-3.5-.1c-1.29,0-2.58-.08-3.85-.14l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.2-3.86-.3l-3.5-.31-3.85-.39-3.5-.4c-1.31-.15-2.59-.32-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.6-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.28-2.61-.58-3.86-.89s-2.37-.59-3.5-.9c-1.33-.36-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.86-1.47s-2.41-1.05-3.5-1.59a34.07,34.07,0,0,1-3.85-2.21,18.29,18.29,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.85.37,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.16c1.15-.17,2.32-.34,3.5-.49l3.86-.49c1.15-.14,2.32-.27,3.5-.39s2.55-.27,3.85-.39,2.32-.22,3.5-.31l3.86-.31,3.5-.23,3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07c1.16,0,2.33,0,3.5,0h3.86c1.17,0,2.33,0,3.5,0l3.85.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.86.22l3.5.23,3.85.3,3.5.31,3.86.39,3.5.4c1.3.15,2.59.31,3.86.48l3.5.49,1.39.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.86-.38,3.5-.36,3.85-.38,3.5-.36,3.86-.38,3.5-.35,3.86-.39,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M208.77,1541.44c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-61",
  cx: 112.78,
  cy: 1518.19,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M112.78,1494.92c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.77,19L142.27,1496C133,1495.31,123.07,1494.92,112.78,1494.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M112.78,1540c-52,0-94.36-10-95.91-22.56a5.52,5.52,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.52,5.52,0,0,0-.05-.71C207.14,1530,164.8,1540,112.78,1540Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-62",
  d: "M21.87,1526.64l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.74,1.74,0,0,0,.51,1.24l0,0a1.73,1.73,0,0,0,2.95-1.23V1528A1.72,1.72,0,0,0,21.87,1526.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-63",
  d: "M28.9,1530.48l0,0a1.74,1.74,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.73,1.73,0,0,0,28.9,1530.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-64",
  d: "M36.1,1533.16h0a1.73,1.73,0,0,0-2.26,1.65V1552a1.73,1.73,0,0,0,1.18,1.65h0A1.73,1.73,0,0,0,37.3,1552v-17.22A1.74,1.74,0,0,0,36.1,1533.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-65",
  d: "M43.35,1535.23h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,43.35,1535.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-66",
  d: "M50.63,1536.9h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.37,1.69h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,50.63,1536.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-67",
  d: "M57.93,1538.26h0a1.73,1.73,0,0,0-2,1.71v17.35a1.75,1.75,0,0,0,1.44,1.71h0a1.72,1.72,0,0,0,2-1.7V1540A1.74,1.74,0,0,0,57.93,1538.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-68",
  d: "M65.24,1539.38h0a1.73,1.73,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.71h0a1.74,1.74,0,0,0,2-1.72V1541.1A1.74,1.74,0,0,0,65.24,1539.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-69",
  d: "M72.54,1540.3h0a1.73,1.73,0,0,0-1.92,1.73v17.38a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.72V1542A1.74,1.74,0,0,0,72.54,1540.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-70",
  d: "M79.86,1541h0a1.73,1.73,0,0,0-1.89,1.72v17.4a1.74,1.74,0,0,0,1.58,1.72h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.73,1.73,0,0,0,79.86,1541Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-71",
  d: "M87.18,1541.6h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.72,1.72,0,0,0,1.61,1.72h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,87.18,1541.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-72",
  d: "M94.5,1542h0a1.74,1.74,0,0,0-1.81,1.73v17.41a1.73,1.73,0,0,0,1.64,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.4A1.73,1.73,0,0,0,94.5,1542Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-73",
  d: "M101.83,1542.29h0A1.73,1.73,0,0,0,100,1544v17.41a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73V1544A1.73,1.73,0,0,0,101.83,1542.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-74",
  d: "M109.15,1542.42h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.72,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,109.15,1542.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-75",
  d: "M116.48,1542.42h0a1.73,1.73,0,0,0-1.71,1.73v17.41a1.73,1.73,0,0,0,1.74,1.74h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,116.48,1542.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-76",
  d: "M123.8,1542.28h0a1.73,1.73,0,0,0-1.69,1.73v17.41a1.74,1.74,0,0,0,1.79,1.73h0a1.73,1.73,0,0,0,1.68-1.73V1544A1.74,1.74,0,0,0,123.8,1542.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-77",
  d: "M131.13,1542h0a1.74,1.74,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,131.13,1542Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-78",
  d: "M138.45,1541.59h0a1.72,1.72,0,0,0-1.61,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.41A1.74,1.74,0,0,0,138.45,1541.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-79",
  d: "M145.77,1541h0a1.74,1.74,0,0,0-1.58,1.72v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.74,1.74,0,0,0,145.77,1541Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-80",
  d: "M153.09,1540.29h0a1.73,1.73,0,0,0-1.54,1.73v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72V1542A1.73,1.73,0,0,0,153.09,1540.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-81",
  d: "M160.39,1539.37h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.5-1.72v-17.38A1.74,1.74,0,0,0,160.39,1539.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-82",
  d: "M167.7,1538.25h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.7V1540A1.73,1.73,0,0,0,167.7,1538.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-83",
  d: "M175,1536.88h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.38-1.7v-17.34A1.73,1.73,0,0,0,175,1536.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-84",
  d: "M182.28,1535.21h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.74,1.74,0,0,0,1.3-1.68v-17.31A1.73,1.73,0,0,0,182.28,1535.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-85",
  d: "M189.53,1533.14h0a1.73,1.73,0,0,0-1.21,1.65V1552a1.74,1.74,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.17-1.64v-17.24A1.73,1.73,0,0,0,189.53,1533.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-86",
  d: "M196.73,1530.45h0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.71,1.71,0,0,0,1-1.56V1532A1.73,1.73,0,0,0,196.73,1530.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-87",
  d: "M203.76,1526.58l0,0a1.73,1.73,0,0,0-.71,1.4v16.43a1.73,1.73,0,0,0,2.94,1.23l0,0a1.77,1.77,0,0,0,.52-1.24V1528A1.74,1.74,0,0,0,203.76,1526.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-88",
  d: "M201.24,1517v0a7.49,7.49,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,37.44,37.44,0,0,1-3.85,2.2c-1.09.54-2.26,1.07-3.51,1.58s-2.49,1-3.85,1.47c-1.12.39-2.29.78-3.5,1.15s-2.53.76-3.86,1.12c-1.13.31-2.3.61-3.5.9s-2.54.6-3.86.89c-1.14.25-2.3.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4c-1.27.14-2.55.27-3.85.39l-3.5.31c-1.28.11-2.56.21-3.86.3s-2.32.16-3.5.24l-3.86.22-3.5.16c-1.27.06-2.56.1-3.85.15l-3.5.09c-1.28,0-2.57.06-3.86.07l-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0s-2.57,0-3.85-.07l-3.5-.1-3.86-.14-3.5-.16-3.86-.23-3.5-.23-3.85-.3-3.5-.31-3.86-.39-3.5-.4c-1.3-.15-2.59-.32-3.86-.49s-2.35-.32-3.5-.48-2.59-.39-3.85-.6-2.36-.39-3.5-.6c-1.32-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.58-3.86-.89s-2.36-.59-3.5-.9c-1.33-.36-2.62-.74-3.85-1.12s-2.39-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a34.91,34.91,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.17,2.26.22,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,2.74.27,1.11-.16c1.15-.17,2.32-.34,3.5-.49l3.86-.49c1.15-.14,2.32-.27,3.5-.39s2.56-.27,3.86-.39,2.32-.22,3.5-.31l3.85-.31,3.5-.23c1.28-.08,2.56-.16,3.86-.22l3.5-.17,3.86-.14,3.5-.1,3.85-.07c1.16,0,2.33,0,3.5,0h3.86c1.17,0,2.34,0,3.5,0l3.86.07,3.5.1,3.85.14,3.5.17c1.3.06,2.59.14,3.86.22l3.5.23c1.3.09,2.58.2,3.86.3l3.5.31,3.85.39,3.5.4c1.31.15,2.59.31,3.86.48l3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.38,3.5-.36,3.85-.38,3.51-.35,3.85-.39,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M201.24,1516.06c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-89",
  cx: 105.24,
  cy: 1492.81,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M105.24,1469.54c-53,0-95.95,10.42-95.95,23.27,0,7.87,16.1,14.82,40.76,19l84.69-41.18C125.45,1469.93,115.53,1469.54,105.24,1469.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M105.24,1514.65c-52,0-94.36-10-95.91-22.55a5.53,5.53,0,0,0,0,.71c0,12.85,43,23.27,95.95,23.27s96-10.42,96-23.27a5.53,5.53,0,0,0,0-.71C199.61,1504.62,157.26,1514.65,105.24,1514.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-90",
  d: "M14.34,1501.26l0,0a1.73,1.73,0,0,0-2.75,1.4V1519a1.75,1.75,0,0,0,.52,1.24l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.71,1.71,0,0,0,14.34,1501.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-91",
  d: "M21.36,1505.1l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l0,0a1.74,1.74,0,0,0,2.47-1.57v-17.06A1.72,1.72,0,0,0,21.36,1505.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-92",
  d: "M28.56,1507.78h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.74,1.74,0,0,0,1.17,1.65h0a1.74,1.74,0,0,0,2.29-1.64v-17.22A1.74,1.74,0,0,0,28.56,1507.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-93",
  d: "M35.82,1509.85h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.74,1.74,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,35.82,1509.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-94",
  d: "M43.1,1511.52h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.38,1.69h0a1.73,1.73,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,43.1,1511.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-95",
  d: "M50.4,1512.88h0a1.72,1.72,0,0,0-2,1.7v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.7v-17.36A1.74,1.74,0,0,0,50.4,1512.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-96",
  d: "M57.7,1514h0a1.73,1.73,0,0,0-2,1.71v17.38a1.73,1.73,0,0,0,1.5,1.71h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,57.7,1514Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-97",
  d: "M65,1514.92h0a1.74,1.74,0,0,0-1.92,1.73V1534a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.73v-17.38A1.73,1.73,0,0,0,65,1514.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-98",
  d: "M72.33,1515.65h0a1.73,1.73,0,0,0-1.88,1.72v17.4a1.73,1.73,0,0,0,1.57,1.72h0a1.74,1.74,0,0,0,1.89-1.73v-17.39A1.74,1.74,0,0,0,72.33,1515.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-99",
  d: "M79.65,1516.22h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.73,1.73,0,0,0,1.62,1.72h0a1.74,1.74,0,0,0,1.85-1.73V1518A1.72,1.72,0,0,0,79.65,1516.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-100",
  d: "M87,1516.63h0a1.74,1.74,0,0,0-1.81,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,87,1516.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-101",
  d: "M94.29,1516.91h0a1.72,1.72,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,94.29,1516.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-102",
  d: "M101.62,1517h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.74-1.73v-17.41A1.73,1.73,0,0,0,101.62,1517Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-103",
  d: "M108.94,1517h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.74,1.74,0,0,0,1.75,1.74h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,108.94,1517Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-104",
  d: "M116.27,1516.9h0a1.72,1.72,0,0,0-1.68,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.68-1.73v-17.41A1.74,1.74,0,0,0,116.27,1516.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-105",
  d: "M123.59,1516.63h0a1.74,1.74,0,0,0-1.66,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.72,1.72,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,123.59,1516.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-106",
  d: "M130.91,1516.21h0a1.73,1.73,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.61-1.73v-17.41A1.74,1.74,0,0,0,130.91,1516.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-107",
  d: "M138.23,1515.64h0a1.73,1.73,0,0,0-1.58,1.72v17.4a1.73,1.73,0,0,0,1.89,1.73h0a1.74,1.74,0,0,0,1.58-1.73v-17.4A1.73,1.73,0,0,0,138.23,1515.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-108",
  d: "M145.55,1514.91h0a1.74,1.74,0,0,0-1.55,1.73V1534a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.73v-17.39A1.72,1.72,0,0,0,145.55,1514.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-109",
  d: "M152.86,1514h0a1.73,1.73,0,0,0-1.49,1.71v17.39a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.49-1.72v-17.38A1.74,1.74,0,0,0,152.86,1514Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-110",
  d: "M160.16,1512.87h0a1.73,1.73,0,0,0-1.44,1.7V1532a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.7v-17.37A1.74,1.74,0,0,0,160.16,1512.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-111",
  d: "M167.46,1511.5h0a1.74,1.74,0,0,0-1.39,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.37-1.7V1513.2A1.73,1.73,0,0,0,167.46,1511.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-112",
  d: "M174.74,1509.83h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.71,1.71,0,0,0,1.29-1.67v-17.31A1.73,1.73,0,0,0,174.74,1509.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-113",
  d: "M182,1507.76h0a1.72,1.72,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.64h0a1.74,1.74,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,182,1507.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-114",
  d: "M189.2,1505.07h0a1.75,1.75,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.72,1.72,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,189.2,1505.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-115",
  d: "M196.23,1501.2l0,0a1.74,1.74,0,0,0-.72,1.4v16.43a1.73,1.73,0,0,0,2.94,1.23l0,0A1.73,1.73,0,0,0,199,1519v-16.41A1.73,1.73,0,0,0,196.23,1501.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-116",
  d: "M216.13,1491.61v0a7.49,7.49,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,35.67,35.67,0,0,1-3.85,2.21c-1.09.54-2.26,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.29.78-3.5,1.15s-2.52.75-3.86,1.12c-1.13.3-2.3.61-3.5.9s-2.53.6-3.85.89c-1.15.25-2.31.49-3.5.73s-2.55.49-3.86.73c-1.15.2-2.31.4-3.5.59s-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.85.48l-3.5.4c-1.27.14-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.86.3l-3.5.24-3.85.22-3.5.16c-1.28.06-2.57.1-3.86.14l-3.5.1c-1.28,0-2.56.06-3.86.07s-2.33,0-3.5,0h-3.85c-1.18,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.86-.14-3.5-.17c-1.29-.06-2.58-.14-3.85-.22l-3.5-.23-3.86-.3-3.5-.32-3.86-.38-3.5-.4c-1.3-.15-2.59-.32-3.85-.49s-2.35-.32-3.5-.48l-3.86-.6c-1.19-.19-2.35-.39-3.5-.6-1.31-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.6-.58-3.85-.89s-2.37-.59-3.5-.9c-1.34-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a35.86,35.86,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.17,2.26.22,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,2.75.27,1.11-.16c1.15-.17,2.31-.34,3.5-.49l3.85-.49c1.16-.14,2.32-.27,3.5-.39s2.56-.27,3.86-.39l3.5-.32,3.86-.3,3.5-.23c1.27-.08,2.56-.16,3.85-.22l3.5-.17,3.86-.14,3.5-.1,3.86-.07c1.16,0,2.32,0,3.5,0h3.85c1.18,0,2.34,0,3.5,0l3.86.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.85.22l3.5.23c1.3.09,2.59.19,3.86.3l3.5.31,3.86.39,3.5.4c1.3.15,2.58.31,3.85.48l3.5.49,1.4.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.85-.39,3.5-.35,2.24-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M216.13,1490.68c-.11,12.83-43,23.21-96,23.21s-96-10.41-96-23.26v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-117",
  cx: 120.14,
  cy: 1467.43,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M120.14,1444.16c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.76,19l84.69-41.18C140.34,1444.55,130.43,1444.16,120.14,1444.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M120.14,1489.27c-52,0-94.37-10-95.92-22.55a5.53,5.53,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.52,5.52,0,0,0,0-.71C214.5,1479.24,172.15,1489.27,120.14,1489.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-118",
  d: "M29.23,1475.88l0,0a1.73,1.73,0,0,0-2.75,1.4v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.71,1.71,0,0,0,29.23,1475.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-119",
  d: "M36.26,1479.72l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l.05,0a1.74,1.74,0,0,0,2.46-1.57v-17.06A1.73,1.73,0,0,0,36.26,1479.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-120",
  d: "M43.45,1482.4h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.71,1.71,0,0,0,1.18,1.64l0,0a1.74,1.74,0,0,0,2.29-1.65v-17.21A1.73,1.73,0,0,0,43.45,1482.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-121",
  d: "M50.71,1484.47h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,50.71,1484.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-122",
  d: "M58,1486.14h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.74,1.74,0,0,0,1.38,1.69h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,58,1486.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-123",
  d: "M65.29,1487.5h0a1.72,1.72,0,0,0-2,1.7v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.74,1.74,0,0,0,65.29,1487.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-124",
  d: "M72.59,1488.62h0a1.73,1.73,0,0,0-2,1.71v17.38a1.72,1.72,0,0,0,1.49,1.71h0a1.75,1.75,0,0,0,2-1.72v-17.37A1.74,1.74,0,0,0,72.59,1488.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-125",
  d: "M79.9,1489.54h0a1.74,1.74,0,0,0-1.93,1.73v17.38a1.73,1.73,0,0,0,1.54,1.72h0a1.74,1.74,0,0,0,1.93-1.73v-17.38A1.73,1.73,0,0,0,79.9,1489.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-126",
  d: "M87.22,1490.27h0A1.73,1.73,0,0,0,85.3,1492v17.4a1.73,1.73,0,0,0,1.57,1.72h0a1.74,1.74,0,0,0,1.89-1.73V1492A1.74,1.74,0,0,0,87.22,1490.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-127",
  d: "M94.54,1490.84h0a1.72,1.72,0,0,0-1.84,1.72V1510a1.72,1.72,0,0,0,1.61,1.72h0a1.74,1.74,0,0,0,1.86-1.73v-17.4A1.73,1.73,0,0,0,94.54,1490.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-128",
  d: "M101.86,1491.25h0A1.74,1.74,0,0,0,100,1493v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.81-1.73V1493A1.74,1.74,0,0,0,101.86,1491.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-129",
  d: "M109.18,1491.53h0a1.74,1.74,0,0,0-1.78,1.74v17.4a1.74,1.74,0,0,0,1.68,1.74h0a1.74,1.74,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,109.18,1491.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-130",
  d: "M116.51,1491.66h0a1.73,1.73,0,0,0-1.74,1.73v17.41a1.72,1.72,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,116.51,1491.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-131",
  d: "M123.83,1491.66h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.72,1.72,0,0,0,1.71-1.73v-17.41A1.73,1.73,0,0,0,123.83,1491.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-132",
  d: "M131.16,1491.52h0a1.74,1.74,0,0,0-1.68,1.74v17.41a1.74,1.74,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.68-1.73v-17.42A1.74,1.74,0,0,0,131.16,1491.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-133",
  d: "M138.48,1491.25h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.72,1.72,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73V1493A1.73,1.73,0,0,0,138.48,1491.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-134",
  d: "M145.81,1490.83h0a1.73,1.73,0,0,0-1.62,1.72V1510a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.61-1.73v-17.41A1.73,1.73,0,0,0,145.81,1490.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-135",
  d: "M153.13,1490.26h0a1.73,1.73,0,0,0-1.58,1.72v17.4a1.73,1.73,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.58-1.73V1492A1.73,1.73,0,0,0,153.13,1490.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-136",
  d: "M160.44,1489.53h0a1.73,1.73,0,0,0-1.54,1.72v17.4a1.73,1.73,0,0,0,1.93,1.72h0a1.74,1.74,0,0,0,1.54-1.73v-17.39A1.73,1.73,0,0,0,160.44,1489.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-137",
  d: "M167.75,1488.61h0a1.73,1.73,0,0,0-1.5,1.71v17.39a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.49-1.72v-17.38A1.74,1.74,0,0,0,167.75,1488.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-138",
  d: "M175.06,1487.49h0a1.73,1.73,0,0,0-1.44,1.7v17.37a1.74,1.74,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71V1489.2A1.73,1.73,0,0,0,175.06,1487.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-139",
  d: "M182.35,1486.12h0a1.73,1.73,0,0,0-1.38,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.74,1.74,0,0,0,1.38-1.7v-17.34A1.74,1.74,0,0,0,182.35,1486.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-140",
  d: "M189.63,1484.45h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.71,1.71,0,0,0,1.29-1.67v-17.31A1.73,1.73,0,0,0,189.63,1484.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-141",
  d: "M196.89,1482.38h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.65V1484A1.72,1.72,0,0,0,196.89,1482.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-142",
  d: "M204.09,1479.69h0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l.05,0a1.74,1.74,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,204.09,1479.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-143",
  d: "M211.12,1475.82l0,0a1.74,1.74,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.69,1.69,0,0,0,.52-1.23v-16.42A1.73,1.73,0,0,0,211.12,1475.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-144",
  d: "M205.1,1463.17v0a7.57,7.57,0,0,1-2.27,5,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.85,1.46c-1.12.4-2.29.78-3.5,1.16s-2.53.75-3.86,1.11c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.86.72c-1.14.21-2.31.41-3.5.6s-2.55.4-3.85.6c-1.15.16-2.32.33-3.5.48l-3.86.49-3.5.4-3.86.38c-1.15.11-2.32.22-3.5.31l-3.85.31-3.5.23-3.86.22-3.5.17-3.86.14-3.5.1-3.85.07-3.5,0h-3.86l-3.5,0-3.86-.07-3.5-.1c-1.29,0-2.58-.09-3.85-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.18-.07-2.34-.15-3.5-.24s-2.58-.19-3.86-.3l-3.5-.31c-1.3-.12-2.58-.25-3.85-.39l-3.5-.39-3.86-.49-3.5-.49c-1.31-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.86-.48l3.5-.4c1.27-.14,2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.27-.06,2.56-.11,3.85-.15s2.33-.07,3.5-.09l3.86-.08,3.5,0h3.86l3.5,0,3.85.08c1.18,0,2.34,0,3.5.09s2.58.09,3.86.15l3.5.16,3.86.22c1.17.07,2.34.15,3.5.24s2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39s2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.46-.24,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M205.09,1462.24c-.11,12.83-43,23.22-95.95,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-145",
  cx: 109.1,
  cy: 1438.99,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M109.1,1415.73c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.69-41.18C129.3,1416.12,119.39,1415.73,109.1,1415.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M109.1,1460.84c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.78,5.78,0,0,0-.05-.71C203.46,1450.8,161.12,1460.84,109.1,1460.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-146",
  d: "M18.19,1447.44l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.73,1.73,0,0,0,18.19,1447.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-147",
  d: "M25.22,1451.28h0a1.73,1.73,0,0,0-2.42,1.59v17.05a1.74,1.74,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.75,1.75,0,0,0,25.22,1451.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-148",
  d: "M32.42,1454h0a1.74,1.74,0,0,0-2.26,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.73,1.73,0,0,0,32.42,1454Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-149",
  d: "M39.68,1456h0a1.72,1.72,0,0,0-2.16,1.67V1475a1.73,1.73,0,0,0,1.3,1.68h0A1.73,1.73,0,0,0,41,1475v-17.29A1.72,1.72,0,0,0,39.68,1456Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-150",
  d: "M47,1457.7h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69V1459.4A1.74,1.74,0,0,0,47,1457.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-151",
  d: "M54.25,1459.07h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,54.25,1459.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-152",
  d: "M61.56,1460.19h0a1.74,1.74,0,0,0-2,1.72v17.37A1.74,1.74,0,0,0,61,1481h0a1.73,1.73,0,0,0,2-1.71V1461.9A1.73,1.73,0,0,0,61.56,1460.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-153",
  d: "M68.87,1461.1h0a1.72,1.72,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,68.87,1461.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-154",
  d: "M76.18,1461.84h0a1.73,1.73,0,0,0-1.89,1.73V1481a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.71,1.71,0,0,0,76.18,1461.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-155",
  d: "M83.5,1462.4h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,83.5,1462.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-156",
  d: "M90.82,1462.82h0a1.72,1.72,0,0,0-1.81,1.73V1482a1.72,1.72,0,0,0,1.65,1.73h0a1.75,1.75,0,0,0,1.82-1.73v-17.41A1.73,1.73,0,0,0,90.82,1462.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-157",
  d: "M98.15,1463.09h0a1.74,1.74,0,0,0-1.78,1.73v17.41A1.73,1.73,0,0,0,98,1484h0a1.72,1.72,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,98.15,1463.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-158",
  d: "M105.47,1463.22h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73V1465A1.74,1.74,0,0,0,105.47,1463.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-159",
  d: "M112.8,1463.22h0a1.74,1.74,0,0,0-1.71,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73V1465A1.74,1.74,0,0,0,112.8,1463.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-160",
  d: "M120.12,1463.09h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.79,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,120.12,1463.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-161",
  d: "M127.45,1462.82h0a1.73,1.73,0,0,0-1.65,1.73V1482a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,127.45,1462.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-162",
  d: "M134.77,1462.4h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,134.77,1462.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-163",
  d: "M142.09,1461.83h0a1.74,1.74,0,0,0-1.59,1.73V1481a1.73,1.73,0,0,0,1.89,1.72h0A1.73,1.73,0,0,0,144,1481v-17.41A1.73,1.73,0,0,0,142.09,1461.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-164",
  d: "M149.41,1461.09h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.74,1.74,0,0,0,149.41,1461.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-165",
  d: "M156.72,1460.18h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.39A1.73,1.73,0,0,0,156.72,1460.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-166",
  d: "M164,1459.06h0a1.73,1.73,0,0,0-1.45,1.71v17.37a1.73,1.73,0,0,0,2,1.7h0a1.74,1.74,0,0,0,1.44-1.71v-17.37A1.72,1.72,0,0,0,164,1459.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-167",
  d: "M171.32,1457.69h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.73,1.73,0,0,0,171.32,1457.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-168",
  d: "M178.6,1456h0a1.71,1.71,0,0,0-1.3,1.67V1475a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,178.6,1456Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-169",
  d: "M185.85,1453.94h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,185.85,1453.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-170",
  d: "M193.05,1451.25l0,0a1.72,1.72,0,0,0-1.05,1.59V1470a1.74,1.74,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,193.05,1451.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-171",
  d: "M200.08,1447.39l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,200.08,1447.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-172",
  d: "M205.1,1434.72v0a7.57,7.57,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,36.59,36.59,0,0,1-3.86,2.21c-1.08.54-2.25,1.06-3.5,1.58s-2.5,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.14.31-2.3.61-3.5.91s-2.54.6-3.86.89c-1.14.25-2.31.49-3.5.73s-2.54.49-3.86.72c-1.14.21-2.31.41-3.5.6s-2.55.41-3.85.6l-3.5.49c-1.27.16-2.56.33-3.86.48l-3.5.4-3.86.39-3.5.31-3.85.3-3.5.23c-1.28.08-2.56.16-3.86.22l-3.5.17-3.86.14-3.5.1-3.85.07c-1.16,0-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.85-.14-3.5-.17-3.86-.22-3.5-.23-3.86-.31-3.5-.31c-1.3-.12-2.58-.25-3.85-.39s-2.35-.26-3.5-.39l-3.86-.49-3.5-.49c-1.31-.19-2.59-.39-3.86-.59l-3.5-.6c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.37-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.64-1-3.85-1.46s-2.42-1-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.16,2.27.22,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.86-.48l3.5-.4,3.85-.39,3.5-.31c1.28-.11,2.56-.21,3.86-.3l3.5-.24L89,1412l3.5-.16c1.27-.06,2.56-.1,3.85-.15s2.33-.07,3.5-.09,2.57-.06,3.86-.07l3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.85.07s2.34.06,3.5.09,2.58.09,3.86.15l3.5.16,3.86.22c1.17.08,2.34.15,3.5.24s2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39s2.35.26,3.5.39l3.86.49,3.5.49,1.39.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M205.09,1433.79c-.11,12.82-43,23.21-95.95,23.21s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-173",
  cx: 109.1,
  cy: 1410.54,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M109.1,1387.27c-53,0-96,10.41-96,23.27,0,7.86,16.11,14.82,40.77,19l84.69-41.18C129.3,1387.66,119.39,1387.27,109.1,1387.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M109.1,1432.38c-52,0-94.36-10-95.91-22.56a5.81,5.81,0,0,0,0,.72c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26a5.81,5.81,0,0,0-.05-.72C203.46,1422.35,161.12,1432.38,109.1,1432.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-174",
  d: "M18.19,1419l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.75,1.75,0,0,0,18.19,1419Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-175",
  d: "M25.22,1422.82h0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.74,1.74,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.75,1.75,0,0,0,25.22,1422.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-176",
  d: "M32.42,1425.51l0,0a1.74,1.74,0,0,0-2.26,1.65v17.22A1.73,1.73,0,0,0,31.3,1446h0a1.72,1.72,0,0,0,2.28-1.64v-17.22A1.72,1.72,0,0,0,32.42,1425.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-177",
  d: "M39.68,1427.58h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.68v-17.28A1.73,1.73,0,0,0,39.68,1427.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-178",
  d: "M47,1429.24h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.74,1.74,0,0,0,47,1429.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-179",
  d: "M54.25,1430.61h0a1.74,1.74,0,0,0-2,1.71v17.36a1.73,1.73,0,0,0,1.44,1.7h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,54.25,1430.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-180",
  d: "M61.56,1431.73h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.37A1.74,1.74,0,0,0,61.56,1431.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-181",
  d: "M68.87,1432.64h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.74,1.74,0,0,0,68.87,1432.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-182",
  d: "M76.18,1433.38h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.72,1.72,0,0,0,76.18,1433.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-183",
  d: "M83.5,1434h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.73,1.73,0,0,0,83.5,1434Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-184",
  d: "M90.82,1434.36h0a1.72,1.72,0,0,0-1.81,1.73v17.41a1.73,1.73,0,0,0,1.65,1.73h0a1.74,1.74,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,90.82,1434.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-185",
  d: "M98.15,1434.63h0a1.74,1.74,0,0,0-1.78,1.73v17.41A1.73,1.73,0,0,0,98,1455.5h0a1.72,1.72,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,98.15,1434.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-186",
  d: "M105.47,1434.77h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73V1436.5A1.73,1.73,0,0,0,105.47,1434.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-187",
  d: "M112.8,1434.77h0a1.72,1.72,0,0,0-1.71,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73V1436.5A1.73,1.73,0,0,0,112.8,1434.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-188",
  d: "M120.12,1434.63h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.75,1.75,0,0,0,1.79,1.74h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.73,1.73,0,0,0,120.12,1434.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-189",
  d: "M127.45,1434.36h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,127.45,1434.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-190",
  d: "M134.77,1433.94h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,134.77,1433.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-191",
  d: "M142.09,1433.37h0a1.74,1.74,0,0,0-1.59,1.73v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.57-1.72v-17.4A1.73,1.73,0,0,0,142.09,1433.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-192",
  d: "M149.41,1432.64h0a1.74,1.74,0,0,0-1.54,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.73,1.73,0,0,0,149.41,1432.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-193",
  d: "M156.72,1431.72h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.38A1.73,1.73,0,0,0,156.72,1431.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-194",
  d: "M164,1430.6h0a1.74,1.74,0,0,0-1.45,1.71v17.37a1.74,1.74,0,0,0,2,1.71h0a1.72,1.72,0,0,0,1.44-1.71V1432.3A1.72,1.72,0,0,0,164,1430.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-195",
  d: "M171.32,1429.23h0a1.72,1.72,0,0,0-1.38,1.69v17.35A1.73,1.73,0,0,0,172,1450h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,171.32,1429.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-196",
  d: "M178.6,1427.56h0a1.73,1.73,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,178.6,1427.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-197",
  d: "M185.85,1425.48h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.65l0,0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,185.85,1425.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-198",
  d: "M193.05,1422.79l0,0a1.72,1.72,0,0,0-1.05,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,193.05,1422.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-199",
  d: "M200.08,1418.93l0,0a1.72,1.72,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,200.08,1418.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-200",
  d: "M197.54,1407.24v0a7.56,7.56,0,0,1-2.26,5,19.29,19.29,0,0,1-3.5,2.91,36.87,36.87,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.47c-1.12.39-2.28.77-3.5,1.15s-2.52.75-3.85,1.11c-1.14.31-2.31.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.72c-1.15.21-2.31.41-3.5.6s-2.55.4-3.86.6c-1.15.16-2.31.33-3.5.48s-2.55.34-3.85.49l-3.5.4-3.86.38-3.5.32-3.86.3-3.5.23c-1.27.08-2.56.16-3.85.22l-3.5.17-3.86.14-3.5.1-3.86.07-3.5,0H99.64l-3.5,0-3.86-.07-3.5-.1c-1.29,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.85-.22c-1.18-.07-2.35-.15-3.5-.24s-2.59-.19-3.86-.3l-3.5-.31c-1.3-.12-2.58-.25-3.86-.39s-2.34-.26-3.5-.39l-3.85-.49-3.5-.49c-1.31-.19-2.6-.39-3.86-.6s-2.35-.39-3.5-.59c-1.31-.24-2.6-.48-3.86-.73s-2.35-.48-3.5-.73c-1.32-.29-2.6-.59-3.85-.89s-2.37-.6-3.5-.91c-1.34-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.65-1-3.86-1.47s-2.41-1-3.5-1.58a37.43,37.43,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.53,7.53,0,0,1-2.24-5v0h0l0-24.17,2.27.23,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.85-.48l3.5-.4c1.28-.14,2.56-.26,3.86-.39l3.5-.31c1.27-.11,2.56-.21,3.86-.3s2.32-.16,3.5-.24l3.85-.22,3.5-.16c1.28-.06,2.57-.1,3.86-.15s2.33-.07,3.5-.09,2.56-.06,3.86-.07l3.5,0h3.85l3.5,0c1.3,0,2.58,0,3.86.07s2.34.06,3.5.09,2.58.09,3.86.15l3.5.16,3.85.22c1.18.07,2.35.15,3.5.24,1.3.09,2.59.19,3.86.3l3.5.31c1.3.12,2.59.25,3.86.39s2.34.26,3.5.39l3.85.49c1.19.15,2.35.32,3.5.49l1.4.2,2.46-.24,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M197.54,1406.31c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-201",
  cx: 101.55,
  cy: 1383.06,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M101.55,1359.8c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.76,19L131,1360.92C121.75,1360.19,111.84,1359.8,101.55,1359.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M101.55,1404.91c-52,0-94.36-10-95.92-22.56,0,.24,0,.48,0,.71,0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.78,5.78,0,0,0,0-.71C195.91,1394.87,153.56,1404.91,101.55,1404.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-202",
  d: "M10.64,1391.51l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,2.95-1.23v-16.37A1.74,1.74,0,0,0,10.64,1391.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-203",
  d: "M17.67,1395.35h0a1.73,1.73,0,0,0-2.42,1.59v17a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,17.67,1395.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-204",
  d: "M24.87,1398h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.22A1.74,1.74,0,0,0,24.87,1398Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-205",
  d: "M32.12,1400.11h0a1.73,1.73,0,0,0-2.16,1.68v17.28a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,32.12,1400.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-206",
  d: "M39.4,1401.77h0a1.73,1.73,0,0,0-2.09,1.69v17.33a1.74,1.74,0,0,0,1.38,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.73,1.73,0,0,0,39.4,1401.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-207",
  d: "M46.7,1403.14h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.74,1.74,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,46.7,1403.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-208",
  d: "M54,1404.26h0a1.74,1.74,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71V1406A1.73,1.73,0,0,0,54,1404.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-209",
  d: "M61.31,1405.17h0a1.73,1.73,0,0,0-1.93,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.73,1.73,0,0,0,61.31,1405.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-210",
  d: "M68.63,1405.91h0a1.73,1.73,0,0,0-1.88,1.73V1425a1.73,1.73,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.73,1.73,0,0,0,68.63,1405.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-211",
  d: "M76,1406.47h0a1.73,1.73,0,0,0-1.84,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,76,1406.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-212",
  d: "M83.27,1406.89h0a1.73,1.73,0,0,0-1.82,1.73V1426a1.73,1.73,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.81-1.73v-17.41A1.72,1.72,0,0,0,83.27,1406.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-213",
  d: "M90.59,1407.16h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.74,1.74,0,0,0,90.59,1407.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-214",
  d: "M97.92,1407.3h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73V1409A1.73,1.73,0,0,0,97.92,1407.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-215",
  d: "M105.25,1407.29h0a1.74,1.74,0,0,0-1.72,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.71-1.73V1409A1.73,1.73,0,0,0,105.25,1407.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-216",
  d: "M112.57,1407.16h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,112.57,1407.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-217",
  d: "M119.9,1406.89h0a1.73,1.73,0,0,0-1.65,1.73V1426a1.74,1.74,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,119.9,1406.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-218",
  d: "M127.22,1406.47h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.86,1.72h0a1.73,1.73,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,127.22,1406.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-219",
  d: "M134.54,1405.9h0a1.74,1.74,0,0,0-1.58,1.73V1425a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.72v-17.4A1.73,1.73,0,0,0,134.54,1405.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-220",
  d: "M141.85,1405.17h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.74,1.74,0,0,0,1.93,1.73h0a1.73,1.73,0,0,0,1.54-1.72v-17.39A1.73,1.73,0,0,0,141.85,1405.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-221",
  d: "M149.16,1404.25h0a1.74,1.74,0,0,0-1.5,1.72v17.38a1.75,1.75,0,0,0,2,1.72h0a1.72,1.72,0,0,0,1.49-1.71V1406A1.72,1.72,0,0,0,149.16,1404.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-222",
  d: "M156.47,1403.13h0a1.74,1.74,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.7h0a1.73,1.73,0,0,0,1.44-1.71v-17.37A1.72,1.72,0,0,0,156.47,1403.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-223",
  d: "M163.77,1401.76h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,163.77,1401.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-224",
  d: "M171,1400.09h0a1.72,1.72,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.16,1.68h0a1.74,1.74,0,0,0,1.3-1.68v-17.3A1.74,1.74,0,0,0,171,1400.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-225",
  d: "M178.3,1398h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,178.3,1398Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-226",
  d: "M185.5,1395.32l0,0a1.73,1.73,0,0,0-1,1.59V1414a1.73,1.73,0,0,0,2.46,1.57l.05,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,185.5,1395.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-227",
  d: "M192.53,1391.46l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.72,1.72,0,0,0,.53-1.24v-16.41A1.73,1.73,0,0,0,192.53,1391.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-228",
  d: "M201.42,1381.86v0a7.53,7.53,0,0,1-2.27,5,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.49,1-3.85,1.46c-1.12.4-2.29.78-3.5,1.16s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.72c-1.15.21-2.32.41-3.5.6s-2.55.4-3.86.6c-1.15.16-2.32.33-3.5.48l-3.86.49-3.5.4-3.85.38c-1.16.11-2.33.22-3.5.31l-3.86.31-3.5.23-3.86.22-3.5.17-3.85.14-3.5.1-3.86.07-3.5,0h-3.86l-3.5,0-3.85-.07-3.5-.1c-1.3,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.17-.07-2.34-.15-3.5-.24s-2.58-.19-3.85-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39l-3.5-.39-3.86-.49-3.5-.49c-1.3-.19-2.59-.39-3.85-.6s-2.36-.39-3.5-.59c-1.32-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.9s-2.36-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.35-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,2.74.27,1.11-.17,3.5-.49c1.27-.17,2.56-.33,3.86-.48l3.5-.4c1.27-.14,2.56-.27,3.86-.39l3.5-.31c1.27-.11,2.56-.21,3.85-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.28-.06,2.56-.11,3.86-.15s2.32-.07,3.5-.09l3.85-.08,3.5,0h3.86l3.5,0,3.86.08c1.17,0,2.34,0,3.5.09s2.58.09,3.85.15l3.5.16,3.86.22c1.18.07,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39s2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.47-.24,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M201.42,1380.93c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-229",
  cx: 105.42,
  cy: 1357.68,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M105.42,1334.42c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.69-41.18C125.62,1334.81,115.71,1334.42,105.42,1334.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M105.42,1379.53c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.74,5.74,0,0,0,0-.71C199.79,1369.49,157.44,1379.53,105.42,1379.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-230",
  d: "M14.51,1366.13l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.7,1.7,0,0,0,14.51,1366.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-231",
  d: "M21.54,1370h0a1.73,1.73,0,0,0-2.42,1.59v17a1.73,1.73,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.73,1.73,0,0,0,21.54,1370Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-232",
  d: "M28.74,1372.65h0a1.74,1.74,0,0,0-2.27,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64V1374.3A1.73,1.73,0,0,0,28.74,1372.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-233",
  d: "M36,1374.73h0a1.73,1.73,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.68V1376.4A1.72,1.72,0,0,0,36,1374.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-234",
  d: "M43.28,1376.39h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,43.28,1376.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-235",
  d: "M50.57,1377.76h0a1.73,1.73,0,0,0-2,1.71v17.35a1.72,1.72,0,0,0,1.44,1.71h0a1.74,1.74,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,50.57,1377.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-236",
  d: "M57.88,1378.88h0a1.74,1.74,0,0,0-2,1.72V1398a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,57.88,1378.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-237",
  d: "M65.19,1379.79h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,65.19,1379.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-238",
  d: "M72.5,1380.53h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.74,1.74,0,0,0,1.89-1.73v-17.39A1.72,1.72,0,0,0,72.5,1380.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-239",
  d: "M79.82,1381.09h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,79.82,1381.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-240",
  d: "M87.15,1381.51h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.75,1.75,0,0,0,1.82-1.73v-17.41A1.73,1.73,0,0,0,87.15,1381.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-241",
  d: "M94.47,1381.78h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.79-1.73v-17.41A1.74,1.74,0,0,0,94.47,1381.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-242",
  d: "M101.8,1381.91h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,101.8,1381.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-243",
  d: "M109.12,1381.91h0a1.74,1.74,0,0,0-1.72,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,109.12,1381.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-244",
  d: "M116.45,1381.78h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.72,1.72,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.69-1.73v-17.41A1.73,1.73,0,0,0,116.45,1381.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-245",
  d: "M123.77,1381.51h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,123.77,1381.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-246",
  d: "M131.09,1381.09h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,131.09,1381.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-247",
  d: "M138.41,1380.52h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.72,1.72,0,0,0,1.88,1.72h0a1.74,1.74,0,0,0,1.58-1.72v-17.41A1.74,1.74,0,0,0,138.41,1380.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-248",
  d: "M145.73,1379.78h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.73,1.73,0,0,0,145.73,1379.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-249",
  d: "M153,1378.87h0a1.74,1.74,0,0,0-1.49,1.72V1398a1.74,1.74,0,0,0,2,1.72h0A1.73,1.73,0,0,0,155,1398v-17.39A1.73,1.73,0,0,0,153,1378.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-250",
  d: "M160.34,1377.75h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.72,1.72,0,0,0,2,1.7h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,160.34,1377.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-251",
  d: "M167.64,1376.38h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.73,1.73,0,0,0,167.64,1376.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-252",
  d: "M174.92,1374.71h0a1.72,1.72,0,0,0-1.3,1.67v17.31a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,174.92,1374.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-253",
  d: "M182.17,1372.63h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,182.17,1372.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-254",
  d: "M189.37,1369.94l0,0a1.72,1.72,0,0,0-1.05,1.59v17.09a1.74,1.74,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,189.37,1369.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-255",
  d: "M196.41,1366.08l0,0a1.69,1.69,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,196.41,1366.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-256",
  d: "M207,1355.4v0a7.56,7.56,0,0,1-2.26,5,18.56,18.56,0,0,1-3.5,2.91,35.86,35.86,0,0,1-3.86,2.21c-1.08.54-2.25,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.11.39-2.28.78-3.5,1.15s-2.52.75-3.85,1.12l-3.5.9c-1.25.3-2.54.6-3.86.89-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.73c-1.14.2-2.31.4-3.5.59s-2.55.41-3.85.6l-3.5.49c-1.27.17-2.56.33-3.86.48l-3.5.4-3.86.39-3.5.31c-1.27.11-2.56.21-3.85.3l-3.5.23-3.86.23-3.5.16-3.86.14-3.5.1-3.85.07c-1.17,0-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.85-.14-3.5-.17c-1.3-.06-2.59-.14-3.86-.22l-3.5-.23-3.86-.3-3.5-.32c-1.3-.12-2.58-.25-3.85-.39s-2.35-.25-3.5-.39l-3.86-.49c-1.18-.15-2.35-.32-3.5-.49-1.31-.19-2.59-.39-3.86-.59s-2.35-.39-3.5-.6c-1.31-.24-2.6-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.37-.6-3.5-.9c-1.33-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.86-1.47s-2.41-1.05-3.5-1.59a35.67,35.67,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.27.22,3.5.34,3.85.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.17c1.15-.16,2.32-.33,3.5-.48s2.55-.34,3.86-.49l3.5-.4,3.85-.38,3.5-.32,3.86-.3,3.5-.23c1.27-.08,2.56-.16,3.86-.22s2.32-.12,3.5-.17l3.85-.14,3.5-.1,3.86-.07c1.16,0,2.33,0,3.5,0H113c1.17,0,2.33,0,3.5,0l3.85.07,3.5.1c1.3,0,2.58.08,3.86.14l3.5.16,3.86.22,3.5.24c1.29.09,2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39l3.5.4c1.3.15,2.59.31,3.86.48l3.5.49,1.39.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M207,1354.47c-.11,12.82-43,23.21-96,23.21s-96-10.41-96-23.26v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-257",
  cx: 111.03,
  cy: 1331.22,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M111,1308c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.77,19l84.68-41.18C131.23,1308.34,121.32,1308,111,1308Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M111,1353.06c-52,0-94.36-10-95.91-22.55a5.52,5.52,0,0,0,0,.71c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26a5.52,5.52,0,0,0-.05-.71C205.39,1343,163.05,1353.06,111,1353.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-258",
  d: "M20.12,1339.66l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.72,1.72,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,2.95-1.23v-16.36A1.75,1.75,0,0,0,20.12,1339.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-259",
  d: "M27.15,1343.51l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.46-1.57V1345.1A1.72,1.72,0,0,0,27.15,1343.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-260",
  d: "M34.35,1346.19h0a1.73,1.73,0,0,0-2.26,1.64V1365a1.72,1.72,0,0,0,1.18,1.64l0,0a1.73,1.73,0,0,0,2.28-1.65v-17.21A1.73,1.73,0,0,0,34.35,1346.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-261",
  d: "M41.6,1348.26h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.72,1.72,0,0,0,1.29,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,41.6,1348.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-262",
  d: "M48.88,1349.93h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,48.88,1349.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-263",
  d: "M56.18,1351.29h0a1.75,1.75,0,0,0-2,1.71v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71V1353A1.73,1.73,0,0,0,56.18,1351.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-264",
  d: "M63.49,1352.41h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.74,1.74,0,0,0,63.49,1352.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-265",
  d: "M70.79,1353.33h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.73,1.73,0,0,0,70.79,1353.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-266",
  d: "M78.11,1354.06h0a1.73,1.73,0,0,0-1.89,1.72v17.4a1.74,1.74,0,0,0,1.58,1.72h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.73,1.73,0,0,0,78.11,1354.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-267",
  d: "M85.43,1354.63h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.72v-17.4A1.73,1.73,0,0,0,85.43,1354.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-268",
  d: "M92.75,1355h0a1.72,1.72,0,0,0-1.81,1.73v17.41a1.73,1.73,0,0,0,1.64,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,92.75,1355Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-269",
  d: "M100.08,1355.31h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.74,1.74,0,0,0,1.69,1.74h0a1.74,1.74,0,0,0,1.78-1.74v-17.4A1.74,1.74,0,0,0,100.08,1355.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-270",
  d: "M107.4,1355.45h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,107.4,1355.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-271",
  d: "M114.73,1355.45h0a1.73,1.73,0,0,0-1.71,1.73v17.41a1.73,1.73,0,0,0,1.74,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.73,1.73,0,0,0,114.73,1355.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-272",
  d: "M122.05,1355.31h0a1.74,1.74,0,0,0-1.69,1.73v17.42a1.74,1.74,0,0,0,1.79,1.73h0a1.74,1.74,0,0,0,1.68-1.74V1357A1.73,1.73,0,0,0,122.05,1355.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-273",
  d: "M129.38,1355h0a1.74,1.74,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,129.38,1355Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-274",
  d: "M136.7,1354.62h0a1.74,1.74,0,0,0-1.61,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.62-1.72v-17.41A1.73,1.73,0,0,0,136.7,1354.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-275",
  d: "M144,1354.05h0a1.72,1.72,0,0,0-1.58,1.72v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.72,1.72,0,0,0,1.57-1.72v-17.4A1.73,1.73,0,0,0,144,1354.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-276",
  d: "M151.34,1353.32h0a1.73,1.73,0,0,0-1.54,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72V1355A1.73,1.73,0,0,0,151.34,1353.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-277",
  d: "M158.64,1352.4h0a1.72,1.72,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.5-1.72v-17.38A1.74,1.74,0,0,0,158.64,1352.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-278",
  d: "M166,1351.28h0a1.75,1.75,0,0,0-1.44,1.71v17.37a1.74,1.74,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71V1353A1.73,1.73,0,0,0,166,1351.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-279",
  d: "M173.25,1349.91h0a1.72,1.72,0,0,0-1.38,1.69V1369a1.73,1.73,0,0,0,2.09,1.69h0a1.73,1.73,0,0,0,1.38-1.7v-17.34A1.73,1.73,0,0,0,173.25,1349.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-280",
  d: "M180.53,1348.24h0a1.72,1.72,0,0,0-1.3,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.74,1.74,0,0,0,1.3-1.67v-17.31A1.73,1.73,0,0,0,180.53,1348.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-281",
  d: "M187.78,1346.16l0,0a1.73,1.73,0,0,0-1.21,1.64v17.25a1.74,1.74,0,0,0,2.29,1.64h0a1.74,1.74,0,0,0,1.17-1.65v-17.24A1.73,1.73,0,0,0,187.78,1346.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-282",
  d: "M195,1343.47l0,0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.74,1.74,0,0,0,195,1343.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-283",
  d: "M202,1339.61l0,0a1.72,1.72,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.24V1341A1.74,1.74,0,0,0,202,1339.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-284",
  d: "M197.74,1327.42v0a7.53,7.53,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,35.67,35.67,0,0,1-3.85,2.21c-1.09.54-2.26,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.91s-2.54.6-3.86.89c-1.14.25-2.3.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4-3.85.39-3.5.31c-1.28.1-2.56.21-3.86.3l-3.5.23c-1.27.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07c-1.16,0-2.33,0-3.5,0H99.83c-1.17,0-2.33,0-3.5,0l-3.85-.07-3.5-.1-3.86-.14-3.5-.17c-1.29-.06-2.58-.14-3.86-.22l-3.5-.23-3.85-.31c-1.18-.09-2.35-.2-3.5-.31s-2.59-.25-3.86-.39-2.35-.25-3.5-.39l-3.86-.49c-1.18-.15-2.35-.32-3.5-.49l-3.85-.59-3.5-.6c-1.32-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89l-3.5-.9c-1.33-.37-2.62-.74-3.85-1.12s-2.39-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.26.22,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,2.74.27,1.11-.17,3.5-.49c1.27-.16,2.56-.33,3.86-.48l3.5-.4,3.86-.39,3.5-.31,3.85-.3,3.5-.23c1.28-.08,2.57-.16,3.86-.22s2.33-.12,3.5-.17l3.86-.14,3.5-.1c1.28,0,2.56-.06,3.85-.07s2.33,0,3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.86.07l3.5.1c1.29,0,2.58.08,3.85.14l3.5.16,3.86.22c1.18.08,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39l3.5.4c1.31.15,2.59.31,3.86.48l3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M197.74,1326.49c-.12,12.82-43,23.21-96,23.21s-96-10.41-96-23.27v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-285",
  cx: 101.74,
  cy: 1303.24,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M101.74,1280c-53,0-95.95,10.42-95.95,23.27,0,7.86,16.1,14.82,40.76,19l84.69-41.18C122,1280.36,112,1280,101.74,1280Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M101.74,1325.08c-52,0-94.36-10-95.91-22.55a5.53,5.53,0,0,0,0,.71c0,12.85,43,23.26,95.95,23.26s96-10.41,96-23.26a5.53,5.53,0,0,0,0-.71C196.11,1315.05,153.76,1325.08,101.74,1325.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-286",
  d: "M10.84,1311.68l0,0a1.73,1.73,0,0,0-2.75,1.4v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.74,1.74,0,0,0,10.84,1311.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-287",
  d: "M17.86,1315.53l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.05A1.71,1.71,0,0,0,17.86,1315.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-288",
  d: "M25.06,1318.21l0,0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.72,1.72,0,0,0,1.17,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.21A1.73,1.73,0,0,0,25.06,1318.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-289",
  d: "M32.32,1320.28h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67V1322A1.72,1.72,0,0,0,32.32,1320.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-290",
  d: "M39.6,1322h0a1.73,1.73,0,0,0-2.08,1.69V1341a1.73,1.73,0,0,0,1.38,1.7h0A1.74,1.74,0,0,0,41,1341v-17.33A1.72,1.72,0,0,0,39.6,1322Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-291",
  d: "M46.9,1323.31h0a1.74,1.74,0,0,0-2,1.71v17.36a1.73,1.73,0,0,0,1.44,1.7h0a1.73,1.73,0,0,0,2-1.71V1325A1.73,1.73,0,0,0,46.9,1323.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-292",
  d: "M54.2,1324.43h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.5,1.72h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,54.2,1324.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-293",
  d: "M61.51,1325.35h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.72,1.72,0,0,0,61.51,1325.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-294",
  d: "M68.83,1326.08h0a1.72,1.72,0,0,0-1.88,1.72v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.74,1.74,0,0,0,68.83,1326.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-295",
  d: "M76.15,1326.65h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.72v-17.41A1.72,1.72,0,0,0,76.15,1326.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-296",
  d: "M83.47,1327.06h0a1.73,1.73,0,0,0-1.81,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,83.47,1327.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-297",
  d: "M90.79,1327.33h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.74v-17.4A1.74,1.74,0,0,0,90.79,1327.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-298",
  d: "M98.12,1327.47h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.74-1.73V1329.2A1.73,1.73,0,0,0,98.12,1327.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-299",
  d: "M105.44,1327.47h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73V1329.2A1.73,1.73,0,0,0,105.44,1327.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-300",
  d: "M112.77,1327.33h0a1.73,1.73,0,0,0-1.68,1.73v17.42a1.74,1.74,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.68-1.74v-17.41A1.74,1.74,0,0,0,112.77,1327.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-301",
  d: "M120.09,1327.06h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.64-1.73v-17.41A1.72,1.72,0,0,0,120.09,1327.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-302",
  d: "M127.41,1326.64h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.72,1.72,0,0,0,1.61-1.72v-17.41A1.73,1.73,0,0,0,127.41,1326.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-303",
  d: "M134.73,1326.07h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.73h0a1.74,1.74,0,0,0,1.58-1.72v-17.4A1.73,1.73,0,0,0,134.73,1326.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-304",
  d: "M142.05,1325.34h0a1.74,1.74,0,0,0-1.55,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.72,1.72,0,0,0,142.05,1325.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-305",
  d: "M149.36,1324.42h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,149.36,1324.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-306",
  d: "M156.66,1323.3h0a1.75,1.75,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71V1325A1.73,1.73,0,0,0,156.66,1323.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-307",
  d: "M164,1321.93h0a1.72,1.72,0,0,0-1.39,1.69V1341a1.73,1.73,0,0,0,2.09,1.69h0A1.73,1.73,0,0,0,166,1341v-17.34A1.73,1.73,0,0,0,164,1321.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-308",
  d: "M171.24,1320.26h0a1.73,1.73,0,0,0-1.31,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.67v-17.31A1.73,1.73,0,0,0,171.24,1320.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-309",
  d: "M178.5,1318.18l0,0a1.72,1.72,0,0,0-1.2,1.64v17.24a1.73,1.73,0,0,0,2.28,1.65l0,0a1.71,1.71,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,178.5,1318.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-310",
  d: "M185.7,1315.49l0,0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.75,1.75,0,0,0,1-1.57v-17.09A1.74,1.74,0,0,0,185.7,1315.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-311",
  d: "M192.73,1311.63l0,0a1.73,1.73,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.24V1313A1.73,1.73,0,0,0,192.73,1311.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-312",
  d: "M203.35,1302v0a7.57,7.57,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,34.91,34.91,0,0,1-3.86,2.21c-1.08.54-2.25,1.07-3.5,1.58s-2.5,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.14.31-2.3.61-3.5.91s-2.54.6-3.86.89c-1.14.25-2.31.49-3.5.73s-2.54.49-3.86.73c-1.14.2-2.31.4-3.5.59s-2.55.41-3.85.6l-3.5.49c-1.27.17-2.56.33-3.86.48l-3.5.4-3.86.39-3.5.31-3.85.3-3.5.23c-1.28.08-2.56.16-3.86.22l-3.5.17-3.86.14-3.5.1-3.85.07c-1.16,0-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.85-.14-3.5-.17-3.86-.22-3.5-.23-3.86-.31c-1.17-.09-2.34-.2-3.5-.31s-2.58-.25-3.85-.39-2.35-.25-3.5-.39l-3.86-.49-3.5-.49c-1.31-.19-2.59-.39-3.86-.59l-3.5-.6c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89l-3.5-.9c-1.33-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.85-1.47s-2.42-1-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.27.22,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,2.75.27,1.11-.17,3.5-.49c1.27-.16,2.55-.33,3.86-.48l3.5-.4,3.85-.39,3.5-.31c1.28-.1,2.56-.21,3.86-.3l3.5-.24,3.86-.22,3.5-.16,3.85-.14,3.5-.1c1.28,0,2.57-.06,3.86-.07s2.33,0,3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.85.07s2.34.06,3.5.09,2.58.09,3.86.15l3.5.16,3.86.22c1.17.08,2.34.15,3.5.24s2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39l3.5.39,3.86.49,3.5.49,1.39.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M203.34,1301.11c-.11,12.82-43,23.21-95.95,23.21s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-313",
  cx: 107.35,
  cy: 1277.86,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M107.35,1254.59c-53,0-96,10.42-96,23.27,0,7.86,16.11,14.82,40.77,19l84.69-41.18C127.55,1255,117.64,1254.59,107.35,1254.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M107.35,1299.7c-52,0-94.36-10-95.91-22.56a5.81,5.81,0,0,0,0,.72c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26a5.81,5.81,0,0,0-.05-.72C201.71,1289.67,159.37,1299.7,107.35,1299.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-314",
  d: "M16.44,1286.3l0,0a1.73,1.73,0,0,0-2.74,1.4V1304a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.75,1.75,0,0,0,16.44,1286.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-315",
  d: "M23.47,1290.14h0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.73,1.73,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.75,1.75,0,0,0,23.47,1290.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-316",
  d: "M30.67,1292.83l0,0a1.74,1.74,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64v-17.21A1.72,1.72,0,0,0,30.67,1292.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-317",
  d: "M37.93,1294.9h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,37.93,1294.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-318",
  d: "M45.2,1296.56h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.74,1.74,0,0,0,45.2,1296.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-319",
  d: "M52.5,1297.93h0a1.74,1.74,0,0,0-2,1.71V1317a1.73,1.73,0,0,0,1.44,1.7h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,52.5,1297.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-320",
  d: "M59.81,1299.05h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.37A1.74,1.74,0,0,0,59.81,1299.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-321",
  d: "M67.12,1300h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.72,1.72,0,0,0,67.12,1300Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-322",
  d: "M74.43,1300.7h0a1.74,1.74,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.72,1.72,0,0,0,1.88-1.72v-17.4A1.73,1.73,0,0,0,74.43,1300.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-323",
  d: "M81.75,1301.27h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.72V1303A1.73,1.73,0,0,0,81.75,1301.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-324",
  d: "M89.07,1301.68h0a1.72,1.72,0,0,0-1.81,1.73v17.41a1.73,1.73,0,0,0,1.65,1.73h0a1.74,1.74,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,89.07,1301.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-325",
  d: "M96.4,1302h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.69,1.73h0a1.74,1.74,0,0,0,1.78-1.74v-17.41A1.73,1.73,0,0,0,96.4,1302Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-326",
  d: "M103.72,1302.09h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,103.72,1302.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-327",
  d: "M111.05,1302.09h0a1.72,1.72,0,0,0-1.71,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.73,1.73,0,0,0,111.05,1302.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-328",
  d: "M118.37,1302h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.75,1.75,0,0,0,1.79,1.74h0a1.74,1.74,0,0,0,1.68-1.74v-17.41A1.73,1.73,0,0,0,118.37,1302Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-329",
  d: "M125.7,1301.68h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,125.7,1301.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-330",
  d: "M133,1301.26h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.62-1.72V1303A1.73,1.73,0,0,0,133,1301.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-331",
  d: "M140.34,1300.69h0a1.74,1.74,0,0,0-1.59,1.73v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.57-1.72v-17.4A1.73,1.73,0,0,0,140.34,1300.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-332",
  d: "M147.66,1300h0a1.74,1.74,0,0,0-1.54,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.73,1.73,0,0,0,147.66,1300Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-333",
  d: "M155,1299h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.38A1.73,1.73,0,0,0,155,1299Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-334",
  d: "M162.27,1297.92h0a1.74,1.74,0,0,0-1.45,1.71V1317a1.74,1.74,0,0,0,2,1.71h0a1.72,1.72,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,162.27,1297.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-335",
  d: "M169.57,1296.55h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,169.57,1296.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-336",
  d: "M176.85,1294.88h0a1.73,1.73,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.67v-17.31A1.73,1.73,0,0,0,176.85,1294.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-337",
  d: "M184.1,1292.8h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.65l0,0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,184.1,1292.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-338",
  d: "M191.3,1290.11l0,0a1.73,1.73,0,0,0-1.05,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57V1291.7A1.74,1.74,0,0,0,191.3,1290.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-339",
  d: "M198.33,1286.25l0,0a1.72,1.72,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,198.33,1286.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-340",
  d: "M192,1274.1v0a7.56,7.56,0,0,1-2.26,5,19.29,19.29,0,0,1-3.5,2.91,35.87,35.87,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.4-2.28.78-3.5,1.16s-2.52.75-3.85,1.11c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.72c-1.14.21-2.31.41-3.5.6s-2.55.4-3.85.6-2.32.33-3.5.48l-3.86.49c-1.15.14-2.32.27-3.5.39s-2.56.27-3.86.39-2.32.22-3.5.31l-3.85.31-3.5.23-3.86.22-3.5.17-3.86.14-3.5.1-3.85.07-3.5,0H94.05l-3.5,0-3.86-.07-3.5-.1c-1.29,0-2.58-.09-3.85-.15l-3.5-.16-3.86-.22c-1.18-.07-2.34-.15-3.5-.24s-2.58-.19-3.86-.3l-3.5-.31c-1.3-.12-2.58-.25-3.86-.39l-3.5-.39-3.85-.49-3.5-.49c-1.31-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.6-.48-3.86-.73s-2.35-.48-3.5-.73c-1.32-.29-2.6-.59-3.85-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.64-1-3.86-1.47s-2.41-1-3.5-1.58a37.43,37.43,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0H0l0-24.17,2.27.23,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.85-.48l3.5-.4c1.28-.14,2.56-.27,3.86-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.16,3.5-.24l3.86-.22,3.5-.16c1.27-.06,2.56-.11,3.85-.15s2.33-.07,3.5-.09l3.86-.08,3.5,0h3.86l3.5,0,3.85.08c1.18,0,2.34,0,3.5.09s2.58.09,3.86.15l3.5.16,3.86.22c1.17.07,2.34.15,3.5.24s2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39s2.35.25,3.5.39l3.86.49c1.18.15,2.34.32,3.5.49l1.39.2,2.46-.24,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M192,1273.17c-.11,12.83-43,23.22-96,23.22S0,1286,0,1273.12v0H0l0-23.17H0l0,24.17H0v0C0,1287,43,1297.39,96,1297.39s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-341",
  cx: 95.96,
  cy: 1249.92,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M96,1226.66c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.76,19l84.69-41.18C116.16,1227.05,106.25,1226.66,96,1226.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M96,1271.77c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.78,5.78,0,0,0,0-.71C190.32,1261.73,148,1271.77,96,1271.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-342",
  d: "M5.05,1258.37l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.51,1.23l0,0a1.74,1.74,0,0,0,2.95-1.24v-16.36A1.73,1.73,0,0,0,5.05,1258.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-343",
  d: "M12.08,1262.21h0a1.73,1.73,0,0,0-2.42,1.59v17a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57V1263.8A1.74,1.74,0,0,0,12.08,1262.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-344",
  d: "M19.28,1264.89h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.22A1.74,1.74,0,0,0,19.28,1264.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-345",
  d: "M26.53,1267h0a1.72,1.72,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,26.53,1267Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-346",
  d: "M33.81,1268.63h0a1.74,1.74,0,0,0-2.09,1.7v17.33a1.74,1.74,0,0,0,1.38,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.73,1.73,0,0,0,33.81,1268.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-347",
  d: "M41.11,1270h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71V1271.7A1.73,1.73,0,0,0,41.11,1270Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-348",
  d: "M48.41,1271.12h0a1.74,1.74,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,48.41,1271.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-349",
  d: "M55.72,1272h0a1.73,1.73,0,0,0-1.93,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.73,1.73,0,0,0,55.72,1272Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-350",
  d: "M63,1272.77h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.73,1.73,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.72,1.72,0,0,0,63,1272.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-351",
  d: "M70.36,1273.33h0a1.73,1.73,0,0,0-1.84,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,70.36,1273.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-352",
  d: "M77.68,1273.75h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.64,1.73h0a1.75,1.75,0,0,0,1.82-1.74v-17.4A1.73,1.73,0,0,0,77.68,1273.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-353",
  d: "M85,1274h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.69,1.73h0a1.72,1.72,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,85,1274Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-354",
  d: "M92.33,1274.15h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,92.33,1274.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-355",
  d: "M99.66,1274.15h0a1.74,1.74,0,0,0-1.71,1.74v17.41a1.73,1.73,0,0,0,1.74,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,99.66,1274.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-356",
  d: "M107,1274h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,107,1274Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-357",
  d: "M114.31,1273.75h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.74,1.74,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,114.31,1273.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-358",
  d: "M121.63,1273.33h0a1.73,1.73,0,0,0-1.61,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,121.63,1273.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-359",
  d: "M129,1272.76h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.72v-17.41A1.73,1.73,0,0,0,129,1272.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-360",
  d: "M136.27,1272h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.39A1.74,1.74,0,0,0,136.27,1272Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-361",
  d: "M143.57,1271.11h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.5-1.71v-17.39A1.73,1.73,0,0,0,143.57,1271.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-362",
  d: "M150.88,1270h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.7h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.72,1.72,0,0,0,150.88,1270Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-363",
  d: "M158.18,1268.62h0a1.74,1.74,0,0,0-1.38,1.7v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,158.18,1268.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-364",
  d: "M165.46,1267h0a1.71,1.71,0,0,0-1.3,1.67v17.31a1.73,1.73,0,0,0,2.16,1.68h0a1.74,1.74,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,165.46,1267Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-365",
  d: "M172.71,1264.87h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,172.71,1264.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-366",
  d: "M179.91,1262.18l0,0a1.73,1.73,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l.05,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,179.91,1262.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-367",
  d: "M186.94,1258.32l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,186.94,1258.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-368",
  d: "M206.67,1250.56v0a7.53,7.53,0,0,1-2.27,5.05,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.72c-1.15.21-2.32.41-3.5.6s-2.55.4-3.86.6c-1.15.16-2.32.33-3.5.48s-2.55.34-3.86.49l-3.5.4-3.85.38-3.5.32-3.86.3-3.5.23-3.86.22-3.5.17-3.85.14-3.5.1-3.86.07-3.5,0h-3.86l-3.5,0-3.85-.07-3.5-.1c-1.3,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.17-.07-2.34-.15-3.5-.24s-2.58-.19-3.85-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39l-3.5-.39-3.86-.49-3.5-.49c-1.3-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.36-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.35-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.56-.33,3.86-.48l3.5-.4c1.27-.14,2.56-.27,3.86-.39l3.5-.31c1.27-.11,2.55-.21,3.85-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.28-.06,2.56-.1,3.86-.15s2.32-.07,3.5-.09l3.85-.08,3.5,0h3.86l3.5,0,3.86.08c1.17,0,2.34,0,3.5.09s2.58.09,3.85.15l3.5.16,3.86.22c1.18.07,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39s2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.47-.24,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M206.67,1249.63c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-369",
  cx: 110.67,
  cy: 1226.38,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M110.67,1203.12c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.69-41.18C130.87,1203.51,121,1203.12,110.67,1203.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M110.67,1248.23c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.74,5.74,0,0,0,0-.71C205,1238.19,162.69,1248.23,110.67,1248.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-370",
  d: "M19.76,1234.83l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.37A1.7,1.7,0,0,0,19.76,1234.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-371",
  d: "M26.79,1238.67h0a1.73,1.73,0,0,0-2.42,1.59v17a1.73,1.73,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.73,1.73,0,0,0,26.79,1238.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-372",
  d: "M34,1241.35h0a1.74,1.74,0,0,0-2.27,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64V1243A1.73,1.73,0,0,0,34,1241.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-373",
  d: "M41.25,1243.43h0a1.73,1.73,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.68V1245.1A1.72,1.72,0,0,0,41.25,1243.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-374",
  d: "M48.53,1245.09h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,48.53,1245.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-375",
  d: "M55.82,1246.46h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.45,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.72,1.72,0,0,0,55.82,1246.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-376",
  d: "M63.13,1247.58h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,63.13,1247.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-377",
  d: "M70.44,1248.49h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0A1.73,1.73,0,0,0,72,1267.6v-17.39A1.74,1.74,0,0,0,70.44,1248.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-378",
  d: "M77.75,1249.23h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.74,1.74,0,0,0,1.89-1.72V1251A1.72,1.72,0,0,0,77.75,1249.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-379",
  d: "M85.07,1249.79h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,85.07,1249.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-380",
  d: "M92.4,1250.21h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.75,1.75,0,0,0,1.82-1.73v-17.41A1.73,1.73,0,0,0,92.4,1250.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-381",
  d: "M99.72,1250.48h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.79-1.73v-17.41A1.74,1.74,0,0,0,99.72,1250.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-382",
  d: "M107.05,1250.61h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,107.05,1250.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-383",
  d: "M114.37,1250.61h0a1.74,1.74,0,0,0-1.72,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,114.37,1250.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-384",
  d: "M121.7,1250.48h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.72,1.72,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.69-1.73v-17.41A1.73,1.73,0,0,0,121.7,1250.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-385",
  d: "M129,1250.21h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,129,1250.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-386",
  d: "M136.34,1249.79h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,136.34,1249.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-387",
  d: "M143.66,1249.22h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.72,1.72,0,0,0,1.88,1.72h0a1.74,1.74,0,0,0,1.58-1.72v-17.41A1.74,1.74,0,0,0,143.66,1249.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-388",
  d: "M151,1248.48h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.74,1.74,0,0,0,151,1248.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-389",
  d: "M158.29,1247.57h0a1.74,1.74,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.39A1.73,1.73,0,0,0,158.29,1247.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-390",
  d: "M165.59,1246.45h0a1.72,1.72,0,0,0-1.44,1.71v17.37a1.72,1.72,0,0,0,2,1.7h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,165.59,1246.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-391",
  d: "M172.89,1245.08h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.73,1.73,0,0,0,172.89,1245.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-392",
  d: "M180.17,1243.41h0a1.72,1.72,0,0,0-1.3,1.67v17.31a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,180.17,1243.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-393",
  d: "M187.42,1241.33h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64V1243A1.74,1.74,0,0,0,187.42,1241.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-394",
  d: "M194.62,1238.64l0,0a1.72,1.72,0,0,0-1.05,1.59v17.09a1.74,1.74,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,194.62,1238.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-395",
  d: "M201.65,1234.78l0,0a1.69,1.69,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,201.65,1234.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-396",
  d: "M197.92,1222.6v0a7.53,7.53,0,0,1-2.27,5,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.72c-1.15.21-2.32.41-3.5.6s-2.55.4-3.86.6c-1.15.16-2.32.33-3.5.48s-2.55.34-3.86.49l-3.5.4-3.85.38-3.5.32-3.86.3-3.5.23-3.86.22-3.5.17-3.85.14-3.5.1-3.86.07-3.5,0H100l-3.5,0-3.85-.07-3.5-.1c-1.3,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.17-.07-2.34-.15-3.5-.24s-2.58-.19-3.85-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39l-3.5-.39-3.86-.49-3.5-.49c-1.3-.19-2.59-.39-3.85-.6s-2.36-.39-3.5-.59c-1.32-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.36-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.35-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0H6l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,2.74.27,1.11-.17,3.5-.49c1.27-.17,2.56-.33,3.86-.48l3.5-.4c1.27-.14,2.56-.27,3.86-.39l3.5-.31c1.27-.11,2.56-.21,3.85-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.28-.06,2.56-.1,3.86-.15s2.32-.07,3.5-.09l3.85-.08,3.5,0h3.86l3.5,0,3.86.08c1.17,0,2.34,0,3.5.09s2.58.09,3.85.15l3.5.16,3.86.22c1.18.07,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39s2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.47-.24,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M197.92,1221.67c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0H6l0-23.17H6l0,24.17H6v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-397",
  cx: 101.92,
  cy: 1198.42,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M101.92,1175.16c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.69-41.18C122.12,1175.55,112.21,1175.16,101.92,1175.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M101.92,1220.27c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.74,5.74,0,0,0,0-.71C196.29,1210.23,153.94,1220.27,101.92,1220.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-398",
  d: "M11,1206.87l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.37A1.72,1.72,0,0,0,11,1206.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-399",
  d: "M18,1210.71h0a1.73,1.73,0,0,0-2.42,1.59v17a1.73,1.73,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57V1212.3A1.73,1.73,0,0,0,18,1210.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-400",
  d: "M25.24,1213.39h0a1.74,1.74,0,0,0-2.27,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64V1215A1.73,1.73,0,0,0,25.24,1213.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-401",
  d: "M32.5,1215.47h0a1.73,1.73,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,32.5,1215.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-402",
  d: "M39.78,1217.13h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,39.78,1217.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-403",
  d: "M47.07,1218.5h0a1.73,1.73,0,0,0-2,1.71v17.35a1.72,1.72,0,0,0,1.44,1.71h0a1.74,1.74,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,47.07,1218.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-404",
  d: "M54.38,1219.62h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,54.38,1219.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-405",
  d: "M61.69,1220.53h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,61.69,1220.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-406",
  d: "M69,1221.27h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.74,1.74,0,0,0,1.89-1.72V1223A1.72,1.72,0,0,0,69,1221.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-407",
  d: "M76.32,1221.83h0a1.73,1.73,0,0,0-1.85,1.73V1241a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,76.32,1221.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-408",
  d: "M83.65,1222.25h0A1.72,1.72,0,0,0,81.8,1224v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.75,1.75,0,0,0,1.82-1.73V1224A1.73,1.73,0,0,0,83.65,1222.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-409",
  d: "M91,1222.52h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.79-1.73v-17.41A1.74,1.74,0,0,0,91,1222.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-410",
  d: "M98.3,1222.65h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,98.3,1222.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-411",
  d: "M105.62,1222.65h0a1.74,1.74,0,0,0-1.72,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,105.62,1222.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-412",
  d: "M113,1222.52h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.72,1.72,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.69-1.73v-17.41A1.73,1.73,0,0,0,113,1222.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-413",
  d: "M120.27,1222.25h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73V1224A1.72,1.72,0,0,0,120.27,1222.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-414",
  d: "M127.59,1221.83h0a1.74,1.74,0,0,0-1.62,1.73V1241a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,127.59,1221.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-415",
  d: "M134.91,1221.26h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.72,1.72,0,0,0,1.88,1.72h0a1.74,1.74,0,0,0,1.58-1.72V1223A1.73,1.73,0,0,0,134.91,1221.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-416",
  d: "M142.23,1220.52h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.73,1.73,0,0,0,142.23,1220.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-417",
  d: "M149.54,1219.61h0a1.74,1.74,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.39A1.73,1.73,0,0,0,149.54,1219.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-418",
  d: "M156.84,1218.49h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.72,1.72,0,0,0,2,1.7h0a1.74,1.74,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,156.84,1218.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-419",
  d: "M164.14,1217.12h0a1.72,1.72,0,0,0-1.39,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.73,1.73,0,0,0,164.14,1217.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-420",
  d: "M171.42,1215.45h0a1.73,1.73,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,171.42,1215.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-421",
  d: "M178.68,1213.37h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64V1215A1.74,1.74,0,0,0,178.68,1213.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-422",
  d: "M185.87,1210.68l0,0a1.72,1.72,0,0,0-1.05,1.59v17.09a1.74,1.74,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,185.87,1210.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-423",
  d: "M192.91,1206.82l0,0a1.72,1.72,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,192.91,1206.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-424",
  d: "M201.24,1195.18v0a7.53,7.53,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,35.67,35.67,0,0,1-3.85,2.21c-1.09.54-2.26,1.07-3.51,1.58s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.91s-2.54.6-3.86.89c-1.14.25-2.3.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4-3.85.39-3.5.31c-1.28.1-2.56.21-3.86.3l-3.5.23c-1.27.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07c-1.16,0-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.85-.07-3.5-.1-3.86-.14-3.5-.17c-1.3-.06-2.58-.14-3.86-.22l-3.5-.23-3.85-.31c-1.18-.09-2.35-.2-3.5-.31s-2.59-.25-3.86-.39-2.35-.25-3.5-.39l-3.86-.49c-1.18-.15-2.35-.32-3.5-.49l-3.85-.59-3.5-.6c-1.32-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89l-3.5-.9c-1.33-.37-2.62-.74-3.85-1.12s-2.39-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.26.22,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,2.74.27,1.11-.17,3.5-.49c1.27-.16,2.56-.33,3.86-.48l3.5-.4,3.86-.39,3.5-.31,3.85-.3,3.5-.23c1.28-.08,2.56-.16,3.86-.22s2.33-.12,3.5-.17l3.86-.14,3.5-.1c1.28,0,2.56-.06,3.85-.07s2.33,0,3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.86.07l3.5.1c1.29,0,2.58.08,3.85.14l3.5.16,3.86.22c1.18.08,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39l3.5.4c1.31.15,2.59.31,3.86.48l3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.51-.35,3.85-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M201.24,1194.25c-.12,12.82-43,23.21-96,23.21s-96-10.41-96-23.27v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-425",
  cx: 105.24,
  cy: 1171,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M105.24,1147.73c-53,0-95.95,10.42-95.95,23.27,0,7.86,16.1,14.82,40.76,19l84.69-41.18C125.45,1148.12,115.53,1147.73,105.24,1147.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M105.24,1192.84c-52,0-94.36-10-95.91-22.55a5.53,5.53,0,0,0,0,.71c0,12.85,43,23.26,95.95,23.26s96-10.41,96-23.26a5.53,5.53,0,0,0,0-.71C199.61,1182.81,157.26,1192.84,105.24,1192.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-426",
  d: "M14.34,1179.44l0,0a1.73,1.73,0,0,0-2.75,1.4v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.74,1.74,0,0,0,14.34,1179.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-427",
  d: "M21.36,1183.29l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.47-1.57v-17A1.71,1.71,0,0,0,21.36,1183.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-428",
  d: "M28.56,1186l0,0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.72,1.72,0,0,0,1.17,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.21A1.73,1.73,0,0,0,28.56,1186Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-429",
  d: "M35.82,1188h0a1.73,1.73,0,0,0-2.16,1.68V1207a1.73,1.73,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.72,1.72,0,0,0,35.82,1188Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-430",
  d: "M43.1,1189.71h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.38,1.7h0a1.74,1.74,0,0,0,2.09-1.7V1191.4A1.72,1.72,0,0,0,43.1,1189.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-431",
  d: "M50.4,1191.07h0a1.74,1.74,0,0,0-2,1.71v17.36a1.73,1.73,0,0,0,1.44,1.7h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,50.4,1191.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-432",
  d: "M57.7,1192.19h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.5,1.72h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,57.7,1192.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-433",
  d: "M65,1193.11h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.72,1.72,0,0,0,65,1193.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-434",
  d: "M72.33,1193.84h0a1.72,1.72,0,0,0-1.88,1.72V1213a1.73,1.73,0,0,0,1.57,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.74,1.74,0,0,0,72.33,1193.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-435",
  d: "M79.65,1194.41h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.72v-17.41A1.72,1.72,0,0,0,79.65,1194.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-436",
  d: "M87,1194.82h0a1.72,1.72,0,0,0-1.81,1.73V1214a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,87,1194.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-437",
  d: "M94.29,1195.09h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.74v-17.4A1.74,1.74,0,0,0,94.29,1195.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-438",
  d: "M101.62,1195.23h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.74-1.73V1197A1.73,1.73,0,0,0,101.62,1195.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-439",
  d: "M108.94,1195.23h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73V1197A1.73,1.73,0,0,0,108.94,1195.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-440",
  d: "M116.27,1195.09h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.74,1.74,0,0,0,1.78,1.74h0a1.74,1.74,0,0,0,1.68-1.74v-17.41A1.74,1.74,0,0,0,116.27,1195.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-441",
  d: "M123.59,1194.82h0a1.73,1.73,0,0,0-1.66,1.73V1214a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,123.59,1194.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-442",
  d: "M130.91,1194.4h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.72,1.72,0,0,0,1.61-1.72v-17.41A1.73,1.73,0,0,0,130.91,1194.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-443",
  d: "M138.23,1193.83h0a1.73,1.73,0,0,0-1.58,1.73V1213a1.73,1.73,0,0,0,1.89,1.73h0a1.74,1.74,0,0,0,1.58-1.72v-17.4A1.73,1.73,0,0,0,138.23,1193.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-444",
  d: "M145.55,1193.1h0a1.74,1.74,0,0,0-1.55,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.72,1.72,0,0,0,145.55,1193.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-445",
  d: "M152.86,1192.18h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.49-1.72V1193.9A1.73,1.73,0,0,0,152.86,1192.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-446",
  d: "M160.16,1191.06h0a1.74,1.74,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,160.16,1191.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-447",
  d: "M167.46,1189.69h0a1.72,1.72,0,0,0-1.39,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,167.46,1189.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-448",
  d: "M174.74,1188h0a1.73,1.73,0,0,0-1.31,1.68V1207a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.67V1189.7A1.73,1.73,0,0,0,174.74,1188Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-449",
  d: "M182,1185.94h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.65l0,0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,182,1185.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-450",
  d: "M189.2,1183.25l0,0a1.75,1.75,0,0,0-1,1.59V1202a1.73,1.73,0,0,0,2.47,1.57l0,0a1.75,1.75,0,0,0,1-1.57v-17.09A1.74,1.74,0,0,0,189.2,1183.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-451",
  d: "M196.23,1179.39l0,0a1.73,1.73,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,196.23,1179.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-452",
  d: "M1203.55,1582.54v0a7.52,7.52,0,0,1-2.26,5,18.89,18.89,0,0,1-3.5,2.91,36.86,36.86,0,0,1-3.86,2.21c-1.09.54-2.25,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.28.78-3.5,1.15s-2.52.75-3.86,1.12c-1.13.3-2.3.61-3.5.9s-2.53.6-3.85.89c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.73c-1.15.2-2.31.4-3.5.59s-2.55.41-3.86.6l-3.5.49c-1.26.17-2.55.33-3.85.48l-3.5.4c-1.27.14-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.86.3l-3.5.24-3.85.22-3.5.16c-1.28.06-2.57.1-3.86.14l-3.5.1c-1.28,0-2.56.06-3.86.07s-2.32,0-3.5,0h-3.85c-1.17,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.86-.14-3.5-.17c-1.29-.06-2.58-.14-3.85-.22l-3.5-.23-3.86-.3-3.5-.32-3.86-.38-3.5-.4c-1.3-.15-2.58-.32-3.85-.49s-2.35-.32-3.5-.48l-3.86-.6c-1.19-.19-2.35-.39-3.5-.6-1.31-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.6-.58-3.85-.89s-2.37-.59-3.5-.9c-1.34-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.41-1-3.5-1.59a35.67,35.67,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.47,7.47,0,0,1-2.24-5v0h0l0-24.17,2.27.22,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,2.75.27,1.11-.16c1.15-.17,2.31-.34,3.5-.49l3.85-.49c1.16-.14,2.32-.27,3.5-.39s2.56-.27,3.86-.39l3.5-.32,3.86-.3,3.5-.23c1.27-.08,2.56-.16,3.85-.22l3.5-.17,3.86-.14,3.5-.1,3.86-.07c1.16,0,2.32,0,3.5,0h3.85c1.18,0,2.34,0,3.5,0l3.86.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.85.22l3.5.23c1.3.09,2.59.19,3.86.3l3.5.31,3.86.39,3.5.4c1.3.15,2.59.31,3.85.48l3.5.49,1.4.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.86-.39,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1203.55,1581.61c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-453",
  cx: 1107.56,
  cy: 1558.36,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1107.56,1535.09c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.76,19l84.69-41.18C1127.76,1535.48,1117.85,1535.09,1107.56,1535.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1107.56,1580.2c-52,0-94.37-10-95.92-22.55,0,.23,0,.47,0,.71,0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.52,5.52,0,0,0,0-.71C1201.92,1570.17,1159.57,1580.2,1107.56,1580.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-454",
  d: "M1016.65,1566.81l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.72,1.72,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,3-1.23v-16.36A1.72,1.72,0,0,0,1016.65,1566.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-455",
  d: "M1023.68,1570.65l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l0,0a1.74,1.74,0,0,0,2.46-1.57v-17.06A1.73,1.73,0,0,0,1023.68,1570.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-456",
  d: "M1030.88,1573.33h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.71,1.71,0,0,0,1.18,1.64l0,0a1.74,1.74,0,0,0,2.29-1.65V1575A1.73,1.73,0,0,0,1030.88,1573.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-457",
  d: "M1038.13,1575.4h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,1038.13,1575.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-458",
  d: "M1045.41,1577.07h0a1.74,1.74,0,0,0-2.09,1.7v17.33a1.74,1.74,0,0,0,1.38,1.69h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.71,1.71,0,0,0,1045.41,1577.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-459",
  d: "M1052.71,1578.43h0a1.73,1.73,0,0,0-2,1.7v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.74,1.74,0,0,0,1052.71,1578.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-460",
  d: "M1060,1579.55h0a1.73,1.73,0,0,0-2,1.71v17.38a1.72,1.72,0,0,0,1.49,1.71h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.74,1.74,0,0,0,1060,1579.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-461",
  d: "M1067.32,1580.47h0a1.74,1.74,0,0,0-1.93,1.73v17.38a1.73,1.73,0,0,0,1.54,1.72h0a1.74,1.74,0,0,0,1.93-1.73v-17.38A1.73,1.73,0,0,0,1067.32,1580.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-462",
  d: "M1074.64,1581.2h0a1.73,1.73,0,0,0-1.88,1.72v17.4a1.73,1.73,0,0,0,1.58,1.72h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.74,1.74,0,0,0,1074.64,1581.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-463",
  d: "M1082,1581.77h0a1.72,1.72,0,0,0-1.84,1.72v17.41a1.72,1.72,0,0,0,1.61,1.72h0a1.74,1.74,0,0,0,1.85-1.73v-17.4A1.73,1.73,0,0,0,1082,1581.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-464",
  d: "M1089.28,1582.18h0a1.75,1.75,0,0,0-1.82,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.72,1.72,0,0,0,1.81-1.73v-17.41A1.73,1.73,0,0,0,1089.28,1582.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-465",
  d: "M1096.6,1582.46h0a1.74,1.74,0,0,0-1.78,1.74v17.4a1.74,1.74,0,0,0,1.68,1.74h0a1.74,1.74,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,1096.6,1582.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-466",
  d: "M1103.93,1582.59h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.72,1.72,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,1103.93,1582.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-467",
  d: "M1111.26,1582.59h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.72,1.72,0,0,0,1.71-1.73v-17.41A1.73,1.73,0,0,0,1111.26,1582.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-468",
  d: "M1118.58,1582.45h0a1.74,1.74,0,0,0-1.69,1.74v17.41a1.74,1.74,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.42A1.74,1.74,0,0,0,1118.58,1582.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-469",
  d: "M1125.91,1582.18h0a1.74,1.74,0,0,0-1.65,1.73v17.41a1.72,1.72,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,1125.91,1582.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-470",
  d: "M1133.23,1581.76h0a1.73,1.73,0,0,0-1.62,1.72v17.41a1.74,1.74,0,0,0,1.86,1.73h0a1.74,1.74,0,0,0,1.61-1.73v-17.41A1.73,1.73,0,0,0,1133.23,1581.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-471",
  d: "M1140.55,1581.19h0a1.73,1.73,0,0,0-1.58,1.72v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.58-1.73v-17.4A1.73,1.73,0,0,0,1140.55,1581.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-472",
  d: "M1147.86,1580.46h0a1.73,1.73,0,0,0-1.54,1.72v17.4a1.73,1.73,0,0,0,1.93,1.72h0a1.74,1.74,0,0,0,1.54-1.73v-17.39A1.73,1.73,0,0,0,1147.86,1580.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-473",
  d: "M1155.17,1579.54h0a1.73,1.73,0,0,0-1.5,1.71v17.39a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.49-1.72v-17.38A1.74,1.74,0,0,0,1155.17,1579.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-474",
  d: "M1162.48,1578.42h0a1.73,1.73,0,0,0-1.44,1.7v17.37a1.74,1.74,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,1162.48,1578.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-475",
  d: "M1169.77,1577.05h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.74,1.74,0,0,0,1.38-1.7v-17.34A1.74,1.74,0,0,0,1169.77,1577.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-476",
  d: "M1177.05,1575.38h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.71,1.71,0,0,0,1.29-1.67v-17.31A1.73,1.73,0,0,0,1177.05,1575.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-477",
  d: "M1184.31,1573.31h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.65V1575A1.72,1.72,0,0,0,1184.31,1573.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-478",
  d: "M1191.51,1570.62h0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.74,1.74,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1191.51,1570.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-479",
  d: "M1198.54,1566.75l0,0a1.73,1.73,0,0,0-.71,1.4v16.42a1.72,1.72,0,0,0,2.93,1.24l0,0a1.7,1.7,0,0,0,.53-1.23v-16.42A1.74,1.74,0,0,0,1198.54,1566.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-480",
  d: "M1192.34,1557.16v0a7.53,7.53,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,35.67,35.67,0,0,1-3.85,2.21c-1.09.54-2.26,1.07-3.51,1.58s-2.49,1-3.85,1.47c-1.12.39-2.29.78-3.5,1.15s-2.53.75-3.86,1.12l-3.5.9c-1.25.3-2.54.6-3.86.89-1.14.25-2.3.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4c-1.27.14-2.55.26-3.85.39l-3.5.31c-1.28.11-2.56.21-3.86.3l-3.5.24-3.86.22-3.5.16-3.85.14-3.5.1c-1.28,0-2.57.06-3.86.07s-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.85-.07-3.5-.1-3.86-.14-3.5-.17c-1.3-.06-2.58-.14-3.86-.22l-3.5-.23-3.85-.3-3.5-.32-3.86-.38-3.5-.4-3.86-.49c-1.18-.15-2.35-.32-3.5-.49l-3.85-.59c-1.19-.19-2.36-.39-3.5-.6-1.32-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.58-3.86-.89s-2.36-.6-3.5-.9c-1.33-.37-2.62-.74-3.85-1.12s-2.39-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1.05-3.5-1.59a34.91,34.91,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.27.22,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,2.74.27,1.11-.16c1.15-.17,2.32-.34,3.5-.49l3.86-.49,3.5-.4,3.86-.38,3.5-.32,3.85-.3,3.5-.23c1.28-.08,2.56-.16,3.86-.22l3.5-.17,3.86-.14,3.5-.1,3.85-.07c1.16,0,2.33,0,3.5,0h3.86c1.17,0,2.34,0,3.5,0l3.86.07,3.5.1,3.85.14c1.18,0,2.34.1,3.5.17s2.58.13,3.86.21l3.5.24c1.3.09,2.58.19,3.86.3l3.5.31c1.3.13,2.58.25,3.85.39l3.5.4c1.31.15,2.59.31,3.86.48l3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.38,3.51-.36,3.85-.38,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1192.34,1556.23c-.12,12.82-43,23.21-96,23.21s-96-10.41-96-23.26v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-481",
  cx: 1096.34,
  cy: 1532.98,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1096.34,1509.71c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.77,19l84.69-41.18C1116.55,1510.1,1106.63,1509.71,1096.34,1509.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1096.34,1554.82c-52,0-94.36-10-95.91-22.55a5.52,5.52,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.53,5.53,0,0,0,0-.71C1190.71,1544.79,1148.36,1554.82,1096.34,1554.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-482",
  d: "M1005.43,1541.43l0,0a1.73,1.73,0,0,0-2.75,1.4v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.69,1.69,0,0,0,1005.43,1541.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-483",
  d: "M1012.46,1545.27l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.71,1.71,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.47-1.56v-17.06A1.72,1.72,0,0,0,1012.46,1545.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-484",
  d: "M1019.66,1548h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.72,1.72,0,0,0,1.17,1.64l0,0a1.74,1.74,0,0,0,2.29-1.65V1549.6A1.73,1.73,0,0,0,1019.66,1548Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-485",
  d: "M1026.92,1550h0a1.73,1.73,0,0,0-2.16,1.68V1569a1.72,1.72,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67V1551.7A1.72,1.72,0,0,0,1026.92,1550Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-486",
  d: "M1034.2,1551.69h0a1.73,1.73,0,0,0-2.08,1.7v17.32a1.73,1.73,0,0,0,1.37,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,1034.2,1551.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-487",
  d: "M1041.49,1553.05h0a1.72,1.72,0,0,0-2,1.7v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.74,1.74,0,0,0,1041.49,1553.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-488",
  d: "M1048.8,1554.17h0a1.73,1.73,0,0,0-2,1.71v17.38a1.73,1.73,0,0,0,1.5,1.71h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,1048.8,1554.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-489",
  d: "M1056.11,1555.09h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.73,1.73,0,0,0,1056.11,1555.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-490",
  d: "M1063.43,1555.82h0a1.73,1.73,0,0,0-1.88,1.72v17.4a1.73,1.73,0,0,0,1.57,1.72h0a1.73,1.73,0,0,0,1.89-1.72v-17.39A1.74,1.74,0,0,0,1063.43,1555.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-491",
  d: "M1070.74,1556.39h0a1.73,1.73,0,0,0-1.85,1.72v17.4a1.73,1.73,0,0,0,1.62,1.73h0a1.74,1.74,0,0,0,1.85-1.73v-17.4A1.72,1.72,0,0,0,1070.74,1556.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-492",
  d: "M1078.07,1556.8h0a1.73,1.73,0,0,0-1.81,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,1078.07,1556.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-493",
  d: "M1085.39,1557.07h0a1.74,1.74,0,0,0-1.78,1.74v17.4a1.74,1.74,0,0,0,1.68,1.74h0a1.74,1.74,0,0,0,1.78-1.73v-17.41A1.74,1.74,0,0,0,1085.39,1557.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-494",
  d: "M1092.72,1557.21h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,1092.72,1557.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-495",
  d: "M1100,1557.21h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.73,1.73,0,0,0,1100,1557.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-496",
  d: "M1107.37,1557.07h0a1.74,1.74,0,0,0-1.68,1.74v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.69-1.73V1558.8A1.74,1.74,0,0,0,1107.37,1557.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-497",
  d: "M1114.69,1556.8h0a1.74,1.74,0,0,0-1.66,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,1114.69,1556.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-498",
  d: "M1122,1556.38h0a1.73,1.73,0,0,0-1.62,1.72v17.41a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.61-1.73v-17.41A1.74,1.74,0,0,0,1122,1556.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-499",
  d: "M1129.33,1555.81h0a1.72,1.72,0,0,0-1.58,1.72v17.4a1.73,1.73,0,0,0,1.89,1.73h0a1.74,1.74,0,0,0,1.58-1.73v-17.4A1.73,1.73,0,0,0,1129.33,1555.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-500",
  d: "M1136.65,1555.08h0a1.74,1.74,0,0,0-1.54,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.74,1.74,0,0,0,1.53-1.73V1556.8A1.72,1.72,0,0,0,1136.65,1555.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-501",
  d: "M1144,1554.16h0a1.73,1.73,0,0,0-1.49,1.71v17.39a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.49-1.72v-17.38A1.74,1.74,0,0,0,1144,1554.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-502",
  d: "M1151.26,1553h0a1.73,1.73,0,0,0-1.44,1.7v17.37a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,1151.26,1553Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-503",
  d: "M1158.56,1551.67h0a1.73,1.73,0,0,0-1.39,1.7v17.34a1.74,1.74,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,1158.56,1551.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-504",
  d: "M1165.84,1550h0a1.74,1.74,0,0,0-1.3,1.68V1569a1.73,1.73,0,0,0,2.17,1.67h0a1.72,1.72,0,0,0,1.3-1.67v-17.31A1.73,1.73,0,0,0,1165.84,1550Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-505",
  d: "M1173.1,1547.92l0,0a1.72,1.72,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.64h0a1.75,1.75,0,0,0,1.18-1.65v-17.24A1.74,1.74,0,0,0,1173.1,1547.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-506",
  d: "M1180.29,1545.24h0a1.75,1.75,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.74,1.74,0,0,0,1-1.56v-17.09A1.74,1.74,0,0,0,1180.29,1545.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-507",
  d: "M1187.33,1541.37l0,0a1.74,1.74,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.23v-16.42A1.73,1.73,0,0,0,1187.33,1541.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-508",
  d: "M1203.55,1531.78v0a7.56,7.56,0,0,1-2.26,5,18.89,18.89,0,0,1-3.5,2.91,36.86,36.86,0,0,1-3.86,2.21c-1.09.54-2.25,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.28.78-3.5,1.15s-2.52.75-3.86,1.12l-3.5.9c-1.25.3-2.53.6-3.85.89-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.73c-1.15.2-2.31.4-3.5.59s-2.55.41-3.86.6l-3.5.49c-1.26.17-2.55.33-3.85.48l-3.5.4-3.86.39-3.5.31c-1.27.11-2.56.21-3.86.3l-3.5.24-3.85.22-3.5.16-3.86.14-3.5.1-3.86.07c-1.16,0-2.32,0-3.5,0h-3.85c-1.17,0-2.34,0-3.5,0l-3.86-.07-3.5-.1-3.86-.14-3.5-.17c-1.29-.06-2.58-.14-3.85-.22l-3.5-.23-3.86-.3-3.5-.32c-1.3-.12-2.59-.25-3.86-.39s-2.34-.25-3.5-.39l-3.85-.49c-1.19-.15-2.35-.32-3.5-.49-1.31-.19-2.6-.39-3.86-.59s-2.35-.39-3.5-.6c-1.31-.23-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.6-.58-3.85-.89s-2.37-.6-3.5-.9c-1.34-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.41-1-3.5-1.59a35.67,35.67,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.47,7.47,0,0,1-2.24-5v0h0l0-24.16,2.27.22,3.5.34,3.85.38,3.5.34,3.86.38,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,2.75.27,1.11-.17c1.15-.16,2.31-.33,3.5-.48s2.55-.34,3.85-.49l3.5-.4,3.86-.38,3.5-.32,3.86-.3,3.5-.23c1.27-.08,2.56-.16,3.85-.22l3.5-.17,3.86-.14,3.5-.1,3.86-.07c1.16,0,2.32,0,3.5,0h3.85c1.18,0,2.34,0,3.5,0l3.86.07,3.5.1,3.86.14,3.5.16,3.85.22,3.5.24c1.3.09,2.59.19,3.86.3l3.5.31c1.3.12,2.59.25,3.86.39l3.5.4c1.3.15,2.59.31,3.85.48l3.5.49,1.4.21,2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,2.23-.23,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1203.55,1530.85c-.11,12.82-43,23.21-96,23.21s-96-10.41-96-23.26v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-509",
  cx: 1107.56,
  cy: 1507.6,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1107.56,1484.33c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.76,19l84.69-41.18C1127.76,1484.72,1117.85,1484.33,1107.56,1484.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1107.56,1529.44c-52,0-94.37-10-95.92-22.55,0,.23,0,.47,0,.71,0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.52,5.52,0,0,0,0-.71C1201.92,1519.41,1159.57,1529.44,1107.56,1529.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-510",
  d: "M1016.65,1516.05l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.72,1.72,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,3-1.23v-16.36A1.72,1.72,0,0,0,1016.65,1516.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-511",
  d: "M1023.68,1519.89l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.46-1.57v-17A1.73,1.73,0,0,0,1023.68,1519.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-512",
  d: "M1030.88,1522.57h0a1.73,1.73,0,0,0-2.26,1.65v17.21a1.71,1.71,0,0,0,1.18,1.64l0,0a1.74,1.74,0,0,0,2.29-1.65v-17.21A1.73,1.73,0,0,0,1030.88,1522.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-513",
  d: "M1038.13,1524.64h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.72,1.72,0,0,0,1.29,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,1038.13,1524.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-514",
  d: "M1045.41,1526.31h0a1.74,1.74,0,0,0-2.09,1.7v17.32a1.74,1.74,0,0,0,1.38,1.7h0a1.74,1.74,0,0,0,2.09-1.7V1528A1.71,1.71,0,0,0,1045.41,1526.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-515",
  d: "M1052.71,1527.67h0a1.73,1.73,0,0,0-2,1.7v17.36a1.75,1.75,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,1052.71,1527.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-516",
  d: "M1060,1528.79h0a1.73,1.73,0,0,0-2,1.71v17.38a1.72,1.72,0,0,0,1.49,1.71h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.74,1.74,0,0,0,1060,1528.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-517",
  d: "M1067.32,1529.71h0a1.74,1.74,0,0,0-1.93,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.73,1.73,0,0,0,1067.32,1529.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-518",
  d: "M1074.64,1530.44h0a1.73,1.73,0,0,0-1.88,1.72v17.4a1.73,1.73,0,0,0,1.58,1.72h0a1.72,1.72,0,0,0,1.89-1.72v-17.4A1.74,1.74,0,0,0,1074.64,1530.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-519",
  d: "M1082,1531h0a1.73,1.73,0,0,0-1.84,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.74,1.74,0,0,0,1.85-1.73v-17.4A1.73,1.73,0,0,0,1082,1531Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-520",
  d: "M1089.28,1531.42h0a1.74,1.74,0,0,0-1.82,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.72,1.72,0,0,0,1.81-1.73v-17.41A1.73,1.73,0,0,0,1089.28,1531.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-521",
  d: "M1096.6,1531.69h0a1.74,1.74,0,0,0-1.78,1.74v17.4a1.74,1.74,0,0,0,1.68,1.74h0a1.74,1.74,0,0,0,1.78-1.74v-17.4A1.74,1.74,0,0,0,1096.6,1531.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-522",
  d: "M1103.93,1531.83h0a1.73,1.73,0,0,0-1.75,1.73V1551a1.73,1.73,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,1103.93,1531.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-523",
  d: "M1111.26,1531.83h0a1.73,1.73,0,0,0-1.72,1.73V1551a1.73,1.73,0,0,0,1.75,1.73h0A1.73,1.73,0,0,0,1113,1551v-17.41A1.73,1.73,0,0,0,1111.26,1531.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-524",
  d: "M1118.58,1531.69h0a1.74,1.74,0,0,0-1.69,1.73v17.42a1.74,1.74,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.68-1.74v-17.41A1.74,1.74,0,0,0,1118.58,1531.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-525",
  d: "M1125.91,1531.42h0a1.74,1.74,0,0,0-1.65,1.73v17.41a1.72,1.72,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,1125.91,1531.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-526",
  d: "M1133.23,1531h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.86,1.73h0a1.74,1.74,0,0,0,1.61-1.73v-17.41A1.73,1.73,0,0,0,1133.23,1531Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-527",
  d: "M1140.55,1530.43h0a1.73,1.73,0,0,0-1.58,1.72v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.72,1.72,0,0,0,1.58-1.72v-17.4A1.73,1.73,0,0,0,1140.55,1530.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-528",
  d: "M1147.86,1529.7h0a1.73,1.73,0,0,0-1.54,1.72v17.4a1.73,1.73,0,0,0,1.93,1.72h0a1.72,1.72,0,0,0,1.54-1.72v-17.39A1.73,1.73,0,0,0,1147.86,1529.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-529",
  d: "M1155.17,1528.78h0a1.73,1.73,0,0,0-1.5,1.71v17.39a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.49-1.72V1530.5A1.74,1.74,0,0,0,1155.17,1528.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-530",
  d: "M1162.48,1527.66h0a1.73,1.73,0,0,0-1.44,1.7v17.37a1.74,1.74,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,1162.48,1527.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-531",
  d: "M1169.77,1526.29h0a1.73,1.73,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.69h0a1.74,1.74,0,0,0,1.38-1.7V1528A1.74,1.74,0,0,0,1169.77,1526.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-532",
  d: "M1177.05,1524.62h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.72,1.72,0,0,0,1.29-1.67V1526.3A1.73,1.73,0,0,0,1177.05,1524.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-533",
  d: "M1184.31,1522.54l0,0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.65v-17.24A1.73,1.73,0,0,0,1184.31,1522.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-534",
  d: "M1191.51,1519.86h0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.75,1.75,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1191.51,1519.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-535",
  d: "M1198.54,1516l0,0a1.72,1.72,0,0,0-.71,1.4v16.42a1.72,1.72,0,0,0,2.93,1.24l0,0a1.7,1.7,0,0,0,.53-1.24v-16.41A1.74,1.74,0,0,0,1198.54,1516Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-536",
  d: "M1196,1506.4v0a7.57,7.57,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,34.91,34.91,0,0,1-3.86,2.21c-1.08.54-2.25,1.07-3.5,1.58s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.12l-3.5.9c-1.25.3-2.54.6-3.86.89-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4-3.85.39-3.5.31c-1.28.11-2.56.21-3.86.3l-3.5.23c-1.28.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07c-1.16,0-2.33,0-3.5,0h-3.86c-1.17,0-2.34,0-3.5,0l-3.85-.07-3.5-.1-3.86-.14-3.5-.17c-1.3-.06-2.58-.14-3.86-.22l-3.5-.23-3.86-.3-3.5-.32c-1.29-.12-2.58-.25-3.85-.39s-2.35-.25-3.5-.39l-3.86-.49c-1.18-.15-2.35-.32-3.5-.49l-3.86-.59c-1.18-.2-2.35-.39-3.5-.6-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.36-.6-3.5-.9c-1.33-.37-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.35-.48-2.64-1-3.85-1.47s-2.42-1.05-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.27.22,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.17c1.15-.16,2.32-.33,3.5-.48s2.56-.34,3.86-.49l3.5-.4,3.85-.38,3.5-.32,3.86-.3,3.5-.23c1.28-.08,2.56-.16,3.86-.22s2.32-.12,3.5-.17l3.86-.14,3.5-.1,3.85-.07c1.16,0,2.33,0,3.5,0H1102c1.17,0,2.34,0,3.5,0l3.86.07,3.5.1c1.29,0,2.58.08,3.85.14l3.5.16,3.86.22,3.5.24c1.3.09,2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39l3.5.4c1.31.15,2.59.31,3.86.48l3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.38,3.5-.36,3.86-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1196,1505.47c-.12,12.82-43,23.21-96,23.21s-96-10.41-96-23.26v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-537",
  cx: 1100.02,
  cy: 1482.22,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1100,1459c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.82,40.77,19l84.69-41.18C1120.22,1459.34,1110.31,1459,1100,1459Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1100,1504.06c-52,0-94.36-10-95.91-22.55a5.52,5.52,0,0,0-.05.71c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26a5.53,5.53,0,0,0,0-.71C1194.39,1494,1152,1504.06,1100,1504.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-538",
  d: "M1009.11,1490.66l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.72,1.72,0,0,0,1009.11,1490.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-539",
  d: "M1016.14,1494.51l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l.05,0a1.73,1.73,0,0,0,2.47-1.57V1496.1A1.71,1.71,0,0,0,1016.14,1494.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-540",
  d: "M1023.34,1497.19h0a1.73,1.73,0,0,0-2.27,1.64V1516a1.73,1.73,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64v-17.21A1.72,1.72,0,0,0,1023.34,1497.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-541",
  d: "M1030.6,1499.26h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.72,1.72,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.73,1.73,0,0,0,1030.6,1499.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-542",
  d: "M1037.88,1500.93h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.72,1.72,0,0,0,1037.88,1500.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-543",
  d: "M1045.17,1502.29h0a1.75,1.75,0,0,0-2,1.71v17.36a1.75,1.75,0,0,0,1.45,1.71h0a1.73,1.73,0,0,0,2-1.71V1504A1.72,1.72,0,0,0,1045.17,1502.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-544",
  d: "M1052.48,1503.41h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.74,1.74,0,0,0,1052.48,1503.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-545",
  d: "M1059.79,1504.33h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.73,1.73,0,0,0,1059.79,1504.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-546",
  d: "M1067.1,1505.06h0a1.73,1.73,0,0,0-1.89,1.72v17.4a1.74,1.74,0,0,0,1.58,1.72h0a1.72,1.72,0,0,0,1.88-1.72v-17.4A1.73,1.73,0,0,0,1067.1,1505.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-547",
  d: "M1074.42,1505.63h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.72v-17.4A1.73,1.73,0,0,0,1074.42,1505.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-548",
  d: "M1081.74,1506h0a1.72,1.72,0,0,0-1.81,1.73v17.41a1.73,1.73,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,1081.74,1506Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-549",
  d: "M1089.07,1506.31h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.74,1.74,0,0,0,1.68,1.74h0a1.75,1.75,0,0,0,1.79-1.74v-17.4A1.74,1.74,0,0,0,1089.07,1506.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-550",
  d: "M1096.39,1506.45h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,1096.39,1506.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-551",
  d: "M1103.72,1506.45h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.73,1.73,0,0,0,1103.72,1506.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-552",
  d: "M1111.05,1506.31h0a1.73,1.73,0,0,0-1.68,1.73v17.42a1.74,1.74,0,0,0,1.78,1.73h0a1.74,1.74,0,0,0,1.69-1.74V1508A1.74,1.74,0,0,0,1111.05,1506.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-553",
  d: "M1118.37,1506h0a1.74,1.74,0,0,0-1.66,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.72,1.72,0,0,0,1118.37,1506Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-554",
  d: "M1125.69,1505.62h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.61-1.72v-17.41A1.73,1.73,0,0,0,1125.69,1505.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-555",
  d: "M1133,1505.05h0a1.71,1.71,0,0,0-1.58,1.72v17.4a1.73,1.73,0,0,0,1.88,1.73h0a1.74,1.74,0,0,0,1.58-1.72v-17.4A1.74,1.74,0,0,0,1133,1505.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-556",
  d: "M1140.33,1504.32h0a1.74,1.74,0,0,0-1.54,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72V1506A1.73,1.73,0,0,0,1140.33,1504.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-557",
  d: "M1147.64,1503.4h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.49-1.72v-17.38A1.74,1.74,0,0,0,1147.64,1503.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-558",
  d: "M1154.94,1502.28h0a1.74,1.74,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.45-1.71V1504A1.73,1.73,0,0,0,1154.94,1502.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-559",
  d: "M1162.24,1500.91h0a1.72,1.72,0,0,0-1.38,1.69V1520a1.73,1.73,0,0,0,2.09,1.69h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,1162.24,1500.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-560",
  d: "M1169.52,1499.24h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.73,1.73,0,0,0,2.17,1.67h0a1.73,1.73,0,0,0,1.3-1.67v-17.31A1.73,1.73,0,0,0,1169.52,1499.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-561",
  d: "M1176.77,1497.16l0,0a1.72,1.72,0,0,0-1.2,1.64v17.25a1.73,1.73,0,0,0,2.28,1.64h0a1.75,1.75,0,0,0,1.18-1.65v-17.24A1.74,1.74,0,0,0,1176.77,1497.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-562",
  d: "M1184,1494.47l0,0a1.73,1.73,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1184,1494.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-563",
  d: "M1191,1490.61l0,0a1.72,1.72,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.24V1492A1.74,1.74,0,0,0,1191,1490.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-564",
  d: "M1210.91,1481v0a7.53,7.53,0,0,1-2.27,5,18.56,18.56,0,0,1-3.5,2.91,35.67,35.67,0,0,1-3.85,2.21c-1.09.54-2.26,1.07-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.91s-2.54.6-3.86.89c-1.14.25-2.3.49-3.5.73s-2.54.49-3.85.73l-3.5.59c-1.27.21-2.55.41-3.86.6l-3.5.49c-1.27.17-2.55.33-3.86.48l-3.5.4-3.85.39-3.5.31-3.86.3-3.5.23c-1.27.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07c-1.16,0-2.33,0-3.5,0H1113c-1.17,0-2.34,0-3.5,0l-3.85-.07-3.5-.1-3.86-.14-3.5-.17c-1.3-.06-2.58-.14-3.86-.22l-3.5-.23-3.85-.31c-1.18-.09-2.35-.2-3.5-.31s-2.59-.25-3.86-.39-2.35-.25-3.5-.39l-3.86-.49c-1.18-.15-2.35-.32-3.5-.49l-3.85-.59-3.5-.6c-1.32-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89l-3.5-.9c-1.33-.37-2.62-.74-3.85-1.12s-2.39-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.5,7.5,0,0,1-2.23-5v0h0l0-24.16,2.26.22,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,3.86.37,3.5.35,3.86.38,3.5.34,2.74.27,1.11-.17,3.5-.49c1.27-.16,2.56-.33,3.86-.48l3.5-.4,3.86-.39,3.5-.31,3.85-.3,3.5-.23,3.86-.23,3.5-.16,3.86-.14,3.5-.1c1.28,0,2.56-.06,3.85-.07s2.33,0,3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.86.07l3.5.09c1.29,0,2.58.09,3.85.15l3.5.16,3.86.22c1.18.08,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39l3.5.39,3.86.49,3.5.49,1.39.21,2.47-.25,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.38,3.5-.36,2.23-.22,0,24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1210.91,1480.09c-.12,12.82-43,23.21-96,23.21s-96-10.41-96-23.27v0h0l0-23.16h0l0,24.16h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-565",
  cx: 1114.91,
  cy: 1456.84,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1114.91,1433.57c-53,0-96,10.42-96,23.27,0,7.86,16.1,14.82,40.76,19l84.69-41.18C1135.12,1434,1125.2,1433.57,1114.91,1433.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1114.91,1478.68c-52,0-94.36-10-95.91-22.56a5.79,5.79,0,0,0,0,.72c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26a5.79,5.79,0,0,0,0-.72C1209.28,1468.65,1166.93,1478.68,1114.91,1478.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-566",
  d: "M1024,1465.28l0,0a1.73,1.73,0,0,0-2.75,1.4V1483a1.73,1.73,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.36A1.74,1.74,0,0,0,1024,1465.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-567",
  d: "M1031,1469.13l0,0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.72,1.72,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.47-1.57v-17A1.71,1.71,0,0,0,1031,1469.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-568",
  d: "M1038.23,1471.81l0,0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.72,1.72,0,0,0,1.17,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.21A1.73,1.73,0,0,0,1038.23,1471.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-569",
  d: "M1045.49,1473.88h0a1.73,1.73,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.67h0a1.73,1.73,0,0,0,2.17-1.67v-17.29A1.72,1.72,0,0,0,1045.49,1473.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-570",
  d: "M1052.77,1475.54h0a1.73,1.73,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.38,1.7h0a1.74,1.74,0,0,0,2.09-1.7v-17.33A1.74,1.74,0,0,0,1052.77,1475.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-571",
  d: "M1060.07,1476.91h0a1.73,1.73,0,0,0-2,1.71V1496a1.73,1.73,0,0,0,1.44,1.7h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,1060.07,1476.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-572",
  d: "M1067.37,1478h0a1.73,1.73,0,0,0-2,1.71v17.37a1.74,1.74,0,0,0,1.5,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.37A1.73,1.73,0,0,0,1067.37,1478Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-573",
  d: "M1074.68,1479h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.72,1.72,0,0,0,1074.68,1479Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-574",
  d: "M1082,1479.68h0a1.72,1.72,0,0,0-1.88,1.72v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.74,1.74,0,0,0,1082,1479.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-575",
  d: "M1089.32,1480.25h0a1.74,1.74,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.72V1482A1.72,1.72,0,0,0,1089.32,1480.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-576",
  d: "M1096.64,1480.66h0a1.73,1.73,0,0,0-1.81,1.73v17.41a1.74,1.74,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.41A1.74,1.74,0,0,0,1096.64,1480.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-577",
  d: "M1104,1480.93h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.74v-17.4A1.74,1.74,0,0,0,1104,1480.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-578",
  d: "M1111.29,1481.07h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.74-1.73V1482.8A1.73,1.73,0,0,0,1111.29,1481.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-579",
  d: "M1118.61,1481.07h0a1.73,1.73,0,0,0-1.72,1.73v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73V1482.8A1.73,1.73,0,0,0,1118.61,1481.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-580",
  d: "M1125.94,1480.93h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.74,1.74,0,0,0,1.78,1.74h0a1.74,1.74,0,0,0,1.68-1.74v-17.41A1.74,1.74,0,0,0,1125.94,1480.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-581",
  d: "M1133.26,1480.66h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.73,1.73,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.64-1.73v-17.41A1.72,1.72,0,0,0,1133.26,1480.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-582",
  d: "M1140.58,1480.24h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.74,1.74,0,0,0,1.85,1.73h0a1.72,1.72,0,0,0,1.61-1.72V1482A1.73,1.73,0,0,0,1140.58,1480.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-583",
  d: "M1147.9,1479.67h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.73h0a1.74,1.74,0,0,0,1.58-1.72v-17.4A1.73,1.73,0,0,0,1147.9,1479.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-584",
  d: "M1155.22,1478.94h0a1.74,1.74,0,0,0-1.55,1.72v17.4a1.74,1.74,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.72,1.72,0,0,0,1155.22,1478.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-585",
  d: "M1162.53,1478h0a1.73,1.73,0,0,0-1.49,1.71v17.38a1.73,1.73,0,0,0,2,1.72h0a1.75,1.75,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,1162.53,1478Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-586",
  d: "M1169.83,1476.9h0a1.74,1.74,0,0,0-1.44,1.71V1496a1.73,1.73,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.36A1.73,1.73,0,0,0,1169.83,1476.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-587",
  d: "M1177.13,1475.53h0a1.72,1.72,0,0,0-1.39,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.73,1.73,0,0,0,1.37-1.7v-17.34A1.73,1.73,0,0,0,1177.13,1475.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-588",
  d: "M1184.41,1473.86h0a1.73,1.73,0,0,0-1.31,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.67v-17.31A1.73,1.73,0,0,0,1184.41,1473.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-589",
  d: "M1191.67,1471.78h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.28,1.65l0,0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,1191.67,1471.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-590",
  d: "M1198.87,1469.09l0,0a1.74,1.74,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.75,1.75,0,0,0,1-1.57v-17.09A1.74,1.74,0,0,0,1198.87,1469.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-591",
  d: "M1205.9,1465.23l0,0a1.73,1.73,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1205.9,1465.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-592",
  d: "M1199.87,1452.58v0a7.52,7.52,0,0,1-2.26,5.05,19.31,19.31,0,0,1-3.5,2.92,35.87,35.87,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.4-2.28.78-3.5,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.6-3.86.89c-1.14.25-2.31.5-3.5.73s-2.55.5-3.86.73c-1.14.21-2.31.4-3.5.6l-3.85.59c-1.15.17-2.32.34-3.5.49l-3.86.49c-1.15.13-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.85.3s-2.33.17-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.11-3.86.15s-2.32.07-3.5.09l-3.85.08-3.5,0H1102l-3.5,0c-1.29,0-2.58,0-3.86-.07s-2.34-.06-3.5-.09-2.58-.09-3.85-.15l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.19-3.86-.3l-3.5-.31c-1.3-.13-2.58-.25-3.86-.39l-3.49-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.6-.47-3.86-.72s-2.35-.48-3.5-.73c-1.32-.29-2.6-.59-3.85-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.86-1.47s-2.41-1-3.5-1.59a34.07,34.07,0,0,1-3.85-2.21,18.64,18.64,0,0,1-3.5-2.92,7.54,7.54,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.85.37,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.86-.49c1.15-.13,2.32-.27,3.49-.39s2.56-.27,3.86-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07,3.5,0h3.86l3.5,0,3.85.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.86.22l3.5.23,3.85.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.86.49s2.35.31,3.5.48l1.39.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1199.87,1451.65c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-593",
  cx: 1103.88,
  cy: 1428.4,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1103.88,1405.13c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.76,19l84.69-41.19C1124.08,1405.53,1114.17,1405.13,1103.88,1405.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1103.88,1450.25c-52,0-94.36-10-95.91-22.56a5.65,5.65,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0,0-.71C1198.24,1440.21,1155.89,1450.25,1103.88,1450.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-594",
  d: "M1013,1436.85l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.74,1.74,0,0,0,.51,1.24l0,0a1.74,1.74,0,0,0,3-1.24v-16.36A1.73,1.73,0,0,0,1013,1436.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-595",
  d: "M1020,1440.69l0,0a1.74,1.74,0,0,0-2.42,1.59v17.06a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,1020,1440.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-596",
  d: "M1027.2,1443.37h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64V1445A1.74,1.74,0,0,0,1027.2,1443.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-597",
  d: "M1034.45,1445.44h0a1.74,1.74,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1034.45,1445.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-598",
  d: "M1041.73,1447.11h0a1.74,1.74,0,0,0-2.09,1.7v17.33a1.73,1.73,0,0,0,1.38,1.69h0a1.72,1.72,0,0,0,2.08-1.69v-17.33A1.73,1.73,0,0,0,1041.73,1447.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-599",
  d: "M1049,1448.48h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1049,1448.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-600",
  d: "M1056.34,1449.6h0a1.73,1.73,0,0,0-2,1.72v17.37a1.75,1.75,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,1056.34,1449.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-601",
  d: "M1063.64,1450.51h0a1.72,1.72,0,0,0-1.92,1.72v17.38a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.92-1.72v-17.39A1.73,1.73,0,0,0,1063.64,1450.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-602",
  d: "M1071,1451.24h0A1.73,1.73,0,0,0,1069,1453v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73V1453A1.74,1.74,0,0,0,1071,1451.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-603",
  d: "M1078.28,1451.81h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1078.28,1451.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-604",
  d: "M1085.6,1452.23h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.64,1.73h0a1.73,1.73,0,0,0,1.82-1.73V1454A1.73,1.73,0,0,0,1085.6,1452.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-605",
  d: "M1092.93,1452.5h0a1.73,1.73,0,0,0-1.78,1.73v17.41a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,1092.93,1452.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-606",
  d: "M1100.25,1452.63h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.71,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1100.25,1452.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-607",
  d: "M1107.58,1452.63h0a1.73,1.73,0,0,0-1.71,1.73v17.42a1.73,1.73,0,0,0,1.74,1.73h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,1107.58,1452.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-608",
  d: "M1114.9,1452.5h0a1.73,1.73,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1114.9,1452.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-609",
  d: "M1122.23,1452.22h0a1.73,1.73,0,0,0-1.65,1.73v17.4a1.74,1.74,0,0,0,1.81,1.74h0a1.73,1.73,0,0,0,1.65-1.73V1454A1.74,1.74,0,0,0,1122.23,1452.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-610",
  d: "M1129.55,1451.81h0a1.73,1.73,0,0,0-1.61,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,1129.55,1451.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-611",
  d: "M1136.87,1451.24h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.74,1.74,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73V1453A1.73,1.73,0,0,0,1136.87,1451.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-612",
  d: "M1144.19,1450.5h0a1.72,1.72,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.4A1.73,1.73,0,0,0,1144.19,1450.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-613",
  d: "M1151.49,1449.59h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.5-1.72V1451.3A1.73,1.73,0,0,0,1151.49,1449.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-614",
  d: "M1158.8,1448.46h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,1158.8,1448.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-615",
  d: "M1166.1,1447.1h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.72,1.72,0,0,0,1.38-1.69v-17.35A1.72,1.72,0,0,0,1166.1,1447.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-616",
  d: "M1173.38,1445.43h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.74,1.74,0,0,0,1.3-1.68V1447.1A1.73,1.73,0,0,0,1173.38,1445.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-617",
  d: "M1180.63,1443.35h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.64V1445A1.73,1.73,0,0,0,1180.63,1443.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-618",
  d: "M1187.83,1440.66l0,0a1.72,1.72,0,0,0-1,1.58v17.1a1.74,1.74,0,0,0,2.46,1.57l0,0a1.71,1.71,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1187.83,1440.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-619",
  d: "M1194.86,1436.8l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24V1438.2A1.73,1.73,0,0,0,1194.86,1436.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-620",
  d: "M1199.87,1424.12v0a7.56,7.56,0,0,1-2.26,5,19.29,19.29,0,0,1-3.5,2.91,35.87,35.87,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.4-2.28.78-3.5,1.16s-2.52.75-3.85,1.11c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.72c-1.14.21-2.31.41-3.5.6s-2.55.4-3.85.6-2.32.33-3.5.48l-3.86.49c-1.15.14-2.32.27-3.5.39s-2.56.27-3.86.39-2.32.22-3.5.31l-3.85.31-3.5.23-3.86.22-3.5.17-3.86.14-3.5.1-3.85.07-3.5,0H1102l-3.5,0-3.86-.07-3.5-.1c-1.29,0-2.58-.09-3.85-.15l-3.5-.16-3.86-.22c-1.18-.07-2.34-.15-3.5-.24s-2.58-.19-3.86-.3l-3.5-.31c-1.3-.12-2.58-.25-3.85-.39l-3.5-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.6-.48-3.86-.73s-2.35-.48-3.5-.73c-1.31-.29-2.6-.59-3.85-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.12s-2.38-.75-3.5-1.15c-1.36-.47-2.64-1-3.86-1.47s-2.41-1-3.5-1.58a37.43,37.43,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.86-.48l3.5-.4c1.27-.14,2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.16,3.5-.24l3.86-.22,3.5-.16c1.27-.06,2.56-.11,3.85-.15l3.5-.1,3.86-.07,3.5,0h3.86l3.5,0,3.85.07,3.5.1c1.3,0,2.58.09,3.86.15s2.34.1,3.5.16l3.86.22c1.17.07,2.34.15,3.5.24s2.58.19,3.85.3,2.35.2,3.5.31,2.59.25,3.86.39,2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.46-.24,3.5-.36,3.86-.38,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1199.87,1423.19c-.11,12.83-43,23.22-95.95,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s95.95-10.41,95.95-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-621",
  cx: 1103.88,
  cy: 1399.94,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1103.88,1376.67c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.76,19l84.69-41.19C1124.08,1377.07,1114.17,1376.67,1103.88,1376.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1103.88,1421.79c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.78,5.78,0,0,0,0-.71C1198.24,1411.75,1155.89,1421.79,1103.88,1421.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-622",
  d: "M1013,1408.39l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.51,1.23l0,0a1.74,1.74,0,0,0,3-1.24v-16.36A1.73,1.73,0,0,0,1013,1408.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-623",
  d: "M1020,1412.23h0a1.73,1.73,0,0,0-2.42,1.59v17a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,1020,1412.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-624",
  d: "M1027.2,1414.91h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.74,1.74,0,0,0,1027.2,1414.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-625",
  d: "M1034.45,1417h0a1.72,1.72,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1034.45,1417Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-626",
  d: "M1041.73,1418.65h0a1.74,1.74,0,0,0-2.09,1.7v17.33a1.74,1.74,0,0,0,1.38,1.7h0a1.72,1.72,0,0,0,2.08-1.69v-17.33A1.73,1.73,0,0,0,1041.73,1418.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-627",
  d: "M1049,1420h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1049,1420Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-628",
  d: "M1056.34,1421.14h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,1056.34,1421.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-629",
  d: "M1063.64,1422.05h0a1.72,1.72,0,0,0-1.92,1.72v17.38a1.73,1.73,0,0,0,1.53,1.73h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1063.64,1422.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-630",
  d: "M1071,1422.79h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.72,1.72,0,0,0,1071,1422.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-631",
  d: "M1078.28,1423.35h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1078.28,1423.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-632",
  d: "M1085.6,1423.77h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.64,1.73h0a1.75,1.75,0,0,0,1.82-1.74v-17.4A1.73,1.73,0,0,0,1085.6,1423.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-633",
  d: "M1092.93,1424h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.69,1.73h0a1.72,1.72,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,1092.93,1424Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-634",
  d: "M1100.25,1424.17h0a1.73,1.73,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,1100.25,1424.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-635",
  d: "M1107.58,1424.17h0a1.73,1.73,0,0,0-1.71,1.74v17.41a1.73,1.73,0,0,0,1.74,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,1107.58,1424.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-636",
  d: "M1114.9,1424h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1114.9,1424Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-637",
  d: "M1122.23,1423.77h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.74,1.74,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.74v-17.4A1.73,1.73,0,0,0,1122.23,1423.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-638",
  d: "M1129.55,1423.35h0a1.73,1.73,0,0,0-1.61,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,1129.55,1423.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-639",
  d: "M1136.87,1422.78h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.73,1.73,0,0,0,1136.87,1422.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-640",
  d: "M1144.19,1422h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.39A1.74,1.74,0,0,0,1144.19,1422Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-641",
  d: "M1151.49,1421.13h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.5-1.71v-17.39A1.73,1.73,0,0,0,1151.49,1421.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-642",
  d: "M1158.8,1420h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.7h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.74,1.74,0,0,0,1158.8,1420Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-643",
  d: "M1166.1,1418.64h0a1.74,1.74,0,0,0-1.38,1.7v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,1166.1,1418.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-644",
  d: "M1173.38,1417h0a1.71,1.71,0,0,0-1.3,1.67V1436a1.73,1.73,0,0,0,2.17,1.68h0a1.74,1.74,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,1173.38,1417Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-645",
  d: "M1180.63,1414.89h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,1180.63,1414.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-646",
  d: "M1187.83,1412.2l0,0a1.73,1.73,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1187.83,1412.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-647",
  d: "M1194.86,1408.34l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1194.86,1408.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-648",
  d: "M1192.32,1396.65v0a7.49,7.49,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,35.68,35.68,0,0,1-3.85,2.2c-1.09.54-2.26,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.4-2.29.78-3.5,1.15s-2.52.76-3.86,1.12c-1.13.31-2.3.61-3.5.9s-2.53.61-3.85.89c-1.15.25-2.31.5-3.5.73s-2.55.5-3.86.73c-1.15.21-2.31.41-3.5.6s-2.55.4-3.86.59c-1.15.17-2.31.34-3.5.49l-3.85.49c-1.16.14-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.86.3-1.15.09-2.32.17-3.5.24l-3.85.22-3.5.16c-1.28.06-2.57.11-3.86.15l-3.5.1-3.86.07-3.5,0h-3.85l-3.5,0-3.86-.08c-1.17,0-2.34-.06-3.5-.09s-2.58-.09-3.86-.15l-3.5-.16-3.85-.22c-1.18-.08-2.35-.15-3.5-.24s-2.59-.19-3.86-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39l-3.5-.4c-1.3-.15-2.59-.31-3.85-.48l-3.5-.49c-1.31-.19-2.6-.39-3.86-.6s-2.35-.39-3.5-.59c-1.31-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.6-.59-3.86-.9s-2.36-.59-3.5-.9c-1.33-.36-2.61-.73-3.85-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.42-1-3.5-1.59a34.25,34.25,0,0,1-3.86-2.21,18.59,18.59,0,0,1-3.5-2.92,7.54,7.54,0,0,1-2.23-5v0h0l0-24.17,2.26.22,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,2.74.26,1.12-.16,3.5-.49,3.85-.49c1.16-.13,2.32-.27,3.5-.39s2.56-.27,3.86-.39l3.5-.31c1.27-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.85-.22,3.5-.16c1.28-.06,2.56-.11,3.86-.15l3.5-.1,3.86-.07,3.5,0h3.85l3.5,0,3.86.07,3.5.1,3.86.14,3.5.17,3.85.22,3.5.23,3.86.31c1.18.09,2.34.2,3.5.31s2.58.25,3.86.39,2.34.25,3.5.39,2.58.32,3.85.49,2.35.32,3.5.48l1.4.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.85-.38,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,2.24-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1192.32,1395.72c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-649",
  cx: 1096.33,
  cy: 1372.47,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1096.33,1349.2c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.76,19l84.69-41.19C1116.53,1349.6,1106.62,1349.2,1096.33,1349.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1096.33,1394.32c-52,0-94.37-10-95.92-22.56a5.63,5.63,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0,0-.71C1190.69,1384.28,1148.34,1394.32,1096.33,1394.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-650",
  d: "M1005.42,1380.92l0,0a1.74,1.74,0,0,0-2.75,1.4v16.35a1.75,1.75,0,0,0,.52,1.24l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.72,1.72,0,0,0,1005.42,1380.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-651",
  d: "M1012.45,1384.76h0a1.73,1.73,0,0,0-2.42,1.59v17.05a1.73,1.73,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,1012.45,1384.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-652",
  d: "M1019.64,1387.44h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.22A1.74,1.74,0,0,0,1019.64,1387.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-653",
  d: "M1026.9,1389.51h0a1.74,1.74,0,0,0-2.17,1.68v17.29a1.74,1.74,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.16-1.68v-17.29A1.73,1.73,0,0,0,1026.9,1389.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-654",
  d: "M1034.18,1391.18h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.38,1.69h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,1034.18,1391.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-655",
  d: "M1041.48,1392.55h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.74,1.74,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1041.48,1392.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-656",
  d: "M1048.78,1393.67h0a1.73,1.73,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.72h0a1.74,1.74,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,1048.78,1393.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-657",
  d: "M1056.09,1394.58h0a1.73,1.73,0,0,0-1.93,1.72v17.38a1.72,1.72,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72V1396.3A1.73,1.73,0,0,0,1056.09,1394.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-658",
  d: "M1063.41,1395.31h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.74,1.74,0,0,0,1.89-1.73V1397A1.74,1.74,0,0,0,1063.41,1395.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-659",
  d: "M1070.73,1395.88h0a1.73,1.73,0,0,0-1.84,1.73V1415a1.73,1.73,0,0,0,1.61,1.73h0a1.74,1.74,0,0,0,1.86-1.73v-17.4A1.74,1.74,0,0,0,1070.73,1395.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-660",
  d: "M1078.05,1396.3h0a1.73,1.73,0,0,0-1.81,1.73v17.4a1.73,1.73,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.81-1.73V1398A1.73,1.73,0,0,0,1078.05,1396.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-661",
  d: "M1085.37,1396.57h0a1.72,1.72,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.73V1398.3A1.73,1.73,0,0,0,1085.37,1396.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-662",
  d: "M1092.7,1396.7h0a1.73,1.73,0,0,0-1.74,1.73v17.41a1.73,1.73,0,0,0,1.71,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1092.7,1396.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-663",
  d: "M1100,1396.7h0a1.73,1.73,0,0,0-1.72,1.73v17.42a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.71-1.73v-17.42A1.73,1.73,0,0,0,1100,1396.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-664",
  d: "M1107.35,1396.57h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.68-1.73V1398.3A1.73,1.73,0,0,0,1107.35,1396.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-665",
  d: "M1114.67,1396.29h0A1.72,1.72,0,0,0,1113,1398v17.41a1.74,1.74,0,0,0,1.81,1.73h0a1.73,1.73,0,0,0,1.65-1.73V1398A1.75,1.75,0,0,0,1114.67,1396.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-666",
  d: "M1122,1395.88h0a1.74,1.74,0,0,0-1.62,1.73V1415a1.73,1.73,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.61-1.73v-17.4A1.72,1.72,0,0,0,1122,1395.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-667",
  d: "M1129.32,1395.31h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.58-1.73V1397A1.73,1.73,0,0,0,1129.32,1395.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-668",
  d: "M1136.63,1394.57h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.4A1.74,1.74,0,0,0,1136.63,1394.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-669",
  d: "M1143.94,1393.66h0a1.74,1.74,0,0,0-1.5,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,1143.94,1393.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-670",
  d: "M1151.25,1392.53h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.75,1.75,0,0,0,1.44-1.71v-17.37A1.74,1.74,0,0,0,1151.25,1392.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-671",
  d: "M1158.54,1391.17h0a1.73,1.73,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,1158.54,1391.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-672",
  d: "M1165.82,1389.5h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.68v-17.31A1.72,1.72,0,0,0,1165.82,1389.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-673",
  d: "M1173.08,1387.42h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,1173.08,1387.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-674",
  d: "M1180.28,1384.73l0,0a1.72,1.72,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.72,1.72,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1180.28,1384.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-675",
  d: "M1187.31,1380.87l0,0a1.72,1.72,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.71,1.71,0,0,0,.52-1.24v-16.41A1.72,1.72,0,0,0,1187.31,1380.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-676",
  d: "M1196.2,1371.27v0a7.54,7.54,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,34.93,34.93,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.85,1.46c-1.12.4-2.29.78-3.51,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.6-3.86.89c-1.14.25-2.31.5-3.5.73s-2.54.5-3.86.73c-1.14.21-2.31.4-3.5.6l-3.85.59c-1.15.17-2.32.34-3.5.49l-3.86.49c-1.15.13-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.55.21-3.85.3s-2.33.17-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.11-3.86.15s-2.32.07-3.5.09l-3.85.08-3.5,0h-3.86l-3.5,0c-1.29,0-2.58,0-3.86-.07s-2.34-.06-3.5-.09-2.58-.09-3.85-.15l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.19-3.86-.3l-3.5-.31c-1.3-.13-2.58-.25-3.85-.39l-3.5-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.59-.47-3.85-.72s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.85-1.47s-2.42-1-3.5-1.59a33.38,33.38,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.92,7.54,7.54,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.86-.49c1.15-.13,2.32-.27,3.5-.39s2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07,3.5,0h3.86l3.5,0,3.85.07,3.5.1,3.86.14,3.5.17c1.3.06,2.58.14,3.86.22l3.5.23,3.85.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.86.49s2.35.31,3.5.48l1.39.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.85-.39,3.51-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1196.19,1370.34c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-677",
  cx: 1100.2,
  cy: 1347.09,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1100.2,1323.82c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.77,19l84.68-41.19C1120.4,1324.22,1110.49,1323.82,1100.2,1323.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1100.2,1368.94c-52,0-94.36-10-95.91-22.56a5.65,5.65,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0-.05-.71C1194.56,1358.9,1152.22,1368.94,1100.2,1368.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-678",
  d: "M1009.29,1355.54l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.75,1.75,0,0,0,.52,1.24l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.73,1.73,0,0,0,1009.29,1355.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-679",
  d: "M1016.32,1359.38l0,0a1.73,1.73,0,0,0-2.41,1.59V1378a1.74,1.74,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57V1361A1.75,1.75,0,0,0,1016.32,1359.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-680",
  d: "M1023.52,1362.06h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.73,1.73,0,0,0,1023.52,1362.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-681",
  d: "M1030.78,1364.13h0a1.74,1.74,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1030.78,1364.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-682",
  d: "M1038.05,1365.8h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.37,1.69h0a1.73,1.73,0,0,0,2.09-1.69V1367.5A1.73,1.73,0,0,0,1038.05,1365.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-683",
  d: "M1045.35,1367.17h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1045.35,1367.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-684",
  d: "M1052.66,1368.29h0a1.73,1.73,0,0,0-2,1.72v17.37a1.75,1.75,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.72V1370A1.73,1.73,0,0,0,1052.66,1368.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-685",
  d: "M1060,1369.2h0a1.72,1.72,0,0,0-1.92,1.72v17.38a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1060,1369.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-686",
  d: "M1067.28,1369.93h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.73,1.73,0,0,0,1067.28,1369.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-687",
  d: "M1074.6,1370.5h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1074.6,1370.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-688",
  d: "M1081.92,1370.92h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.4A1.73,1.73,0,0,0,1081.92,1370.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-689",
  d: "M1089.25,1371.19h0a1.73,1.73,0,0,0-1.78,1.73v17.41a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.72,1.72,0,0,0,1089.25,1371.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-690",
  d: "M1096.57,1371.32h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.72,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1096.57,1371.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-691",
  d: "M1103.9,1371.32h0a1.73,1.73,0,0,0-1.71,1.73v17.42a1.73,1.73,0,0,0,1.75,1.73h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,1103.9,1371.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-692",
  d: "M1111.22,1371.19h0a1.73,1.73,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.79,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1111.22,1371.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-693",
  d: "M1118.55,1370.91h0a1.73,1.73,0,0,0-1.65,1.73v17.4a1.75,1.75,0,0,0,1.82,1.74h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,1118.55,1370.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-694",
  d: "M1125.87,1370.5h0a1.74,1.74,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,1125.87,1370.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-695",
  d: "M1133.19,1369.93h0a1.74,1.74,0,0,0-1.59,1.73v17.4a1.74,1.74,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.73,1.73,0,0,0,1133.19,1369.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-696",
  d: "M1140.51,1369.19h0a1.72,1.72,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.4A1.73,1.73,0,0,0,1140.51,1369.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-697",
  d: "M1147.82,1368.28h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.5-1.72V1370A1.73,1.73,0,0,0,1147.82,1368.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-698",
  d: "M1155.12,1367.15h0a1.73,1.73,0,0,0-1.45,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,1155.12,1367.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-699",
  d: "M1162.42,1365.79h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.72,1.72,0,0,0,1162.42,1365.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-700",
  d: "M1169.7,1364.12h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.31A1.73,1.73,0,0,0,1169.7,1364.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-701",
  d: "M1177,1362h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.74,1.74,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,1177,1362Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-702",
  d: "M1184.15,1359.35l0,0a1.71,1.71,0,0,0-1,1.58v17.1a1.74,1.74,0,0,0,2.47,1.57l0,0a1.71,1.71,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1184.15,1359.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-703",
  d: "M1191.18,1355.49l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1191.18,1355.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-704",
  d: "M1201.8,1344.8v0a7.56,7.56,0,0,1-2.26,5.05,19.29,19.29,0,0,1-3.5,2.91,38.73,38.73,0,0,1-3.86,2.21c-1.09.54-2.25,1.06-3.5,1.58s-2.5,1-3.86,1.47c-1.12.39-2.28.77-3.5,1.15s-2.52.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.53.61-3.85.9c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.72c-1.15.21-2.31.41-3.5.6s-2.55.41-3.86.6l-3.5.49c-1.26.16-2.55.33-3.85.48l-3.5.4-3.86.38-3.5.32-3.86.3-3.5.23c-1.27.08-2.56.16-3.85.22l-3.5.17-3.86.14-3.5.1-3.86.07c-1.16,0-2.32,0-3.5,0h-3.85l-3.5,0-3.86-.07-3.5-.1-3.86-.14-3.5-.17-3.85-.22c-1.18-.07-2.35-.15-3.5-.24s-2.59-.19-3.86-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39s-2.34-.26-3.5-.39l-3.85-.49-3.5-.49c-1.31-.19-2.6-.39-3.86-.59l-3.5-.6c-1.31-.24-2.6-.48-3.86-.73s-2.36-.48-3.5-.73c-1.32-.29-2.6-.59-3.85-.89s-2.37-.6-3.5-.91c-1.34-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.65-1-3.86-1.46s-2.41-1-3.5-1.59a37.43,37.43,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.49,7.49,0,0,1-2.24-5v0h0l0-24.17,2.27.23,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.85-.48l3.5-.4,3.86-.39,3.5-.31c1.27-.11,2.56-.21,3.86-.3l3.5-.24,3.85-.22,3.5-.16c1.28-.06,2.57-.1,3.86-.15s2.33-.07,3.5-.09,2.56-.06,3.86-.07l3.5,0h3.85l3.5,0c1.3,0,2.58,0,3.86.07s2.34.06,3.5.09,2.58.09,3.86.15l3.5.16,3.85.22c1.18.07,2.35.15,3.5.24,1.3.09,2.59.19,3.86.3l3.5.31c1.3.12,2.59.25,3.86.39s2.34.26,3.5.39l3.85.49,3.5.49c.47.07.94.13,1.4.21l2.46-.25,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1201.8,1343.87c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-705",
  cx: 1105.81,
  cy: 1320.62,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1105.81,1297.36c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.76,19l84.69-41.18C1126,1297.75,1116.1,1297.36,1105.81,1297.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1105.81,1342.47c-52,0-94.37-10-95.92-22.56,0,.24,0,.48,0,.71,0,12.86,43,23.27,96,23.27s96-10.41,96-23.27a5.78,5.78,0,0,0,0-.71C1200.17,1332.44,1157.82,1342.47,1105.81,1342.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-706",
  d: "M1014.9,1329.07l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,3-1.23v-16.36A1.75,1.75,0,0,0,1014.9,1329.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-707",
  d: "M1021.93,1332.91h0a1.73,1.73,0,0,0-2.42,1.59v17.06a1.75,1.75,0,0,0,1,1.56l0,0a1.73,1.73,0,0,0,2.46-1.57V1334.5A1.74,1.74,0,0,0,1021.93,1332.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-708",
  d: "M1029.13,1335.59h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64v-17.22A1.75,1.75,0,0,0,1029.13,1335.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-709",
  d: "M1036.38,1337.67h0a1.73,1.73,0,0,0-2.16,1.68v17.28a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,1036.38,1337.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-710",
  d: "M1043.66,1339.33h0a1.73,1.73,0,0,0-2.09,1.69v17.33a1.74,1.74,0,0,0,1.38,1.7h0a1.73,1.73,0,0,0,2.09-1.69V1341A1.73,1.73,0,0,0,1043.66,1339.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-711",
  d: "M1051,1340.7h0a1.74,1.74,0,0,0-2,1.71v17.36a1.73,1.73,0,0,0,1.44,1.7h0a1.74,1.74,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,1051,1340.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-712",
  d: "M1058.26,1341.82h0a1.74,1.74,0,0,0-2,1.72v17.37a1.73,1.73,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.37A1.74,1.74,0,0,0,1058.26,1341.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-713",
  d: "M1065.57,1342.73h0a1.73,1.73,0,0,0-1.93,1.72v17.39a1.73,1.73,0,0,0,1.54,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.73,1.73,0,0,0,1065.57,1342.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-714",
  d: "M1072.89,1343.47h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.73,1.73,0,0,0,1072.89,1343.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-715",
  d: "M1080.21,1344h0a1.73,1.73,0,0,0-1.84,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1080.21,1344Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-716",
  d: "M1087.53,1344.45h0a1.73,1.73,0,0,0-1.82,1.73v17.4a1.73,1.73,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.81-1.73v-17.41A1.72,1.72,0,0,0,1087.53,1344.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-717",
  d: "M1094.85,1344.72h0a1.73,1.73,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.74,1.74,0,0,0,1094.85,1344.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-718",
  d: "M1102.18,1344.86h0a1.72,1.72,0,0,0-1.75,1.73V1364a1.73,1.73,0,0,0,1.71,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.73,1.73,0,0,0,1102.18,1344.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-719",
  d: "M1109.51,1344.85h0a1.74,1.74,0,0,0-1.72,1.74V1364a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.71-1.73v-17.41A1.73,1.73,0,0,0,1109.51,1344.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-720",
  d: "M1116.83,1344.72h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.73,1.73,0,0,0,1116.83,1344.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-721",
  d: "M1124.16,1344.45h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.73,1.73,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,1124.16,1344.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-722",
  d: "M1131.48,1344h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.86,1.72h0a1.73,1.73,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,1131.48,1344Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-723",
  d: "M1138.8,1343.46h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.74,1.74,0,0,0,1.89,1.73h0a1.73,1.73,0,0,0,1.58-1.72v-17.4A1.73,1.73,0,0,0,1138.8,1343.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-724",
  d: "M1146.11,1342.73h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.74,1.74,0,0,0,1.93,1.73h0a1.73,1.73,0,0,0,1.54-1.72v-17.39A1.73,1.73,0,0,0,1146.11,1342.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-725",
  d: "M1153.42,1341.81h0a1.74,1.74,0,0,0-1.5,1.72v17.38a1.75,1.75,0,0,0,2,1.72h0a1.72,1.72,0,0,0,1.49-1.71v-17.38A1.73,1.73,0,0,0,1153.42,1341.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-726",
  d: "M1160.73,1340.69h0a1.74,1.74,0,0,0-1.44,1.71v17.37a1.74,1.74,0,0,0,2,1.71h0a1.73,1.73,0,0,0,1.44-1.71v-17.37A1.72,1.72,0,0,0,1160.73,1340.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-727",
  d: "M1168,1339.32h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.38-1.69V1341A1.74,1.74,0,0,0,1168,1339.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-728",
  d: "M1175.3,1337.65h0a1.72,1.72,0,0,0-1.31,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.68v-17.3A1.73,1.73,0,0,0,1175.3,1337.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-729",
  d: "M1182.56,1335.57h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,1182.56,1335.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-730",
  d: "M1189.76,1332.88l0,0a1.73,1.73,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.75,1.75,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1189.76,1332.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-731",
  d: "M1196.79,1329l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.93,1.24l0,0a1.72,1.72,0,0,0,.53-1.24v-16.41A1.73,1.73,0,0,0,1196.79,1329Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-732",
  d: "M1192.52,1316.82v0a7.57,7.57,0,0,1-2.27,5.05,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.72c-1.15.21-2.32.41-3.5.6s-2.55.41-3.86.6c-1.15.16-2.32.33-3.5.48s-2.55.34-3.86.49l-3.5.4-3.85.38-3.5.32-3.86.3-3.5.23c-1.28.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07-3.5,0h-3.86l-3.5,0-3.85-.07-3.5-.1c-1.3,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.17-.07-2.34-.15-3.5-.24s-2.58-.19-3.85-.3l-3.5-.31c-1.3-.12-2.59-.25-3.86-.39s-2.35-.26-3.5-.39l-3.86-.49-3.5-.49c-1.3-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.36-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.35-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.56-.33,3.86-.48l3.5-.4c1.27-.14,2.56-.26,3.86-.39l3.5-.31c1.27-.11,2.55-.21,3.85-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.28-.06,2.56-.1,3.86-.15s2.32-.07,3.5-.09,2.56-.06,3.85-.07l3.5,0h3.86l3.5,0c1.29,0,2.58,0,3.86.07s2.34.06,3.5.09,2.58.09,3.85.15l3.5.16,3.86.22c1.18.07,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39s2.35.26,3.5.39l3.86.49,3.5.49,1.39.2,2.47-.24,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1192.52,1315.89c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-733",
  cx: 1096.52,
  cy: 1292.64,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1096.52,1269.38c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19L1126,1270.5C1116.72,1269.77,1106.81,1269.38,1096.52,1269.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1096.52,1314.49c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.74,5.74,0,0,0,0-.71C1190.89,1304.45,1148.54,1314.49,1096.52,1314.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-734",
  d: "M1005.61,1301.09l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.37A1.72,1.72,0,0,0,1005.61,1301.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-735",
  d: "M1012.64,1304.93h0a1.73,1.73,0,0,0-2.42,1.59v17a1.73,1.73,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.73,1.73,0,0,0,1012.64,1304.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-736",
  d: "M1019.84,1307.61h0a1.74,1.74,0,0,0-2.27,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64v-17.22A1.73,1.73,0,0,0,1019.84,1307.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-737",
  d: "M1027.1,1309.69h0a1.73,1.73,0,0,0-2.16,1.68v17.28a1.73,1.73,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,1027.1,1309.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-738",
  d: "M1034.38,1311.35h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,1034.38,1311.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-739",
  d: "M1041.67,1312.72h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.45,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.72,1.72,0,0,0,1041.67,1312.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-740",
  d: "M1049,1313.84h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,1049,1313.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-741",
  d: "M1056.29,1314.75h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.38A1.74,1.74,0,0,0,1056.29,1314.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-742",
  d: "M1063.6,1315.49h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.73,1.73,0,0,0,1.57,1.73h0a1.74,1.74,0,0,0,1.89-1.72v-17.4A1.73,1.73,0,0,0,1063.6,1315.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-743",
  d: "M1070.92,1316.05h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1070.92,1316.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-744",
  d: "M1078.24,1316.47h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.74,1.74,0,0,0,1.82-1.73V1318.2A1.73,1.73,0,0,0,1078.24,1316.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-745",
  d: "M1085.57,1316.74h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.79-1.73v-17.41A1.74,1.74,0,0,0,1085.57,1316.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-746",
  d: "M1092.9,1316.88h0a1.74,1.74,0,0,0-1.75,1.74V1336a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.72,1.72,0,0,0,1092.9,1316.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-747",
  d: "M1100.22,1316.87h0a1.74,1.74,0,0,0-1.72,1.74V1336a1.73,1.73,0,0,0,1.75,1.73h0A1.73,1.73,0,0,0,1102,1336v-17.41A1.74,1.74,0,0,0,1100.22,1316.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-748",
  d: "M1107.55,1316.74h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.72,1.72,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.69-1.73v-17.41A1.74,1.74,0,0,0,1107.55,1316.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-749",
  d: "M1114.87,1316.47h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73V1318.2A1.72,1.72,0,0,0,1114.87,1316.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-750",
  d: "M1122.19,1316.05h0a1.74,1.74,0,0,0-1.62,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,1122.19,1316.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-751",
  d: "M1129.51,1315.48h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.72,1.72,0,0,0,1.88,1.72h0a1.74,1.74,0,0,0,1.58-1.72v-17.4A1.74,1.74,0,0,0,1129.51,1315.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-752",
  d: "M1136.83,1314.75h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.74,1.74,0,0,0,1.93,1.73h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.72,1.72,0,0,0,1136.83,1314.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-753",
  d: "M1144.14,1313.83h0a1.74,1.74,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71v-17.39A1.73,1.73,0,0,0,1144.14,1313.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-754",
  d: "M1151.44,1312.71h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.72,1.72,0,0,0,2,1.7h0a1.73,1.73,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,1151.44,1312.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-755",
  d: "M1158.74,1311.34h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69V1313A1.73,1.73,0,0,0,1158.74,1311.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-756",
  d: "M1166,1309.67h0a1.73,1.73,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,1166,1309.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-757",
  d: "M1173.27,1307.59h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,1173.27,1307.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-758",
  d: "M1180.47,1304.9l0,0a1.72,1.72,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1180.47,1304.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-759",
  d: "M1187.5,1301l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1187.5,1301Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-760",
  d: "M1198.12,1291.44v0a7.56,7.56,0,0,1-2.26,5,19.29,19.29,0,0,1-3.5,2.91,35.87,35.87,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.47c-1.12.39-2.28.77-3.5,1.15s-2.52.75-3.85,1.11c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.55.49-3.86.72c-1.14.21-2.31.41-3.5.6s-2.55.4-3.85.6-2.32.33-3.5.48-2.56.34-3.86.49l-3.5.4-3.86.38-3.5.32-3.85.3-3.5.23-3.86.22-3.5.17-3.86.14-3.5.1-3.85.07-3.5,0h-3.86l-3.5,0-3.86-.07-3.5-.1c-1.29,0-2.58-.09-3.85-.15s-2.35-.1-3.5-.16l-3.86-.22c-1.18-.07-2.34-.15-3.5-.24s-2.58-.19-3.86-.3l-3.5-.31c-1.3-.12-2.58-.25-3.85-.39l-3.5-.39-3.86-.49-3.5-.49c-1.31-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.6-.48-3.86-.73s-2.35-.48-3.5-.73c-1.31-.29-2.6-.59-3.85-.89s-2.37-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.36-.47-2.64-1-3.86-1.47s-2.41-1-3.5-1.58a37.43,37.43,0,0,1-3.85-2.21,18.67,18.67,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.35,3.86.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.55-.33,3.86-.48l3.5-.4c1.27-.14,2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.16,3.5-.24l3.86-.22,3.5-.16c1.27-.06,2.56-.1,3.85-.15s2.33-.07,3.5-.09l3.86-.08,3.5,0h3.86l3.5,0,3.85.08c1.18,0,2.34,0,3.5.09s2.58.09,3.86.15l3.5.16,3.86.22c1.17.07,2.34.15,3.5.24s2.58.19,3.85.3l3.5.31c1.3.12,2.59.25,3.86.39s2.35.25,3.5.39l3.86.49c1.18.15,2.35.32,3.5.49l1.39.2,2.46-.24,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1198.12,1290.51c-.11,12.83-43,23.22-95.95,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s95.95-10.41,95.95-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-761",
  cx: 1102.13,
  cy: 1267.26,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1102.13,1244c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.68-41.18C1122.33,1244.39,1112.42,1244,1102.13,1244Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1102.13,1289.11c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.78,5.78,0,0,0,0-.71C1196.49,1279.07,1154.15,1289.11,1102.13,1289.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-762",
  d: "M1011.22,1275.71l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.73,1.73,0,0,0,.51,1.23l0,0a1.73,1.73,0,0,0,3-1.23v-16.37A1.73,1.73,0,0,0,1011.22,1275.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-763",
  d: "M1018.25,1279.55h0a1.73,1.73,0,0,0-2.42,1.59v17a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,1018.25,1279.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-764",
  d: "M1025.45,1282.23h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64v-17.22A1.74,1.74,0,0,0,1025.45,1282.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-765",
  d: "M1032.7,1284.31h0a1.72,1.72,0,0,0-2.16,1.67v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.73,1.73,0,0,0,2.17-1.68V1286A1.72,1.72,0,0,0,1032.7,1284.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-766",
  d: "M1040,1286h0a1.73,1.73,0,0,0-2.09,1.69V1305a1.74,1.74,0,0,0,1.38,1.7h0a1.72,1.72,0,0,0,2.08-1.69v-17.33A1.73,1.73,0,0,0,1040,1286Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-767",
  d: "M1047.28,1287.34h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.73,1.73,0,0,0,1047.28,1287.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-768",
  d: "M1054.59,1288.46h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,1054.59,1288.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-769",
  d: "M1061.89,1289.37h0a1.72,1.72,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1061.89,1289.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-770",
  d: "M1069.21,1290.11h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.72v-17.4A1.71,1.71,0,0,0,1069.21,1290.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-771",
  d: "M1076.53,1290.67h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1076.53,1290.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-772",
  d: "M1083.85,1291.09h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.64,1.73h0a1.75,1.75,0,0,0,1.82-1.73v-17.41A1.73,1.73,0,0,0,1083.85,1291.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-773",
  d: "M1091.18,1291.36h0a1.74,1.74,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.69,1.73h0a1.72,1.72,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,1091.18,1291.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-774",
  d: "M1098.5,1291.49h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.74,1.74,0,0,0,1098.5,1291.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-775",
  d: "M1105.83,1291.49h0a1.74,1.74,0,0,0-1.71,1.74v17.41a1.73,1.73,0,0,0,1.74,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,1105.83,1291.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-776",
  d: "M1113.15,1291.36h0a1.74,1.74,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.79,1.73h0a1.72,1.72,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1113.15,1291.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-777",
  d: "M1120.48,1291.09h0a1.73,1.73,0,0,0-1.65,1.73v17.41a1.74,1.74,0,0,0,1.81,1.73h0a1.74,1.74,0,0,0,1.65-1.73v-17.41A1.73,1.73,0,0,0,1120.48,1291.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-778",
  d: "M1127.8,1290.67h0a1.73,1.73,0,0,0-1.61,1.73v17.41a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,1127.8,1290.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-779",
  d: "M1135.12,1290.1h0a1.74,1.74,0,0,0-1.58,1.73v17.4a1.73,1.73,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.72v-17.41A1.73,1.73,0,0,0,1135.12,1290.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-780",
  d: "M1142.44,1289.36h0a1.73,1.73,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.39A1.74,1.74,0,0,0,1142.44,1289.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-781",
  d: "M1149.74,1288.45h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.5-1.71v-17.39A1.73,1.73,0,0,0,1149.74,1288.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-782",
  d: "M1157.05,1287.33h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.73,1.73,0,0,0,2,1.7h0a1.75,1.75,0,0,0,1.44-1.71V1289A1.72,1.72,0,0,0,1157.05,1287.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-783",
  d: "M1164.35,1286h0a1.72,1.72,0,0,0-1.38,1.69V1305a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,1164.35,1286Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-784",
  d: "M1171.63,1284.29h0a1.72,1.72,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.74,1.74,0,0,0,1.3-1.68V1286A1.73,1.73,0,0,0,1171.63,1284.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-785",
  d: "M1178.88,1282.21h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.72,1.72,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,1178.88,1282.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-786",
  d: "M1186.08,1279.52l0,0a1.73,1.73,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.46,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1186.08,1279.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-787",
  d: "M1193.11,1275.66l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1193.11,1275.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-788",
  d: "M1186.73,1263.51v0a7.52,7.52,0,0,1-2.26,5,19.06,19.06,0,0,1-3.51,2.92,35.68,35.68,0,0,1-3.85,2.2c-1.09.54-2.25,1.07-3.5,1.59s-2.5,1-3.86,1.46c-1.12.4-2.29.78-3.5,1.15s-2.52.76-3.86,1.12c-1.13.31-2.3.61-3.5.9s-2.53.6-3.85.89c-1.14.25-2.31.5-3.5.73s-2.55.5-3.86.73c-1.15.21-2.31.4-3.5.6s-2.55.4-3.86.59c-1.15.17-2.31.34-3.5.49l-3.85.49c-1.16.13-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.86.3s-2.32.17-3.5.24l-3.85.22-3.5.16c-1.28.06-2.57.11-3.86.15s-2.33.07-3.5.09l-3.86.08-3.5,0h-3.85l-3.5,0c-1.3,0-2.58,0-3.86-.07s-2.34-.06-3.5-.09-2.58-.09-3.86-.15l-3.5-.16-3.85-.22-3.5-.24c-1.3-.09-2.59-.19-3.86-.3l-3.5-.31c-1.3-.13-2.59-.25-3.86-.39l-3.5-.4c-1.3-.15-2.59-.31-3.85-.48l-3.5-.49c-1.31-.19-2.6-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.6-.47-3.86-.72s-2.36-.48-3.5-.73c-1.32-.29-2.6-.59-3.85-.9s-2.37-.59-3.5-.9c-1.34-.36-2.62-.74-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.65-1-3.86-1.47s-2.41-1-3.5-1.59a34.07,34.07,0,0,1-3.85-2.21,18.33,18.33,0,0,1-3.5-2.92,7.51,7.51,0,0,1-2.24-5v0h0l0-24.17,2.27.22,3.5.35,3.85.37,3.5.35,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.85-.49c1.16-.13,2.32-.27,3.5-.39s2.56-.27,3.86-.39l3.5-.31c1.27-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.85-.22,3.5-.17,3.86-.14,3.5-.1,3.86-.07,3.5,0h3.85l3.5,0,3.86.07,3.5.1,3.86.14,3.5.17c1.29.06,2.58.14,3.85.22l3.5.23,3.86.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.85.49s2.35.31,3.5.48l1.4.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.85-.38,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.51-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1186.73,1262.58c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-789",
  cx: 1090.74,
  cy: 1239.33,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1090.74,1216.06c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.76,19l84.69-41.19C1110.94,1216.46,1101,1216.06,1090.74,1216.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1090.74,1261.18c-52,0-94.37-10-95.92-22.56a5.63,5.63,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0,0-.71C1185.1,1251.14,1142.75,1261.18,1090.74,1261.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-790",
  d: "M999.83,1247.78l0,0a1.73,1.73,0,0,0-2.74,1.4v16.35a1.74,1.74,0,0,0,.51,1.24l0,0a1.74,1.74,0,0,0,2.95-1.24v-16.36A1.73,1.73,0,0,0,999.83,1247.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-791",
  d: "M1006.86,1251.62l0,0a1.74,1.74,0,0,0-2.42,1.59v17.06a1.75,1.75,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.46-1.57v-17.06A1.74,1.74,0,0,0,1006.86,1251.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-792",
  d: "M1014.06,1254.3h0a1.73,1.73,0,0,0-2.26,1.65v17.22a1.73,1.73,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.29-1.64V1256A1.74,1.74,0,0,0,1014.06,1254.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-793",
  d: "M1021.31,1256.37h0a1.74,1.74,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.29,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1021.31,1256.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-794",
  d: "M1028.59,1258h0a1.74,1.74,0,0,0-2.09,1.7v17.33a1.73,1.73,0,0,0,1.38,1.69h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.73,1.73,0,0,0,1028.59,1258Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-795",
  d: "M1035.89,1259.41h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.74,1.74,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1035.89,1259.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-796",
  d: "M1043.19,1260.53h0a1.73,1.73,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,1043.19,1260.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-797",
  d: "M1050.5,1261.44h0a1.73,1.73,0,0,0-1.93,1.72v17.38a1.73,1.73,0,0,0,1.54,1.72h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.73,1.73,0,0,0,1050.5,1261.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-798",
  d: "M1057.82,1262.17h0a1.73,1.73,0,0,0-1.88,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73V1263.9A1.74,1.74,0,0,0,1057.82,1262.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-799",
  d: "M1065.14,1262.74h0a1.73,1.73,0,0,0-1.84,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1065.14,1262.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-800",
  d: "M1072.46,1263.16h0a1.73,1.73,0,0,0-1.81,1.73v17.4a1.73,1.73,0,0,0,1.65,1.73h0a1.72,1.72,0,0,0,1.81-1.73v-17.4A1.73,1.73,0,0,0,1072.46,1263.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-801",
  d: "M1079.78,1263.43h0a1.72,1.72,0,0,0-1.78,1.73v17.41a1.73,1.73,0,0,0,1.68,1.73h0a1.74,1.74,0,0,0,1.78-1.73v-17.41A1.73,1.73,0,0,0,1079.78,1263.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-802",
  d: "M1087.11,1263.56h0a1.73,1.73,0,0,0-1.74,1.73v17.41a1.74,1.74,0,0,0,1.71,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1087.11,1263.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-803",
  d: "M1094.44,1263.56h0a1.73,1.73,0,0,0-1.72,1.73v17.42a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.71-1.74v-17.41A1.73,1.73,0,0,0,1094.44,1263.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-804",
  d: "M1101.76,1263.43h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.73,1.73,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1101.76,1263.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-805",
  d: "M1109.09,1263.15h0a1.73,1.73,0,0,0-1.65,1.73v17.4a1.74,1.74,0,0,0,1.81,1.74h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,1109.09,1263.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-806",
  d: "M1116.41,1262.74h0a1.74,1.74,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.73,1.73,0,0,0,1.61-1.73v-17.41A1.72,1.72,0,0,0,1116.41,1262.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-807",
  d: "M1123.73,1262.17h0a1.74,1.74,0,0,0-1.58,1.73v17.4A1.73,1.73,0,0,0,1124,1283h0a1.73,1.73,0,0,0,1.58-1.73v-17.4A1.73,1.73,0,0,0,1123.73,1262.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-808",
  d: "M1131,1261.43h0a1.72,1.72,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.54-1.72v-17.4A1.74,1.74,0,0,0,1131,1261.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-809",
  d: "M1138.35,1260.52h0a1.74,1.74,0,0,0-1.5,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,1138.35,1260.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-810",
  d: "M1145.66,1259.39h0a1.73,1.73,0,0,0-1.44,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.75,1.75,0,0,0,1.44-1.71V1261.1A1.73,1.73,0,0,0,1145.66,1259.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-811",
  d: "M1153,1258h0a1.73,1.73,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.73,1.73,0,0,0,1.38-1.69v-17.35A1.73,1.73,0,0,0,1153,1258Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-812",
  d: "M1160.23,1256.36h0a1.74,1.74,0,0,0-1.31,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.29-1.68V1258A1.72,1.72,0,0,0,1160.23,1256.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-813",
  d: "M1167.49,1254.28h0a1.74,1.74,0,0,0-1.2,1.65v17.24a1.73,1.73,0,0,0,2.29,1.64h0a1.73,1.73,0,0,0,1.18-1.64v-17.24A1.73,1.73,0,0,0,1167.49,1254.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-814",
  d: "M1174.69,1251.59l0,0a1.72,1.72,0,0,0-1,1.58v17.1a1.73,1.73,0,0,0,2.46,1.57l0,0a1.72,1.72,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1174.69,1251.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-815",
  d: "M1181.72,1247.73l0,0a1.72,1.72,0,0,0-.72,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.73,1.73,0,0,0,.53-1.24v-16.41A1.73,1.73,0,0,0,1181.72,1247.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-816",
  d: "M1201.44,1240v0a7.54,7.54,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,34.93,34.93,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.85,1.46c-1.12.4-2.29.78-3.51,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.89c-1.14.25-2.31.5-3.5.73s-2.54.5-3.86.73c-1.14.21-2.31.41-3.5.6l-3.85.59c-1.15.17-2.32.34-3.5.49l-3.86.49c-1.15.14-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.56.21-3.85.3s-2.33.17-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.11-3.86.15l-3.5.1-3.85.07-3.5,0h-3.86l-3.5,0-3.86-.08c-1.17,0-2.34-.06-3.5-.09s-2.58-.09-3.85-.15l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.19-3.86-.3l-3.5-.31c-1.3-.13-2.58-.25-3.85-.39l-3.5-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.59-.47-3.85-.72s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.85-1.47s-2.42-1-3.5-1.59a33.38,33.38,0,0,1-3.86-2.21,18.59,18.59,0,0,1-3.5-2.92,7.54,7.54,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.86.37,3.5.35,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.86-.49c1.15-.13,2.32-.27,3.5-.39s2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.32-.17,3.5-.24l3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07,3.5,0h3.86l3.5,0,3.85.07,3.5.1,3.86.14,3.5.17,3.86.22,3.5.23,3.85.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.86.49s2.35.31,3.5.48l1.39.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.85-.39,3.51-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1201.44,1239c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-817",
  cx: 1105.45,
  cy: 1215.79,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1105.45,1192.52c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.77,19l84.68-41.19C1125.65,1192.92,1115.74,1192.52,1105.45,1192.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1105.45,1237.64c-52,0-94.36-10-95.91-22.56a5.65,5.65,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0-.05-.71C1199.81,1227.6,1157.47,1237.64,1105.45,1237.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-818",
  d: "M1014.54,1224.24l0,0a1.73,1.73,0,0,0-2.74,1.4V1242a1.75,1.75,0,0,0,.52,1.24l0,0a1.74,1.74,0,0,0,3-1.24v-16.36A1.73,1.73,0,0,0,1014.54,1224.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-819",
  d: "M1021.57,1228.08l0,0a1.73,1.73,0,0,0-2.41,1.59v17.06a1.74,1.74,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.75,1.75,0,0,0,1021.57,1228.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-820",
  d: "M1028.77,1230.76h0a1.74,1.74,0,0,0-2.26,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.73,1.73,0,0,0,1028.77,1230.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-821",
  d: "M1036,1232.83h0a1.74,1.74,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1036,1232.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-822",
  d: "M1043.3,1234.5h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.37,1.69h0a1.73,1.73,0,0,0,2.09-1.69V1236.2A1.74,1.74,0,0,0,1043.3,1234.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-823",
  d: "M1050.6,1235.87h0a1.73,1.73,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1050.6,1235.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-824",
  d: "M1057.91,1237h0a1.74,1.74,0,0,0-2,1.72v17.37a1.75,1.75,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.72V1238.7A1.73,1.73,0,0,0,1057.91,1237Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-825",
  d: "M1065.22,1237.9h0a1.72,1.72,0,0,0-1.92,1.72V1257a1.73,1.73,0,0,0,1.53,1.72h0a1.74,1.74,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1065.22,1237.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-826",
  d: "M1072.53,1238.63h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73v-17.39A1.73,1.73,0,0,0,1072.53,1238.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-827",
  d: "M1079.85,1239.2h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.73,1.73,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1079.85,1239.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-828",
  d: "M1087.17,1239.62h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.4A1.73,1.73,0,0,0,1087.17,1239.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-829",
  d: "M1094.5,1239.89h0a1.73,1.73,0,0,0-1.78,1.73V1259a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.72,1.72,0,0,0,1094.5,1239.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-830",
  d: "M1101.82,1240h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.72,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1101.82,1240Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-831",
  d: "M1109.15,1240h0a1.73,1.73,0,0,0-1.71,1.73v17.42a1.73,1.73,0,0,0,1.75,1.73h0a1.74,1.74,0,0,0,1.72-1.74v-17.41A1.73,1.73,0,0,0,1109.15,1240Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-832",
  d: "M1116.47,1239.89h0a1.73,1.73,0,0,0-1.69,1.73V1259a1.73,1.73,0,0,0,1.79,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1116.47,1239.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-833",
  d: "M1123.8,1239.61h0a1.73,1.73,0,0,0-1.65,1.73v17.4a1.75,1.75,0,0,0,1.82,1.74h0a1.73,1.73,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,1123.8,1239.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-834",
  d: "M1131.12,1239.2h0a1.74,1.74,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73v-17.4A1.73,1.73,0,0,0,1131.12,1239.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-835",
  d: "M1138.44,1238.63h0a1.74,1.74,0,0,0-1.59,1.73v17.4a1.74,1.74,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.73,1.73,0,0,0,1138.44,1238.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-836",
  d: "M1145.76,1237.89h0a1.72,1.72,0,0,0-1.54,1.72V1257a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.4A1.73,1.73,0,0,0,1145.76,1237.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-837",
  d: "M1153.07,1237h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.5-1.72v-17.38A1.73,1.73,0,0,0,1153.07,1237Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-838",
  d: "M1160.37,1235.85h0a1.73,1.73,0,0,0-1.45,1.71v17.36a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.44-1.71v-17.37A1.73,1.73,0,0,0,1160.37,1235.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-839",
  d: "M1167.67,1234.49h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.72,1.72,0,0,0,1167.67,1234.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-840",
  d: "M1175,1232.82h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.74,1.74,0,0,0,1.3-1.68v-17.31A1.73,1.73,0,0,0,1175,1232.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-841",
  d: "M1182.2,1230.74h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.74,1.74,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,1182.2,1230.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-842",
  d: "M1189.4,1228.05l0,0a1.71,1.71,0,0,0-1,1.58v17.1a1.74,1.74,0,0,0,2.46,1.57l0,0a1.71,1.71,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1189.4,1228.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-843",
  d: "M1196.43,1224.19l0,0a1.71,1.71,0,0,0-.71,1.4V1242a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1196.43,1224.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-844",
  d: "M1192.7,1212v0a7.54,7.54,0,0,1-2.27,5,19,19,0,0,1-3.5,2.92,34.93,34.93,0,0,1-3.86,2.2c-1.08.54-2.25,1.07-3.5,1.59s-2.5,1-3.85,1.46c-1.12.4-2.29.78-3.51,1.15s-2.52.76-3.85,1.12c-1.14.31-2.3.61-3.5.9s-2.54.61-3.86.89c-1.14.25-2.31.5-3.5.73s-2.54.5-3.86.73c-1.14.21-2.31.41-3.5.6l-3.85.59c-1.15.17-2.32.34-3.5.49l-3.86.49c-1.15.14-2.32.27-3.5.39s-2.56.27-3.86.39l-3.5.31c-1.27.11-2.55.21-3.85.3s-2.33.17-3.5.24l-3.86.22-3.5.16c-1.28.06-2.56.11-3.86.15l-3.5.1-3.85.07-3.5,0h-3.86l-3.5,0-3.86-.08c-1.17,0-2.34-.06-3.5-.09s-2.58-.09-3.85-.15l-3.5-.16-3.86-.22-3.5-.24c-1.3-.09-2.58-.19-3.86-.3l-3.5-.31c-1.3-.13-2.58-.25-3.85-.39l-3.5-.4c-1.31-.15-2.59-.31-3.86-.48l-3.5-.49c-1.31-.19-2.59-.39-3.86-.6s-2.35-.39-3.5-.6c-1.31-.23-2.59-.47-3.85-.72s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.9s-2.37-.59-3.5-.9c-1.33-.36-2.62-.73-3.86-1.12s-2.38-.76-3.5-1.15c-1.36-.48-2.64-1-3.85-1.47s-2.42-1-3.5-1.59a33.38,33.38,0,0,1-3.86-2.21,18.59,18.59,0,0,1-3.5-2.92,7.54,7.54,0,0,1-2.23-5v0h0l0-24.17,2.27.22,3.5.35,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,2.75.27,1.11-.16,3.5-.49,3.86-.49c1.15-.13,2.32-.27,3.5-.39s2.55-.27,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.33-.17,3.5-.24l3.86-.22,3.5-.17,3.85-.14,3.5-.1,3.86-.07,3.5,0h3.86l3.5,0,3.85.07,3.5.1,3.86.14,3.5.17,3.86.22,3.5.23,3.85.3,3.5.32,3.86.38,3.5.4c1.3.15,2.59.32,3.86.49s2.35.31,3.5.48l1.39.21,2.46-.25,3.5-.35,3.86-.38,3.5-.36,3.86-.38,3.5-.35,3.85-.39,3.51-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1192.69,1211.08c-.11,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.16h0l0,24.17h0v0c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-845",
  cx: 1096.7,
  cy: 1187.83,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1096.7,1164.56c-53,0-96,10.42-96,23.27,0,7.87,16.11,14.83,40.77,19l84.69-41.19C1116.9,1165,1107,1164.56,1096.7,1164.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1096.7,1209.68c-52,0-94.36-10-95.91-22.56a5.65,5.65,0,0,0,0,.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.65,5.65,0,0,0-.05-.71C1191.06,1199.64,1148.72,1209.68,1096.7,1209.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-846",
  d: "M1005.79,1196.28l0,0a1.73,1.73,0,0,0-2.74,1.4V1214a1.75,1.75,0,0,0,.52,1.24l0,0a1.73,1.73,0,0,0,2.94-1.24v-16.36A1.73,1.73,0,0,0,1005.79,1196.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-847",
  d: "M1012.82,1200.12l0,0a1.73,1.73,0,0,0-2.41,1.59v17.06a1.74,1.74,0,0,0,1,1.57l0,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.75,1.75,0,0,0,1012.82,1200.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-848",
  d: "M1020,1202.8h0a1.74,1.74,0,0,0-2.26,1.65v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.73,1.73,0,0,0,2.28-1.64v-17.22A1.73,1.73,0,0,0,1020,1202.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-849",
  d: "M1027.28,1204.87h0a1.74,1.74,0,0,0-2.16,1.68v17.29a1.73,1.73,0,0,0,1.3,1.68h0a1.74,1.74,0,0,0,2.17-1.68v-17.29A1.74,1.74,0,0,0,1027.28,1204.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-850",
  d: "M1034.55,1206.54h0a1.73,1.73,0,0,0-2.08,1.7v17.33a1.72,1.72,0,0,0,1.37,1.69h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,1034.55,1206.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-851",
  d: "M1041.85,1207.91h0a1.73,1.73,0,0,0-2,1.71V1227a1.73,1.73,0,0,0,1.44,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.36A1.73,1.73,0,0,0,1041.85,1207.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-852",
  d: "M1049.16,1209h0a1.74,1.74,0,0,0-2,1.72v17.37a1.75,1.75,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.72v-17.37A1.73,1.73,0,0,0,1049.16,1209Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-853",
  d: "M1056.47,1209.94h0a1.72,1.72,0,0,0-1.92,1.72V1229a1.72,1.72,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1056.47,1209.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-854",
  d: "M1063.78,1210.67h0a1.73,1.73,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.89-1.73V1212.4A1.73,1.73,0,0,0,1063.78,1210.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-855",
  d: "M1071.1,1211.24h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.61,1.73h0a1.73,1.73,0,0,0,1.85-1.73V1213A1.74,1.74,0,0,0,1071.1,1211.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-856",
  d: "M1078.42,1211.66h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.73,1.73,0,0,0,1.82-1.73v-17.4A1.73,1.73,0,0,0,1078.42,1211.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-857",
  d: "M1085.75,1211.93h0a1.73,1.73,0,0,0-1.78,1.73v17.41a1.74,1.74,0,0,0,1.69,1.73h0a1.73,1.73,0,0,0,1.78-1.73v-17.41A1.72,1.72,0,0,0,1085.75,1211.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-858",
  d: "M1093.07,1212.06h0a1.73,1.73,0,0,0-1.75,1.73v17.41a1.74,1.74,0,0,0,1.72,1.74h0a1.74,1.74,0,0,0,1.75-1.74v-17.41A1.73,1.73,0,0,0,1093.07,1212.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-859",
  d: "M1100.4,1212.06h0a1.73,1.73,0,0,0-1.71,1.73v17.42a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.42A1.73,1.73,0,0,0,1100.4,1212.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-860",
  d: "M1107.72,1211.93h0a1.73,1.73,0,0,0-1.69,1.73v17.41a1.73,1.73,0,0,0,1.79,1.73h0a1.73,1.73,0,0,0,1.68-1.73v-17.41A1.72,1.72,0,0,0,1107.72,1211.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-861",
  d: "M1115.05,1211.65h0a1.73,1.73,0,0,0-1.65,1.73v17.4a1.75,1.75,0,0,0,1.82,1.74h0a1.72,1.72,0,0,0,1.65-1.73v-17.41A1.74,1.74,0,0,0,1115.05,1211.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-862",
  d: "M1122.37,1211.24h0a1.74,1.74,0,0,0-1.62,1.73v17.4a1.73,1.73,0,0,0,1.85,1.73h0a1.74,1.74,0,0,0,1.62-1.73V1213A1.73,1.73,0,0,0,1122.37,1211.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-863",
  d: "M1129.69,1210.67h0a1.74,1.74,0,0,0-1.59,1.73v17.4a1.74,1.74,0,0,0,1.89,1.72h0a1.73,1.73,0,0,0,1.57-1.73v-17.4A1.73,1.73,0,0,0,1129.69,1210.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-864",
  d: "M1137,1209.93h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.73,1.73,0,0,0,1.93,1.72h0a1.73,1.73,0,0,0,1.53-1.72v-17.4A1.73,1.73,0,0,0,1137,1209.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-865",
  d: "M1144.32,1209h0a1.73,1.73,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.74,1.74,0,0,0,1.49-1.72v-17.38A1.73,1.73,0,0,0,1144.32,1209Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-866",
  d: "M1151.62,1207.89h0a1.73,1.73,0,0,0-1.45,1.71V1227a1.73,1.73,0,0,0,2,1.71h0a1.74,1.74,0,0,0,1.44-1.71V1209.6A1.73,1.73,0,0,0,1151.62,1207.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-867",
  d: "M1158.92,1206.53h0a1.74,1.74,0,0,0-1.38,1.7v17.34a1.73,1.73,0,0,0,2.09,1.7h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.72,1.72,0,0,0,1158.92,1206.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-868",
  d: "M1166.2,1204.86h0a1.73,1.73,0,0,0-1.3,1.68v17.31a1.74,1.74,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.31A1.73,1.73,0,0,0,1166.2,1204.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-869",
  d: "M1173.45,1202.78h0a1.74,1.74,0,0,0-1.21,1.65v17.24a1.74,1.74,0,0,0,2.29,1.64h0a1.74,1.74,0,0,0,1.18-1.64v-17.24A1.74,1.74,0,0,0,1173.45,1202.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-870",
  d: "M1180.65,1200.09l0,0a1.71,1.71,0,0,0-1,1.58v17.1a1.74,1.74,0,0,0,2.47,1.57l0,0a1.71,1.71,0,0,0,1-1.56v-17.09A1.73,1.73,0,0,0,1180.65,1200.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-871",
  d: "M1187.68,1196.23l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24v-16.41A1.73,1.73,0,0,0,1187.68,1196.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-872",
  d: "M1196,1184.58v0a7.57,7.57,0,0,1-2.27,5.05,19,19,0,0,1-3.5,2.91,34.93,34.93,0,0,1-3.86,2.2c-1.08.55-2.25,1.07-3.5,1.59s-2.49,1-3.85,1.47c-1.12.39-2.29.77-3.5,1.15s-2.53.75-3.86,1.11c-1.13.31-2.3.61-3.5.9s-2.54.61-3.86.9c-1.14.25-2.31.49-3.5.73s-2.54.49-3.85.72c-1.15.21-2.32.41-3.5.6s-2.55.4-3.86.6c-1.15.16-2.32.33-3.5.48s-2.55.34-3.86.49l-3.5.4-3.85.38-3.5.32-3.86.3-3.5.23c-1.28.08-2.56.16-3.86.22l-3.5.17-3.85.14-3.5.1-3.86.07-3.5,0h-3.86l-3.5,0-3.85-.07-3.5-.1c-1.3,0-2.58-.09-3.86-.15s-2.34-.1-3.5-.16l-3.86-.22c-1.17-.07-2.34-.15-3.5-.24s-2.58-.19-3.86-.3l-3.5-.31c-1.29-.12-2.58-.25-3.85-.39s-2.35-.26-3.5-.39L1054,1205l-3.5-.49c-1.3-.19-2.59-.39-3.86-.6l-3.5-.59c-1.31-.24-2.59-.48-3.85-.73s-2.36-.48-3.5-.73c-1.32-.29-2.61-.59-3.86-.89s-2.36-.6-3.5-.91c-1.33-.36-2.62-.73-3.86-1.11s-2.38-.76-3.5-1.16c-1.35-.47-2.64-1-3.85-1.47s-2.42-1-3.5-1.58a36.59,36.59,0,0,1-3.86-2.21,19,19,0,0,1-3.5-2.93,7.52,7.52,0,0,1-2.23-5v0h0l0-24.17,2.27.23,3.5.34,3.86.38,3.5.34,3.85.38,3.5.34,3.86.38,3.5.34,3.86.38,3.5.35,3.85.37,3.5.35,2.75.27,1.11-.17,3.5-.49c1.27-.17,2.56-.33,3.86-.48l3.5-.4c1.27-.14,2.56-.26,3.85-.39l3.5-.31c1.28-.11,2.56-.21,3.86-.3s2.33-.16,3.5-.24l3.86-.22,3.5-.16c1.28-.06,2.56-.1,3.86-.15s2.32-.07,3.5-.09,2.56-.06,3.85-.07l3.5,0H1102l3.5,0c1.29,0,2.58,0,3.86.07s2.34.06,3.5.09,2.58.09,3.85.15l3.5.16,3.86.22c1.17.07,2.34.15,3.5.24s2.58.19,3.86.3l3.5.31c1.3.12,2.58.25,3.85.39s2.35.26,3.5.39l3.86.49,3.5.49,1.39.2,2.47-.24,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,3.86-.39,3.5-.35,3.85-.39,3.5-.35,3.86-.39,3.5-.35,2.23-.22,0,24.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-2",
  d: "M1196,1183.65c-.12,12.83-43,23.22-96,23.22s-96-10.42-96-23.27v0h0l0-23.17h0l0,24.17h0v0c0,12.85,43,23.26,96,23.26s96-10.41,96-23.26v0h0Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-g3-873",
  cx: 1100.02,
  cy: 1160.4,
  rx: 95.96,
  ry: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-4",
  d: "M1100,1137.14c-53,0-96,10.41-96,23.26,0,7.87,16.11,14.83,40.77,19l84.69-41.18C1120.22,1137.53,1110.31,1137.14,1100,1137.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-5",
  d: "M1100,1182.25c-52,0-94.36-10-95.91-22.56a5.78,5.78,0,0,0-.05.71c0,12.85,43,23.27,96,23.27s96-10.42,96-23.27a5.74,5.74,0,0,0,0-.71C1194.39,1172.21,1152,1182.25,1100,1182.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-874",
  d: "M1009.11,1168.85l0,0a1.73,1.73,0,0,0-2.74,1.41v16.35a1.74,1.74,0,0,0,.52,1.23l0,0a1.73,1.73,0,0,0,2.94-1.23v-16.37A1.72,1.72,0,0,0,1009.11,1168.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-875",
  d: "M1016.14,1172.69h0a1.73,1.73,0,0,0-2.42,1.59v17a1.74,1.74,0,0,0,1,1.57l.05,0a1.73,1.73,0,0,0,2.47-1.57v-17.06A1.73,1.73,0,0,0,1016.14,1172.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-876",
  d: "M1023.34,1175.37h0A1.74,1.74,0,0,0,1021,1177v17.22a1.74,1.74,0,0,0,1.18,1.64h0a1.72,1.72,0,0,0,2.28-1.64V1177A1.73,1.73,0,0,0,1023.34,1175.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-877",
  d: "M1030.6,1177.45h0a1.73,1.73,0,0,0-2.16,1.68v17.28a1.73,1.73,0,0,0,1.3,1.68h0a1.73,1.73,0,0,0,2.17-1.68v-17.29A1.72,1.72,0,0,0,1030.6,1177.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-878",
  d: "M1037.88,1179.11h0a1.72,1.72,0,0,0-2.08,1.69v17.33a1.73,1.73,0,0,0,1.37,1.7h0a1.73,1.73,0,0,0,2.09-1.69v-17.33A1.74,1.74,0,0,0,1037.88,1179.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-879",
  d: "M1045.17,1180.48h0a1.74,1.74,0,0,0-2,1.71v17.35a1.73,1.73,0,0,0,1.45,1.71h0a1.73,1.73,0,0,0,2-1.71v-17.35A1.72,1.72,0,0,0,1045.17,1180.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-880",
  d: "M1052.48,1181.6h0a1.74,1.74,0,0,0-2,1.72v17.37a1.74,1.74,0,0,0,1.49,1.72h0a1.73,1.73,0,0,0,2-1.71v-17.38A1.73,1.73,0,0,0,1052.48,1181.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-881",
  d: "M1059.79,1182.51h0a1.73,1.73,0,0,0-1.92,1.72v17.39a1.73,1.73,0,0,0,1.53,1.72h0a1.73,1.73,0,0,0,1.93-1.72v-17.39A1.74,1.74,0,0,0,1059.79,1182.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-882",
  d: "M1067.1,1183.25h0a1.74,1.74,0,0,0-1.89,1.73v17.39a1.74,1.74,0,0,0,1.58,1.73h0a1.73,1.73,0,0,0,1.88-1.72V1185A1.72,1.72,0,0,0,1067.1,1183.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-883",
  d: "M1074.42,1183.81h0a1.73,1.73,0,0,0-1.85,1.73v17.4a1.74,1.74,0,0,0,1.62,1.73h0a1.73,1.73,0,0,0,1.85-1.73v-17.4A1.74,1.74,0,0,0,1074.42,1183.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-884",
  d: "M1081.74,1184.23h0a1.72,1.72,0,0,0-1.81,1.73v17.4a1.72,1.72,0,0,0,1.65,1.73h0a1.74,1.74,0,0,0,1.82-1.73V1186A1.73,1.73,0,0,0,1081.74,1184.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-885",
  d: "M1089.07,1184.5h0a1.73,1.73,0,0,0-1.77,1.73v17.41a1.72,1.72,0,0,0,1.68,1.73h0a1.73,1.73,0,0,0,1.79-1.73v-17.41A1.74,1.74,0,0,0,1089.07,1184.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-886",
  d: "M1096.39,1184.64h0a1.74,1.74,0,0,0-1.75,1.74v17.41a1.73,1.73,0,0,0,1.72,1.73h0a1.73,1.73,0,0,0,1.75-1.73v-17.41A1.72,1.72,0,0,0,1096.39,1184.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-887",
  d: "M1103.72,1184.63h0a1.74,1.74,0,0,0-1.72,1.74v17.41a1.73,1.73,0,0,0,1.75,1.73h0a1.73,1.73,0,0,0,1.72-1.73v-17.41A1.74,1.74,0,0,0,1103.72,1184.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-888",
  d: "M1111.05,1184.5h0a1.73,1.73,0,0,0-1.68,1.73v17.41a1.72,1.72,0,0,0,1.78,1.73h0a1.73,1.73,0,0,0,1.69-1.73v-17.41A1.74,1.74,0,0,0,1111.05,1184.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-889",
  d: "M1118.37,1184.23h0a1.73,1.73,0,0,0-1.66,1.73v17.41a1.74,1.74,0,0,0,1.82,1.73h0a1.73,1.73,0,0,0,1.65-1.73V1186A1.72,1.72,0,0,0,1118.37,1184.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-890",
  d: "M1125.69,1183.81h0a1.74,1.74,0,0,0-1.62,1.73V1203a1.73,1.73,0,0,0,1.85,1.72h0a1.74,1.74,0,0,0,1.61-1.73v-17.4A1.73,1.73,0,0,0,1125.69,1183.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-891",
  d: "M1133,1183.24h0a1.73,1.73,0,0,0-1.58,1.73v17.4a1.72,1.72,0,0,0,1.88,1.72h0a1.74,1.74,0,0,0,1.58-1.72V1185A1.74,1.74,0,0,0,1133,1183.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-892",
  d: "M1140.33,1182.51h0a1.74,1.74,0,0,0-1.54,1.72v17.39a1.74,1.74,0,0,0,1.93,1.73h0a1.73,1.73,0,0,0,1.53-1.72v-17.39A1.72,1.72,0,0,0,1140.33,1182.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-893",
  d: "M1147.64,1181.59h0a1.74,1.74,0,0,0-1.49,1.72v17.38a1.74,1.74,0,0,0,2,1.72h0a1.73,1.73,0,0,0,1.49-1.71V1183.3A1.73,1.73,0,0,0,1147.64,1181.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-894",
  d: "M1154.94,1180.47h0a1.73,1.73,0,0,0-1.44,1.71v17.37a1.72,1.72,0,0,0,2,1.7h0a1.73,1.73,0,0,0,1.45-1.71v-17.37A1.73,1.73,0,0,0,1154.94,1180.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-895",
  d: "M1162.24,1179.1h0a1.72,1.72,0,0,0-1.38,1.69v17.35a1.73,1.73,0,0,0,2.09,1.69h0a1.72,1.72,0,0,0,1.37-1.69v-17.35A1.73,1.73,0,0,0,1162.24,1179.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-896",
  d: "M1169.52,1177.43h0a1.73,1.73,0,0,0-1.3,1.68v17.3a1.73,1.73,0,0,0,2.17,1.68h0a1.73,1.73,0,0,0,1.3-1.68v-17.3A1.73,1.73,0,0,0,1169.52,1177.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-897",
  d: "M1176.77,1175.35h0a1.73,1.73,0,0,0-1.2,1.65v17.24a1.72,1.72,0,0,0,2.28,1.64h0a1.73,1.73,0,0,0,1.18-1.64V1177A1.74,1.74,0,0,0,1176.77,1175.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-898",
  d: "M1184,1172.66l0,0a1.72,1.72,0,0,0-1,1.59v17.09a1.73,1.73,0,0,0,2.47,1.57l0,0a1.73,1.73,0,0,0,1-1.57v-17.09A1.73,1.73,0,0,0,1184,1172.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-g3-899",
  d: "M1191,1168.8l0,0a1.71,1.71,0,0,0-.71,1.4v16.42a1.73,1.73,0,0,0,2.94,1.24l0,0a1.75,1.75,0,0,0,.52-1.24V1170.2A1.73,1.73,0,0,0,1191,1168.8Z"
})));

var SvgG3 = function SvgG3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1210.91 1616.42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgG3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/g3.fed857ba.svg";
export { ForwardRef as ReactComponent };